import { __read as n, __makeTemplateObject as e, __rest as t, __assign as r, __spread as o, __awaiter as i, __generator as a } from "tslib";
import l, { useState as c, useCallback as d, useEffect as s, memo as h, useRef as p, useMemo as u, createRef as g, createContext as f, useContext as m } from "react";
import v, { keyframes as x, css as b } from "styled-components";
import { useSwipeable as C } from "react-swipeable";
import { isMobile as w } from "@inter/lib-util";
import k, { registerLocale as L } from "react-datepicker";
import y from "date-fns/locale/pt-BR";
import M from "react-input-mask";
import E, { createPortal as Z } from "react-dom";
import { useTable as V, useGlobalFilter as H, useSortBy as z } from "react-table";

var B,
    R,
    j,
    I,
    W,
    S,
    D,
    A,
    T,
    P,
    Y,
    _,
    F,
    N,
    O,
    X,
    G,
    J,
    U,
    K,
    q,
    $,
    Q,
    nn,
    en,
    tn,
    rn,
    on = function on(e) {
  var t = e.controlled,
      r = e.defaultState,
      o = n(c(r), 2),
      i = o[0],
      a = o[1],
      l = void 0 === t;
  return [l ? i : t, d(function (n) {
    l && a(n);
  }, [l])];
},
    an = function an(n, e) {
  var t = function t(_t2) {
    var r;
    (null === (r = null == n ? void 0 : n.current) || void 0 === r ? void 0 : r.contains(_t2.target)) || e();
  };

  s(function () {
    return document.addEventListener("click", t), function () {
      document.removeEventListener("click", t);
    };
  });
},
    ln = function ln() {
  var e = n(c(!1), 2),
      t = e[0],
      r = e[1];
  return s(function () {
    r(!0);
  }, []), t;
},
    cn = function cn() {
  return null;
},
    dn = {
  top: 0,
  left: 0,
  width: 0,
  height: 0
},
    sn = v.div(B || (B = e(["\n  padding: 20px 16px;\n  cursor: pointer;\n  color: var(--accordion-summary-color);\n"], ["\n  padding: 20px 16px;\n  cursor: pointer;\n  color: var(--accordion-summary-color);\n"]))),
    hn = v.div(R || (R = e(["\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height ease-in-out ", "ms;\n  color: var(--accordion-details-color);\n"], ["\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height ease-in-out ", "ms;\n  color: var(--accordion-details-color);\n"])), 300),
    pn = v.div(j || (j = e(["\n  padding: 20px 16px;\n  border-top: 1px solid var(--gray200);\n"], ["\n  padding: 20px 16px;\n  border-top: 1px solid var(--gray200);\n"]))),
    un = v.div(I || (I = e(["\n  background: var(--accordion-container-background-color);\n  border-radius: var(--accordion-container-border-radius);\n"], ["\n  background: var(--accordion-container-background-color);\n  border-radius: var(--accordion-container-border-radius);\n"]))),
    gn = h(function (e) {
  var o = e.children,
      i = e.expanded,
      a = e.defaultExpanded,
      c = e.onChange,
      h = t(e, ["children", "expanded", "defaultExpanded", "onChange"]),
      u = p(null),
      g = p(0),
      f = n(l.Children.toArray(o)),
      m = f[0],
      v = f.slice(1),
      x = n(on({
    controlled: i,
    defaultState: a
  }), 2),
      b = x[0],
      C = x[1],
      w = d(function (n) {
    clearTimeout(g.current), C(!b), null == c || c(n, !b);
  }, [b, C, c]),
      k = d(function (n, e, t) {
    var r = n.style;
    return r.maxHeight = n.scrollHeight + "px", setTimeout(function () {
      r.maxHeight = e;
    }, t);
  }, []);
  return s(function () {
    var n = u.current;
    b ? g.current = k(n, "inherit", 300) : "" !== n.style.maxHeight && (g.current = k(n, "0px", 50));
  }, [k, b]), l.createElement(un, r({}, h), l.createElement(sn, {
    onClick: w,
    role: "button"
  }, m), l.createElement(hn, {
    ref: u,
    role: "region"
  }, l.createElement(pn, null, v)));
}),
    fn = x(W || (W = e(["\n  0% {\n    background: transparent;\n  }\n\n  100% {\n    background: var(--bottom-sheet-overlay-background-color);\n  }\n"], ["\n  0% {\n    background: transparent;\n  }\n\n  100% {\n    background: var(--bottom-sheet-overlay-background-color);\n  }\n"]))),
    mn = v.div(S || (S = e(["\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  z-index: var(--bottom-sheet-overlay-z-index);\n  background: var(--bottom-sheet-overlay-background-color);\n  transition: all 0.5s ease 0s;\n  justify-content: center;\n  align-items: center;\n  animation: ", " ", "ms;\n"], ["\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  z-index: var(--bottom-sheet-overlay-z-index);\n  background: var(--bottom-sheet-overlay-background-color);\n  transition: all 0.5s ease 0s;\n  justify-content: center;\n  align-items: center;\n  animation: ", " ", "ms;\n"])), fn, 1e3),
    vn = x(D || (D = e(["\n  0% {\n    transform: scale(1) translateY(0px);\n    opacity: 1;\n  }\n\n  100% {\n    transform: scale(.8) translateY(1000px);\n    opacity: 0;\n  }\n"], ["\n  0% {\n    transform: scale(1) translateY(0px);\n    opacity: 1;\n  }\n\n  100% {\n    transform: scale(.8) translateY(1000px);\n    opacity: 0;\n  }\n"]))),
    xn = x(A || (A = e(["\n  0% {\n    transform: scale(.8) translateY(1000px);\n    opacity: 0;\n  }\n\n  100% {\n    transform: scale(1) translateY(0px);\n    opacity: 1;\n  }\n"], ["\n  0% {\n    transform: scale(.8) translateY(1000px);\n    opacity: 0;\n  }\n\n  100% {\n    transform: scale(1) translateY(0px);\n    opacity: 1;\n  }\n"]))),
    bn = v.div(P || (P = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.down,
      r = n.closeAnimation;
  return b(T || (T = e(["\n    display: flex;\n    flex-flow: column wrap;\n    background-color: var(--bottom-sheet-background-color);\n    position: fixed;\n    width: 100%;\n    border-top-left-radius: var(--radiiLg);\n    border-top-right-radius: var(--radiiLg);\n    bottom: ", ";\n    box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08);\n\n    animation: ", " ", "ms\n      cubic-bezier(0.165, 0.84, 0.44, 1) forwards;\n  "], ["\n    display: flex;\n    flex-flow: column wrap;\n    background-color: var(--bottom-sheet-background-color);\n    position: fixed;\n    width: 100%;\n    border-top-left-radius: var(--radiiLg);\n    border-top-right-radius: var(--radiiLg);\n    bottom: ", ";\n    box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08);\n\n    animation: ", " ", "ms\n      cubic-bezier(0.165, 0.84, 0.44, 1) forwards;\n  "])), t > 0 ? "-" + t + "px" : "0", r ? vn : xn, 1e3);
}),
    Cn = v.div(Y || (Y = e(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 28px;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 28px;\n"]))),
    wn = v.div(_ || (_ = e(["\n  background: var(--bottom-sheet-handler-background-color);\n  border-radius: var(--radiiMd);\n  width: 48px;\n  height: 4px;\n"], ["\n  background: var(--bottom-sheet-handler-background-color);\n  border-radius: var(--radiiMd);\n  width: 48px;\n  height: 4px;\n"]))),
    kn = v.div(F || (F = e(["\n  padding: 10px 24px;\n"], ["\n  padding: 10px 24px;\n"]))),
    Ln = function Ln(e) {
  var o = e.children,
      i = e.onClose,
      a = n(c(0), 2),
      s = a[0],
      h = a[1],
      p = n(c(!1), 2),
      u = p[0],
      g = p[1],
      f = d(function (n, e) {
    var t = n.dir,
        r = n.deltaY;

    if (void 0 === e && (e = !1), "Down" === t && (h(r), e)) {
      if (r > 100) return g(!0), void setTimeout(i, 1e3);
      h(0);
    }
  }, [i, h]),
      m = C({
    onSwiping: f,
    onSwiped: function onSwiped(n) {
      return f(n, !0);
    },
    preventDefaultTouchmoveEvent: !0,
    trackMouse: !w(),
    trackTouch: w(),
    delta: 10
  }),
      v = m.ref,
      x = t(m, ["ref"]);
  return l.createElement(mn, {
    "data-testid": "bottom-sheet-overlay",
    onClick: function onClick(n) {
      n.stopPropagation(), n.target === n.currentTarget && i();
    }
  }, l.createElement(bn, r({}, x, {
    ref: function ref(n) {
      n && v(n);
    },
    down: s,
    closeAnimation: u,
    "data-testid": "bottom-sheet-container"
  }), l.createElement(Cn, null, l.createElement(wn, null)), l.createElement(kn, null, o)));
},
    yn = x(N || (N = e(["\n  0% {\n    transform: translate(-50%, -50%) rotate(0deg);\n  }\n  100% {\n    transform: translate(-50%, -50%) rotate(360deg);\n  }\n"], ["\n  0% {\n    transform: translate(-50%, -50%) rotate(0deg);\n  }\n  100% {\n    transform: translate(-50%, -50%) rotate(360deg);\n  }\n"]))),
    Mn = {
  primary: function primary(n) {
    var t = n.isLoading;
    return b(G || (G = e(["\n    background: var(--button-background-color);\n    color: ", ";\n\n    :disabled {\n      background-color: var(--button-disabled-background-color);\n      color: ", ";\n    }\n\n    ", "\n  "], ["\n    background: var(--button-background-color);\n    color: ", ";\n\n    :disabled {\n      background-color: var(--button-disabled-background-color);\n      color: ", ";\n    }\n\n    ", "\n  "])), t ? "transparent" : "var(--button-text-color)", t ? "transparent" : "var(--button-disabled-text-color)", b(t ? O || (O = e(["\n          :after {\n            border-color: var(--button-loading-primary-color);\n            border-left-color: var(--button-loading-secondary-color);\n          }\n\n          &:disabled {\n            &:after {\n              border-color: var(--button-disabled-loading-primary-color);\n              border-left-color: var(--button-disabled-loading-secondary-color);\n            }\n          }\n        "], ["\n          :after {\n            border-color: var(--button-loading-primary-color);\n            border-left-color: var(--button-loading-secondary-color);\n          }\n\n          &:disabled {\n            &:after {\n              border-color: var(--button-disabled-loading-primary-color);\n              border-left-color: var(--button-disabled-loading-secondary-color);\n            }\n          }\n        "])) : X || (X = e(["\n          :hover:enabled {\n            background-color: var(--button-hover-background-color);\n          }\n\n          :active {\n            background-color: var(--button-active-background-color);\n          }\n        "], ["\n          :hover:enabled {\n            background-color: var(--button-hover-background-color);\n          }\n\n          :active {\n            background-color: var(--button-active-background-color);\n          }\n        "]))));
  },
  secondary: function secondary(n) {
    var t = n.isLoading;
    return b(K || (K = e(["\n    color: ", ";\n    border: 1px solid var(--button-secondary-border-color);\n\n    :disabled {\n      border-color: var(--button-disabled-background-color);\n      color: ", ";\n    }\n\n    ", "\n  "], ["\n    color: ", ";\n    border: 1px solid var(--button-secondary-border-color);\n\n    :disabled {\n      border-color: var(--button-disabled-background-color);\n      color: ", ";\n    }\n\n    ", "\n  "])), t ? "transparent" : "var(--button-secondary-text-color)", t ? "transparent" : "var(--button-disabled-text-color)", b(t ? J || (J = e(["\n          border-color: var(--button-background-color);\n\n          :after {\n            border-color: var(--button-background-color);\n            border-left-color: var(--button-secondary-border-color);\n          }\n\n          :disabled {\n            border-color: var(--button-disabled-text-color);\n\n            :after {\n              border-color: var(--button-disabled-text-color);\n              border-left-color: var(--button-disabled-background-color);\n            }\n          }\n        "], ["\n          border-color: var(--button-background-color);\n\n          :after {\n            border-color: var(--button-background-color);\n            border-left-color: var(--button-secondary-border-color);\n          }\n\n          :disabled {\n            border-color: var(--button-disabled-text-color);\n\n            :after {\n              border-color: var(--button-disabled-text-color);\n              border-left-color: var(--button-disabled-background-color);\n            }\n          }\n        "])) : U || (U = e(["\n          :hover:enabled {\n            border-color: var(--button-background-color);\n          }\n\n          :active {\n            background: var(--button-background-color);\n            color: var(--button-text-color);\n          }\n        "], ["\n          :hover:enabled {\n            border-color: var(--button-background-color);\n          }\n\n          :active {\n            background: var(--button-background-color);\n            color: var(--button-text-color);\n          }\n        "]))));
  },
  link: function link(n) {
    var t = n.isLoading;
    return b(Q || (Q = e(["\n    background: none;\n    color: ", ";\n\n    :disabled {\n      border-color: var(--button-disabled-background-color);\n      color: ", ";\n    }\n\n    ", "\n  "], ["\n    background: none;\n    color: ", ";\n\n    :disabled {\n      border-color: var(--button-disabled-background-color);\n      color: ", ";\n    }\n\n    ", "\n  "])), t ? "transparent" : "var(--button-link-text-color)", t ? "transparent" : "var(--button-disabled-text-color)", b(t ? q || (q = e(["\n          border-color: var(--button-background-color);\n\n          :after {\n            border-color: var(--button-background-color);\n            border-left-color: var(--button-disabled-background-color);\n          }\n\n          :disabled {\n            border-color: var(--button-disabled-text-color);\n\n            :after {\n              border-color: var(--button-disabled-text-color);\n              border-left-color: var(--button-disabled-background-color);\n            }\n          }\n        "], ["\n          border-color: var(--button-background-color);\n\n          :after {\n            border-color: var(--button-background-color);\n            border-left-color: var(--button-disabled-background-color);\n          }\n\n          :disabled {\n            border-color: var(--button-disabled-text-color);\n\n            :after {\n              border-color: var(--button-disabled-text-color);\n              border-left-color: var(--button-disabled-background-color);\n            }\n          }\n        "])) : $ || ($ = e(["\n          :hover:enabled {\n            background-color: var(--button-link-hover-background-color);\n          }\n\n          :active {\n            background: var(--button-background-color);\n            color: var(--button-text-color);\n          }\n        "], ["\n          :hover:enabled {\n            background-color: var(--button-link-hover-background-color);\n          }\n\n          :active {\n            background: var(--button-background-color);\n            color: var(--button-text-color);\n          }\n        "]))));
  },
  withIcon: function withIcon() {
    return b(nn || (nn = e(["\n    justify-content: space-between;\n\n    span + * {\n      margin-left: 12px;\n    }\n\n    svg {\n      height: 18px;\n    }\n  "], ["\n    justify-content: space-between;\n\n    span + * {\n      margin-left: 12px;\n    }\n\n    svg {\n      height: 18px;\n    }\n  "])));
  },
  loading: function loading() {
    return b(en || (en = e(["\n    position: relative;\n    outline: none;\n    cursor: progress;\n\n    :after {\n      content: '';\n      border-radius: 50%;\n      width: 18px;\n      height: 18px;\n      z-index: 1;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      font-size: var(--button-loading-font-size);\n      border-style: solid;\n      border-width: 2px;\n      animation: ", " 1.1s infinite linear;\n    }\n  "], ["\n    position: relative;\n    outline: none;\n    cursor: progress;\n\n    :after {\n      content: '';\n      border-radius: 50%;\n      width: 18px;\n      height: 18px;\n      z-index: 1;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      font-size: var(--button-loading-font-size);\n      border-style: solid;\n      border-width: 2px;\n      animation: ", " 1.1s infinite linear;\n    }\n  "])), yn);
  }
},
    En = v.button(rn || (rn = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.variant,
      r = n.fixedWidth,
      o = n.isLoading,
      i = n.hasIcon;
  return b(tn || (tn = e(["\n    background: none;\n    border-radius: var(--button-border-radius);\n    width: ", ";\n    max-height: 40px;\n    padding: 12px 16px;\n    cursor: pointer;\n    transition: 180ms ease-in-out;\n    font-size: var(--button-font-size);\n    font-family: Inter;\n    text-decoration: none;\n\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n\n    :disabled {\n      cursor: not-allowed;\n    }\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    background: none;\n    border-radius: var(--button-border-radius);\n    width: ", ";\n    max-height: 40px;\n    padding: 12px 16px;\n    cursor: pointer;\n    transition: 180ms ease-in-out;\n    font-size: var(--button-font-size);\n    font-family: Inter;\n    text-decoration: none;\n\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n\n    :disabled {\n      cursor: not-allowed;\n    }\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), r ? "200px" : "auto", !!t && Mn[t]({
    isLoading: o
  }), !!i && Mn.withIcon(), o && Mn.loading());
}),
    Zn = function Zn(n) {
  var e = n.onClick,
      o = n.isLoading,
      i = n.children,
      a = n.icon,
      c = t(n, ["onClick", "isLoading", "children", "icon"]),
      d = o ? cn : e;
  return "a" === c.as && delete c.type, l.createElement(En, r({
    onClick: d,
    isLoading: o,
    hasIcon: !!a
  }, c), a ? l.createElement(l.Fragment, null, l.createElement("span", null, i), a) : i);
};

Zn.defaultProps = {
  type: "button",
  variant: "primary",
  className: "",
  fixedWidth: !1,
  isLoading: !1
};

var Vn = h(Zn),
    Hn = function Hn(n) {
  var e = n.width,
      o = n.height,
      i = n.color,
      a = t(n, ["width", "height", "color"]);
  return l.createElement("svg", r({
    width: e,
    height: o,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, a), l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.05599 11.47L3.29299 5.70702C2.90247 5.3165 2.90247 4.68333 3.29299 4.29281C3.68351 3.90228 4.31668 3.90228 4.7072 4.29281L10.4702 10.0558C10.8607 10.4463 10.8607 11.0795 10.4702 11.47C10.0797 11.8605 9.44651 11.8605 9.05599 11.47ZM15.293 17.707L11.8202 14.2342C11.4297 13.8437 11.4297 13.2106 11.8202 12.82C12.2107 12.4295 12.8439 12.4295 13.2344 12.82L16.7072 16.2928C17.0977 16.6833 17.0977 17.3165 16.7072 17.707C16.3167 18.0975 15.6835 18.0975 15.293 17.707Z",
    fill: i
  }), l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77314 11.7529L3.01015 5.98986C2.46341 5.44313 2.46341 4.5567 3.01015 4.00996C3.55688 3.46323 4.44331 3.46323 4.99005 4.00996L10.753 9.77296C11.2998 10.3197 11.2998 11.2061 10.753 11.7529C10.2063 12.2996 9.31988 12.2996 8.77314 11.7529ZM15.0101 17.9899L11.5374 14.5171C10.9906 13.9704 10.9906 13.0839 11.5374 12.5372C12.0841 11.9904 12.9705 11.9904 13.5173 12.5372L16.99 16.01C17.5368 16.5567 17.5368 17.4431 16.99 17.9899C16.4433 18.5366 15.5569 18.5366 15.0101 17.9899ZM3.29299 5.70702L9.05599 11.47C9.44651 11.8605 10.0797 11.8605 10.4702 11.47C10.8607 11.0795 10.8607 10.4463 10.4702 10.0558L4.7072 4.29281C4.31668 3.90228 3.68351 3.90228 3.29299 4.29281C2.90247 4.68333 2.90247 5.3165 3.29299 5.70702ZM11.8202 14.2342L15.293 17.707C15.6835 18.0975 16.3167 18.0975 16.7072 17.707C17.0977 17.3165 17.0977 16.6833 16.7072 16.2928L13.2344 12.82C12.8439 12.4295 12.2107 12.4295 11.8202 12.82C11.4297 13.2106 11.4297 13.8437 11.8202 14.2342Z",
    fill: i
  }), l.createElement("path", {
    d: "M4.7072 17.707L16.7072 5.70702C17.0977 5.3165 17.0977 4.68333 16.7072 4.29281C16.3167 3.90228 15.6835 3.90228 15.293 4.29281L3.29299 16.2928C2.90247 16.6833 2.90247 17.3165 3.29299 17.707C3.68351 18.0975 4.31668 18.0975 4.7072 17.707Z",
    fill: i
  }), l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.99 5.98986L4.99004 17.9899C4.44331 18.5366 3.55688 18.5366 3.01015 17.9899C2.46341 17.4431 2.46341 16.5567 3.01015 16.01L15.0101 4.00996C15.5569 3.46323 16.4433 3.46323 16.99 4.00996C17.5368 4.5567 17.5368 5.44313 16.99 5.98986ZM16.7072 5.70702L4.7072 17.707C4.31668 18.0975 3.68351 18.0975 3.29299 17.707C2.90247 17.3165 2.90247 16.6833 3.29299 16.2928L15.293 4.29281C15.6835 3.90228 16.3167 3.90228 16.7072 4.29281C17.0977 4.68333 17.0977 5.3165 16.7072 5.70702Z",
    fill: i
  }));
};

Hn.defaultProps = {
  width: 20,
  height: 21,
  color: "#8C91A9"
};

var zn,
    Bn,
    Rn,
    jn,
    In,
    Wn,
    Sn,
    Dn,
    An,
    Tn,
    Pn,
    Yn,
    _n,
    Fn,
    Nn,
    On,
    Xn,
    Gn,
    Jn,
    Un,
    Kn,
    qn = x(zn || (zn = e(["\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n"], ["\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n"]))),
    $n = v.svg(Bn || (Bn = e(["\n  animation: ", " 2s linear infinite;\n"], ["\n  animation: ", " 2s linear infinite;\n"])), qn),
    Qn = v.circle(Rn || (Rn = e(["\n  opacity: 0.35;\n"], ["\n  opacity: 0.35;\n"]))),
    ne = {
  "info-outline": function infoOutline(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), l.createElement("path", {
      d: "M12 8L12 7M12 17V12",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  download: function download(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M12 3V15M12 15L16 11M12 15L8 11M3 13V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V13",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  "payment-notification": function paymentNotification(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9V7ZM23 8H24C24 7.44772 23.5523 7 23 7V8ZM23 20V21C23.5523 21 24 20.5523 24 20H23ZM16 19C15.4477 19 15 19.4477 15 20C15 20.5523 15.4477 21 16 21V19ZM5 2L5.17379 1.01522C4.88267 0.963843 4.58373 1.04391 4.35727 1.23391C4.1308 1.42391 4 1.70438 4 2H5ZM12 18.5L12.6 19.3C12.8518 19.1111 13 18.8148 13 18.5H12ZM6 20H5C5 20.5523 5.44772 21 6 21V20ZM5 14H4C4 14.4589 4.3123 14.8589 4.75746 14.9701L5 14ZM1 4V3C0.447715 3 0 3.44772 0 4H1ZM1 17H0C0 17.5523 0.447715 18 1 18L1 17ZM16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13V11ZM19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11V13ZM16 15C15.4477 15 15 15.4477 15 16C15 16.5523 15.4477 17 16 17V15ZM19 17C19.5523 17 20 16.5523 20 16C20 15.4477 19.5523 15 19 15V17ZM12 9H23V7H12V9ZM22 8V20H24V8H22ZM23 19H16V21H23V19ZM4.82621 2.98478C6.10123 3.20979 7.74324 3.85929 9.07113 4.60845C9.73236 4.9815 10.2738 5.35599 10.635 5.68169C10.8163 5.84524 10.9263 5.97338 10.9841 6.05985C11.0497 6.15806 11 6.12919 11 6H13C13 5.57081 12.8201 5.20757 12.6468 4.94835C12.4657 4.6774 12.2279 4.42507 11.9744 4.19643C11.4658 3.73776 10.7885 3.281 10.0539 2.86655C8.59009 2.04071 6.7321 1.29021 5.17379 1.01522L4.82621 2.98478ZM11 6V18.5H13V6H11ZM11.4 17.7C10.932 18.051 9.01788 19 6 19V21C9.38212 21 11.7347 19.949 12.6 19.3L11.4 17.7ZM7 20V17H5V20H7ZM4 2V4H6V2H4ZM4 4V14H6V4H4ZM5 3H1V5H5V3ZM0 4V17H2V4H0ZM4.75746 14.9701C6.62229 15.4363 8.43481 16.3585 9.68378 17.6854L11.1401 16.3146C9.56519 14.6415 7.37771 13.5637 5.24254 13.0299L4.75746 14.9701ZM9.86619 17.8379C10.434 18.2077 10.8752 18.6156 11.1679 19.0547L12.8321 17.9453C12.3471 17.2178 11.6798 16.6324 10.9577 16.1621L9.86619 17.8379ZM1 18H6V16H1V18ZM6 18H10.4119V16H6V18ZM16 13H19V11H16V13ZM16 17H19V15H16V17Z",
      fill: i
    }));
  },
  upload: function upload(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M12 15L12 3M12 3L8 7M12 3L16 7",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), l.createElement("path", {
      d: "M4 7C4 6.44771 3.55228 6 3 6C2.44771 6 2 6.44771 2 7L4 7ZM22 7C22 6.44771 21.5523 6 21 6C20.4477 6 20 6.44771 20 7L22 7ZM2 7L2 19L4 19L4 7L2 7ZM5 22L19 22L19 20L5 20L5 22ZM22 19L22 7L20 7L20 19L22 19ZM19 22C20.6569 22 22 20.6569 22 19L20 19C20 19.5523 19.5523 20 19 20L19 22ZM2 19C2 20.6569 3.34315 22 5 22L5 20C4.44772 20 4 19.5523 4 19L2 19Z",
      fill: i
    }));
  },
  processing: function processing(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "11",
      fill: "white",
      stroke: "white",
      strokeWidth: "2"
    }), l.createElement("circle", {
      cx: "12",
      cy: "12.0006",
      r: "9.28571",
      fill: "white",
      stroke: i,
      strokeWidth: "2"
    }), l.createElement("ellipse", {
      cx: "16.2857",
      cy: "12.0006",
      rx: "0.535714",
      ry: "0.535714",
      transform: "rotate(90 16.2857 12.0006)",
      stroke: i
    }), l.createElement("ellipse", {
      cx: "7.71429",
      cy: "12.0006",
      rx: "0.535714",
      ry: "0.535714",
      transform: "rotate(90 7.71429 12.0006)",
      stroke: i
    }), l.createElement("circle", {
      cx: "12.0001",
      cy: "12.0006",
      r: "0.535714",
      transform: "rotate(90 12.0001 12.0006)",
      stroke: i
    }));
  },
  home: function home(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M21 20.9998V11.7961C21 10.6535 20.5114 9.5655 19.6575 8.80643L13.9931 3.77144C12.8564 2.76108 11.1436 2.76108 10.0069 3.77144L4.34254 8.80643C3.48859 9.5655 3 10.6535 3 11.7961V20.9998",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), l.createElement("path", {
      d: "M15 13H10C9.44772 13 9 13.4477 9 14V21",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  "dollar-sign": function dollarSign(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
      fill: i
    }), l.createElement("path", {
      d: "M10.9397 5.84034C10.9397 5.37623 10.5612 5 10.0942 5C9.6273 5 9.24876 5.37623 9.24876 5.84034V6.12073C8.21975 6.20192 7.33058 6.91153 7.07252 7.92212L7.07203 7.92407C6.79631 9.01471 7.3328 10.1142 8.32812 10.6117L8.33136 10.6133C8.66685 10.7792 9.04839 10.8751 9.43946 10.8751H10.593C11.0084 10.8751 11.309 11.1974 11.309 11.5442C11.309 11.8935 11.013 12.2133 10.593 12.2133H10.0998L10.0942 12.2133L10.0887 12.2133H8.21557C7.74863 12.2133 7.3701 12.5896 7.3701 13.0537C7.3701 13.5178 7.74863 13.894 8.21557 13.894H9.24876V14.1597C9.24876 14.6238 9.6273 15 10.0942 15C10.5612 15 10.9397 14.6238 10.9397 14.1597V13.8697C12.0912 13.707 13 12.746 13 11.5442C13 10.2217 11.8938 9.19445 10.593 9.19445H9.43946C9.32464 9.19445 9.20038 9.16549 9.08616 9.10932C8.77465 8.95278 8.63646 8.63436 8.71176 8.33461C8.78936 8.03259 9.08097 7.79363 9.44649 7.79363H10.091C10.0921 7.79363 10.0931 7.79363 10.0942 7.79363C10.0953 7.79363 10.0964 7.79363 10.0975 7.79363H11.8239C12.2909 7.79363 12.6694 7.41739 12.6694 6.95329C12.6694 6.48918 12.2909 6.11295 11.8239 6.11295H10.9397V5.84034Z",
      fill: i
    }));
  },
  transactions: function transactions(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.93139 17.8352L5.93139 7.00468L2.84018 10.4114C2.42063 10.8738 1.72782 10.8738 1.30827 10.4114C0.897242 9.95844 0.897242 9.23247 1.30827 8.77948L6.23779 3.34678C6.65733 2.88441 7.34267 2.88441 7.76221 3.34678L12.6917 8.77948C13.1028 9.23247 13.1028 9.95844 12.6917 10.4114C12.2722 10.8738 11.5868 10.8738 11.1673 10.4114L8.07609 7.00468V17.8352C8.07609 18.4608 7.60899 19 7.00374 19C6.39849 19 5.93139 18.4608 5.93139 17.8352Z",
      fill: i
    }), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.9314 6.01921L15.9314 17.4959L12.8402 14.515C12.4206 14.1104 11.7278 14.1104 11.3083 14.515C10.8972 14.9114 10.8972 15.5466 11.3083 15.943L16.2378 20.6966C16.6573 21.1011 17.3427 21.1011 17.7622 20.6966L22.6917 15.943C23.1028 15.5466 23.1028 14.9114 22.6917 14.515C22.2722 14.1104 21.5868 14.1104 21.1673 14.515L18.0761 17.4959V6.01921C18.0761 5.47181 17.609 5 17.0037 5C16.3985 5 15.9314 5.47181 15.9314 6.01921Z",
      fill: i
    }));
  },
  "question-mark": function questionMark(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "10",
      stroke: i,
      strokeWidth: "2"
    }), l.createElement("path", {
      d: "M10 9.5V9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9V9.88197C14 10.5672 13.6129 11.1936 13 11.5C12.3871 11.8064 12 12.4328 12 13.118V13.5M12 16.5V17",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  agenda: function agenda(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M7 4.5H5C3.89543 4.5 3 5.39543 3 6.5V11.5M7 4.5H17M7 4.5V3.5M7 4.5V6.5M17 4.5H19C20.1046 4.5 21 5.39543 21 6.5V11.5M17 4.5V3.5M17 4.5V6.5M3 11.5V19.5C3 20.6046 3.89543 21.5 5 21.5H19C20.1046 21.5 21 20.6046 21 19.5V11.5M3 11.5H21",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round"
    }));
  },
  "settings-bars": function settingsBars(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M21 6C21.5523 6 22 5.55229 22 5C22 4.44772 21.5523 4 21 4V6ZM14 4C13.4477 4 13 4.44771 13 5C13 5.55228 13.4477 6 14 6V4ZM3 4C2.44772 4 2 4.44771 2 5C2 5.55228 2.44772 6 3 6L3 4ZM3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13L3 11ZM10 13C10.5523 13 11 12.5523 11 12C11 11.4477 10.5523 11 10 11V13ZM21 13C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11V13ZM21 20C21.5523 20 22 19.5523 22 19C22 18.4477 21.5523 18 21 18V20ZM14 18C13.4477 18 13 18.4477 13 19C13 19.5523 13.4477 20 14 20V18ZM3 18C2.44772 18 2 18.4477 2 19C2 19.5523 2.44771 20 3 20L3 18ZM21 4L14 4V6L21 6V4ZM6 4L3 4L3 6L6 6L6 4ZM7 5C7 4.44772 7.44772 4 8 4V2C6.34315 2 5 3.34315 5 5L7 5ZM8 4C8.55228 4 9 4.44772 9 5H11C11 3.34315 9.65686 2 8 2V4ZM9 5C9 5.55228 8.55228 6 8 6V8C9.65685 8 11 6.65685 11 5H9ZM8 6C7.44772 6 7 5.55228 7 5L5 5C5 6.65685 6.34315 8 8 8V6ZM3 13L10 13V11L3 11L3 13ZM18 13L21 13V11L18 11V13ZM17 12C17 12.5523 16.5523 13 16 13V15C17.6569 15 19 13.6569 19 12H17ZM16 13C15.4477 13 15 12.5523 15 12H13C13 13.6569 14.3431 15 16 15V13ZM15 12C15 11.4477 15.4477 11 16 11V9C14.3431 9 13 10.3431 13 12H15ZM16 11C16.5523 11 17 11.4477 17 12H19C19 10.3431 17.6569 9 16 9V11ZM21 18L14 18V20L21 20V18ZM6 18L3 18L3 20L6 20L6 18ZM7 19C7 18.4477 7.44772 18 8 18V16C6.34315 16 5 17.3431 5 19H7ZM8 18C8.55229 18 9 18.4477 9 19H11C11 17.3431 9.65686 16 8 16V18ZM9 19C9 19.5523 8.55228 20 8 20V22C9.65685 22 11 20.6569 11 19H9ZM8 20C7.44772 20 7 19.5523 7 19H5C5 20.6569 6.34315 22 8 22V20Z",
      fill: i
    }));
  },
  "transfer-money": function transferMoney(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M14 9.5C14 9.5 13 9 12 9M12 9C11 9 10 9.5 10 10.5C10 11.5 11 12 12 12C13 12 14 12.5 14 13.5C14 14.5 13 15 12 15M12 9V8M12 15C11.2 15 10 14.5 10 14.5M12 15V16",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), l.createElement("path", {
      d: "M20.0022 4H11.0022C4.87041 4 1.58636 7.55967 3.58459 13M20.0022 4L17.0022 1M20.0022 4L17.0022 7M3.99776 20H12.9978C19.1296 20 22.4136 16.4403 20.4154 11M3.99776 20L6.99774 23M3.99776 20L6.99774 17",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  "no-taxes": function noTaxes(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M16 21.1679C14.7751 21.7031 13.4222 22 12 22C6.47715 22 2 17.5228 2 12C2 10.4354 2.35934 8.95464 3 7.63587M19.0764 19.0658C20.8829 17.2566 22 14.7587 22 12C22 6.47715 17.5228 2 12 2C9.25943 2 6.77636 3.10244 4.97006 4.88804",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), l.createElement("path", {
      d: "M14 9.5C14 9.5 13 9 12 9M12 9C11 9 10 9.5 10 10.5C10 11.5 11 12 12 12C13 12 14 12.5 14 13.5C14 14.5 13 15 12 15M12 9V8M12 15C11.2 15 10 14.5 10 14.5M12 15V16",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), l.createElement("path", {
      d: "M2 2L22 22",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round"
    }));
  },
  credit: function credit(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M15 16L19.2335 14.6974C20.4464 14.3242 21.7162 15.0809 21.9651 16.3253C22.161 17.3052 21.655 18.2916 20.7376 18.6878C17.5048 20.0837 12.6954 22 11 22C9 22 4.16667 20.6667 2 20M15 16C15 17.1046 14.1046 18 13 18H8M15 16C15 14.8954 14.1046 14 13 14H10C8.5 12.5 7.50016 12 5.5 12C3.49984 12 2 14 2 14",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), l.createElement("path", {
      d: "M14 3.5C14 3.5 13 3 12 3M12 3C11 3 10 3.5 10 4.5C10 5.5 11 6 12 6C13 6 14 6.5 14 7.5C14 8.5 13 9 12 9M12 3V2M12 9C11.2 9 10 8.5 10 8.5M12 9V10",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  "i-safe": function iSafe(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 48 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M24.0004 46L23.1574 45.6769C1.03029 37.1963 4.1328 12.9371 4.16663 12.6929L4.3142 11.6353C4.3142 11.6353 16 8 24.0004 2C32 8 43.6858 11.6353 43.6858 11.6353L43.8334 12.6929C43.8672 12.9371 46.9697 37.1963 24.8433 45.6769L24.0004 46Z",
      fill: i,
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), l.createElement("path", {
      d: "M19.9996 22.0001L19.9998 17.9998C19.9999 15.7907 21.7907 14 23.9998 14C26.209 14 27.9999 15.791 27.9998 18.0002L27.9996 22.0001M18 32.0001H30C31.1046 32.0001 32 31.1047 32 30.0001V24.0001C32 22.8955 31.1046 22.0001 30 22.0001H18C16.8954 22.0001 16 22.8955 16 24.0001V30.0001C16 31.1047 16.8954 32.0001 18 32.0001Z",
      stroke: "white",
      strokeWidth: "2",
      strokeLinejoin: "round"
    }));
  },
  phone: function phone(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M18.0064 21.8748C19.319 21.4962 20.9602 19.6082 21.8182 18.5216C22.1426 18.1108 22.0172 17.5197 21.5667 17.2529L17.2441 14.6926C16.8583 14.4641 16.3631 14.5554 16.0843 14.9065L14.8787 16.4247C14.4539 16.9596 13.7133 17.1172 13.1312 16.7598C12.1442 16.1539 10.7678 15.2239 9.61789 14.249C8.31112 13.141 7.4054 11.5103 7.00308 10.4114C6.83788 9.96021 7.0012 9.47457 7.34956 9.14362L8.85916 7.70949C9.22409 7.36279 9.30009 6.8095 9.04213 6.37725L6.73695 2.51451C6.42401 1.99013 5.74071 1.83324 5.2523 2.1998C4.13312 3.03976 2.34961 4.54954 2.08178 5.81565C1.58834 8.14826 3.3378 13.3069 7.06102 16.8507C10.7842 20.3945 15.6738 22.5477 18.0064 21.8748Z",
      stroke: i,
      strokeWidth: "2"
    }));
  },
  email: function email(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M2.57346 6.18077C2.12101 5.86405 1.49748 5.97409 1.18077 6.42654C0.864054 6.87899 0.974088 7.50252 1.42654 7.81923L2.57346 6.18077ZM12 14L11.4265 14.8192C11.7709 15.0603 12.2291 15.0603 12.5735 14.8192L12 14ZM22.5735 7.81923C23.0259 7.50252 23.1359 6.87899 22.8192 6.42654C22.5025 5.97409 21.879 5.86405 21.4265 6.18077L22.5735 7.81923ZM4 5H20V3H4V5ZM21 6V18H23V6H21ZM20 19H4V21H20V19ZM3 18V6H1V18H3ZM4 19C3.44772 19 3 18.5523 3 18H1C1 19.6569 2.34315 21 4 21V19ZM21 18C21 18.5523 20.5523 19 20 19V21C21.6569 21 23 19.6569 23 18H21ZM20 5C20.5523 5 21 5.44772 21 6H23C23 4.34315 21.6569 3 20 3V5ZM4 3C2.34315 3 1 4.34315 1 6H3C3 5.44772 3.44772 5 4 5V3ZM1.42654 7.81923L11.4265 14.8192L12.5735 13.1808L2.57346 6.18077L1.42654 7.81923ZM12.5735 14.8192L22.5735 7.81923L21.4265 6.18077L11.4265 13.1808L12.5735 14.8192Z",
      fill: i
    }));
  },
  whatsapp: function whatsapp(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M11.9998 22C17.5227 22 21.9998 17.5228 21.9998 12C21.9998 6.47715 17.5227 2 11.9998 2C6.47696 2 1.99981 6.47715 1.99981 12C1.99981 13.8214 2.48678 15.5291 3.33763 17L1.99951 22L6.99951 20.662C8.47045 21.513 10.1783 22 11.9998 22Z",
      stroke: i,
      strokeWidth: "2",
      strokeLinejoin: "round"
    }), l.createElement("path", {
      d: "M16.7487 15.7268C16.568 15.9363 16.3656 16.1565 16.1567 16.3572C15.7606 16.738 15.468 16.9233 15.3267 16.9641C15.1864 17.0045 14.9153 17.023 14.4905 16.9412C14.0788 16.862 13.587 16.7008 13.0459 16.4556C11.9629 15.9647 10.764 15.174 9.72605 14.1861C8.72268 13.2311 7.97594 12.0469 7.51755 10.9437C7.04099 9.79678 6.94174 8.90135 7.02742 8.49635C7.04508 8.41286 7.17278 8.17094 7.52771 7.80372C7.73684 7.58735 7.97562 7.37699 8.20418 7.19103L9.22148 8.89569L8.52098 9.56118C8.08661 9.97384 7.7988 10.6696 8.06281 11.3907C8.34483 12.1609 8.97148 13.3045 9.92405 14.1121C10.6656 14.7408 11.537 15.3284 12.1556 15.7081C12.9673 16.2064 13.9644 15.9642 14.5103 15.2767L14.9833 14.6811L16.7487 15.7268ZM17.23 16.0119L17.2304 16.0121L17.23 16.0119Z",
      fill: i,
      stroke: i,
      strokeWidth: "2"
    }));
  },
  car: function car(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 41 41",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M1.3335 35.6663V28.2639C1.3335 27.0163 1.77092 25.8081 2.56965 24.8496L4.66683 22.333L6.26908 16.9922C6.51845 16.1609 7.15535 15.5025 7.99493 15.2829C9.50084 14.889 12.6668 14.333 16.0002 14.333C19.3335 14.333 22.4995 14.889 24.0054 15.2829C24.845 15.5025 25.4819 16.1609 25.7312 16.9922L27.3335 22.333L29.4307 24.8496C30.2294 25.8081 30.6668 27.0163 30.6668 28.2639V35.6663",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), l.createElement("path", {
      d: "M6.6665 35.667V35.0003C6.6665 34.2639 7.26346 33.667 7.99984 33.667H23.9998C24.7362 33.667 25.3332 34.2639 25.3332 35.0003V35.667",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), l.createElement("path", {
      d: "M1.3335 22.333C1.3335 22.333 9.3335 22.9997 16.0002 22.9997C22.6668 22.9997 30.6668 22.333 30.6668 22.333",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), l.createElement("path", {
      d: "M6.6665 29H7.99984M23.9998 29H25.3332",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), l.createElement("path", {
      d: "M40.0008 11.6668C40.0008 10.266 39.7249 8.87896 39.1888 7.5848C38.6528 6.29065 37.8671 5.11474 36.8766 4.12424C35.8861 3.13373 34.7102 2.34802 33.416 1.81196C32.1218 1.27591 30.7348 1 29.334 1",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), l.createElement("path", {
      d: "M34.6674 11.6664C34.6674 10.966 34.5294 10.2725 34.2614 9.62541C33.9934 8.97833 33.6005 8.39038 33.1053 7.89513C32.61 7.39987 32.0221 7.00702 31.375 6.73899C30.7279 6.47096 30.0344 6.33301 29.334 6.33301",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), l.createElement("ellipse", {
      cx: "29.3334",
      cy: "11.6673",
      rx: "1.33335",
      ry: "1.33335",
      fill: i
    }));
  },
  education: function education(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M38.3332 15L19.9998 25L1.6665 15L19.9998 5L38.3332 15ZM38.3332 15V28.3333M9.99984 20.2381V28.3333C9.99984 28.3333 11.6665 33.3333 19.9998 33.3333C28.3332 33.3333 29.9998 28.3333 29.9998 28.3333V20",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  outbound: function outbound(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M10 33.333H30",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.0378 17.2798L8.2584 10.3488C7.61735 9.64944 7.61735 8.51561 8.2584 7.81628C8.38316 7.68018 8.52721 7.56692 8.68502 7.48084L9.74696 6.9016C10.3561 6.56932 11.0773 6.59115 11.6686 6.95979L23.521 13.5857C23.6136 13.6374 23.722 13.6438 23.8192 13.6033C30.9983 10.6062 34.5984 9.10326 34.6194 9.09436C36.0047 8.50822 37.5768 9.22096 38.1309 10.6863C38.707 12.21 38.0106 13.9398 36.5729 14.5562L8.73834 26.4887C7.95521 26.8438 7.04663 26.6587 6.44416 26.0213L2.2768 21.6129C1.46307 20.7521 1.46307 19.3564 2.2768 18.4956C3.09053 17.6348 3.98465 17.6348 5.22357 18.4956L7.47606 20.0999C8.40242 20.7597 9.57021 20.8692 10.5862 20.3915L14.9555 17.927C15.1354 17.8256 15.2058 17.5842 15.1128 17.388C15.0936 17.3476 15.0683 17.311 15.0378 17.2798Z",
      stroke: i,
      strokeWidth: "2",
      strokeLinejoin: "round"
    }));
  },
  "shell-box": function shellBox(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M38.8633 10.848C39.3317 10.5553 39.474 9.93834 39.1813 9.47C38.8886 9.00166 38.2717 8.85929 37.8033 9.152L38.8633 10.848ZM37.8033 9.152L32.7033 12.3395L33.7633 14.0355L38.8633 10.848L37.8033 9.152ZM30.6667 16.0142V26.6667H32.6667V16.0142H30.6667ZM32.7033 12.3395C31.4364 13.1314 30.6667 14.5201 30.6667 16.0142H32.6667C32.6667 15.2096 33.0811 14.4619 33.7633 14.0355L32.7033 12.3395ZM30.6667 15.8333C30.6667 17.7663 32.2337 19.3333 34.1667 19.3333V17.3333C33.3382 17.3333 32.6667 16.6618 32.6667 15.8333H30.6667ZM34.1667 19.3333C36.0997 19.3333 37.6667 17.7663 37.6667 15.8333H35.6667C35.6667 16.6618 34.9951 17.3333 34.1667 17.3333V19.3333ZM37.6667 15.8333C37.6667 13.9003 36.0997 12.3333 34.1667 12.3333V14.3333C34.9951 14.3333 35.6667 15.0049 35.6667 15.8333H37.6667ZM34.1667 12.3333C32.2337 12.3333 30.6667 13.9003 30.6667 15.8333H32.6667C32.6667 15.0049 33.3382 14.3333 34.1667 14.3333V12.3333ZM26 26.6667V25H24V26.6667H26ZM28.3333 29C27.0447 29 26 27.9553 26 26.6667H24C24 29.0599 25.9401 31 28.3333 31V29ZM30.6667 26.6667C30.6667 27.9553 29.622 29 28.3333 29V31C30.7266 31 32.6667 29.0599 32.6667 26.6667H30.6667Z",
      fill: i
    }), l.createElement("path", {
      d: "M24.9998 16.6667V8.33333C24.9998 6.49238 23.5075 5 21.6665 5H9.99984C8.15889 5 6.6665 6.49238 6.6665 8.33333V35M24.9998 16.6667H6.6665M24.9998 16.6667V35",
      stroke: i,
      strokeWidth: "2"
    }), l.createElement("path", {
      d: "M3.3335 34.0003C2.78121 34.0003 2.3335 34.448 2.3335 35.0003C2.3335 35.5526 2.78121 36.0003 3.3335 36.0003V34.0003ZM36.6668 36.0003C37.2191 36.0003 37.6668 35.5526 37.6668 35.0003C37.6668 34.448 37.2191 34.0003 36.6668 34.0003V36.0003ZM15.8335 21.667L16.6621 21.1072C16.4762 20.832 16.1657 20.667 15.8335 20.667C15.5013 20.667 15.1908 20.832 15.0048 21.1072L15.8335 21.667ZM13.7169 24.8003L12.8882 24.2406V24.2406L13.7169 24.8003ZM17.9501 24.8003L17.1215 25.3601V25.3601L17.9501 24.8003ZM3.3335 36.0003H36.6668V34.0003H3.3335V36.0003ZM15.0048 21.1072L12.8882 24.2406L14.5455 25.3601L16.6621 22.2268L15.0048 21.1072ZM18.7788 24.2406L16.6621 21.1072L15.0048 22.2268L17.1215 25.3601L18.7788 24.2406ZM15.8335 29.3337C18.4475 29.3337 20.347 26.5621 18.7788 24.2406L17.1215 25.3601C17.6313 26.1148 17.1404 27.3337 15.8335 27.3337V29.3337ZM12.8882 24.2406C11.32 26.5621 13.2195 29.3337 15.8335 29.3337V27.3337C14.5266 27.3337 14.0357 26.1148 14.5455 25.3601L12.8882 24.2406Z",
      fill: i
    }));
  },
  menu: function menu(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M3 4H21",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), l.createElement("path", {
      d: "M3 12H21",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), l.createElement("path", {
      d: "M3 20H21",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round"
    }));
  },
  exit: function exit(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M19 5L5 19",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), l.createElement("path", {
      d: "M5 5L19 19",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round"
    }));
  },
  investments: function investments(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M20.7372 2.07129L21.7031 1.81247C21.5617 1.28455 21.0226 0.967991 20.4926 1.10166L20.7372 2.07129ZM15.6566 2.32143C15.1211 2.4565 14.7964 3.00011 14.9315 3.53562C15.0666 4.07114 15.6102 4.39576 16.1457 4.26069L15.6566 2.32143ZM21.0341 7.04295C21.177 7.57642 21.7254 7.893 22.2588 7.75006C22.7923 7.60712 23.1089 7.05878 22.9659 6.52531L21.0341 7.04295ZM3.11815 13.0072C2.56974 12.9419 2.07226 13.3336 2.007 13.882C1.94175 14.4304 2.33343 14.9279 2.88185 14.9932L3.11815 13.0072ZM20.9438 3.33067C21.1263 2.80942 20.8517 2.23889 20.3305 2.05636C19.8092 1.87383 19.2387 2.14842 19.0562 2.66967L20.9438 3.33067ZM17 15.0002C17 14.4479 16.5523 14.0002 16 14.0002C15.4477 14.0002 15 14.4479 15 15.0002H17ZM15 21.0002C15 21.5525 15.4477 22.0002 16 22.0002C16.5523 22.0002 17 21.5525 17 21.0002H15ZM9 18.0002C9 17.4479 8.55228 17.0002 8 17.0002C7.44772 17.0002 7 17.4479 7 18.0002H9ZM7 21.0002C7 21.5525 7.44772 22.0002 8 22.0002C8.55228 22.0002 9 21.5525 9 21.0002H7ZM13 17.0002C13 16.4479 12.5523 16.0002 12 16.0002C11.4477 16.0002 11 16.4479 11 17.0002H13ZM11 21.0002C11 21.5525 11.4477 22.0002 12 22.0002C12.5523 22.0002 13 21.5525 13 21.0002H11ZM5 19.0002C5 18.4479 4.55228 18.0002 4 18.0002C3.44772 18.0002 3 18.4479 3 19.0002H5ZM3 21.0002C3 21.5525 3.44772 22.0002 4 22.0002C4.55228 22.0002 5 21.5525 5 21.0002H3ZM21 11.0002C21 10.4479 20.5523 10.0002 20 10.0002C19.4477 10.0002 19 10.4479 19 11.0002H21ZM19 21.0002C19 21.5525 19.4477 22.0002 20 22.0002C20.5523 22.0002 21 21.5525 21 21.0002H19ZM20.4926 1.10166L15.6566 2.32143L16.1457 4.26069L20.9818 3.04092L20.4926 1.10166ZM19.7713 2.33011L21.0341 7.04295L22.9659 6.52531L21.7031 1.81247L19.7713 2.33011ZM2.88185 14.9932C4.76946 15.2178 8.36483 14.831 11.9245 13.1619C15.5175 11.4772 19.152 8.44749 20.9438 3.33067L19.0562 2.66967C17.4806 7.169 14.2988 9.83964 11.0755 11.3511C7.81885 12.8781 4.59789 13.1832 3.11815 13.0072L2.88185 14.9932ZM15 15.0002V21.0002H17V15.0002H15ZM7 18.0002V21.0002H9V18.0002H7ZM11 17.0002V21.0002H13V17.0002H11ZM3 19.0002V21.0002H5V19.0002H3ZM19 11.0002V21.0002H21V11.0002H19Z",
      fill: i
    }));
  },
  "open-banking": function openBanking(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M5.00054 4.71642C5.79031 3.37357 7.0841 2.4633 8.74324 2.08314C9.17756 1.98361 9.38937 1.97551 9.66685 2.04778C9.95826 2.12369 10.1948 2.26109 10.4175 2.48378C10.7525 2.81874 10.9058 3.19178 10.9066 3.67343C10.9071 4.02849 10.8579 4.27209 10.7344 4.52448C10.5325 4.93734 10.2572 5.17734 9.8158 5.32556C9.42196 5.45775 9.24328 5.54102 8.98478 5.7129C8.32574 6.15099 7.89146 6.94013 7.76617 7.92715C7.74544 8.09031 7.71389 8.66353 7.69606 9.20098C7.67819 9.73842 7.64563 10.241 7.62364 10.3178C7.47678 10.8306 7.05841 11.2517 6.50969 11.4389C6.35976 11.49 6.21842 11.5041 5.86406 11.5032C5.36992 11.502 5.13236 11.4522 4.8234 11.285C4.60297 11.1657 4.27244 10.8092 4.15808 10.5675C4.00009 10.2335 3.98819 10.0992 4.00644 8.85673C4.02092 7.87156 4.03467 7.63829 4.09927 7.28152C4.2798 6.28504 4.57924 5.43284 5.00054 4.71642Z",
      fill: i
    }), l.createElement("path", {
      d: "M12.7951 4.60471C13.0179 4.16334 13.55 3.77711 14.0305 3.70808C14.2949 3.67008 14.5029 3.68983 14.9204 3.79257C16.4928 4.17957 17.7203 5.03931 18.5065 6.30434C19.0792 7.22599 19.4688 8.47772 19.5599 9.68957C19.6071 10.3174 19.6079 15.931 19.5608 16.6345C19.4354 18.5111 18.7652 20.0491 17.5678 21.2084C17.0529 21.707 16.6357 21.9989 16.0183 22.2926C15.3356 22.6175 14.3078 22.8844 13.4023 22.9721C12.8129 23.0292 11.7338 22.995 11.2122 22.9028C9.63551 22.624 8.48105 22.0756 7.56965 21.1724C6.98387 20.5919 6.60242 20.0373 6.26386 19.274C5.99189 18.6609 5.8339 18.1457 5.70045 17.4372C5.62859 17.0557 5.62147 16.9142 5.62067 15.8493C5.6198 14.7067 5.62161 14.6756 5.70059 14.48C5.93769 13.8929 6.40834 13.4724 7.00076 13.3182C7.30309 13.2395 7.80889 13.2615 8.09761 13.3659C8.52949 13.522 8.94325 13.8828 9.14431 14.2788C9.31807 14.621 9.34047 14.7683 9.3723 15.7795C9.41373 17.094 9.52296 17.582 9.91739 18.2149C10.369 18.9395 11.0188 19.3568 11.9407 19.5144C12.4255 19.5973 12.7808 19.6018 13.197 19.5302C14.5426 19.299 15.3369 18.5415 15.6848 17.158C15.8208 16.6172 15.8332 16.2232 15.819 12.9177C15.8056 9.80372 15.8043 9.75451 15.7277 9.41439C15.4455 8.16185 14.9548 7.54497 13.9083 7.1273C13.4391 6.94003 13.2936 6.85334 13.0773 6.6325C12.5512 6.09526 12.4413 5.30552 12.7951 4.60471Z",
      fill: i
    }));
  },
  card: function card(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M6 16H11",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), l.createElement("rect", {
      x: "2",
      y: "7",
      width: "20",
      height: "3",
      fill: i
    }), l.createElement("path", {
      d: "M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6Z",
      stroke: i,
      strokeWidth: "2"
    }));
  },
  "list-check": function listCheck(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M3 5C2.44772 5 2 5.44772 2 6C2 6.55228 2.44772 7 3 7V5ZM7 7C7.55228 7 8 6.55228 8 6C8 5.44772 7.55228 5 7 5V7ZM3 10C2.44772 10 2 10.4477 2 11C2 11.5523 2.44772 12 3 12V10ZM7 12C7.55228 12 8 11.5523 8 11C8 10.4477 7.55228 10 7 10V12ZM3 15C2.44772 15 2 15.4477 2 16C2 16.5523 2.44772 17 3 17V15ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15V17ZM3 20C2.44772 20 2 20.4477 2 21C2 21.5523 2.44772 22 3 22V20ZM21 22C21.5523 22 22 21.5523 22 21C22 20.4477 21.5523 20 21 20V22ZM19.6 6.80001C20.0418 6.46864 20.1314 5.84184 19.8 5.40001C19.4686 4.95818 18.8418 4.86863 18.4 5.19999L19.6 6.80001ZM16.3333 8L15.7332 8.79999C16.0888 9.06666 16.5777 9.06667 16.9332 8.80001L16.3333 8ZM15.6 6.20004C15.1582 5.86866 14.5314 5.9582 14.2 6.40002C13.8686 6.84184 13.9582 7.46864 14.4 7.80002L15.6 6.20004ZM3 7H7V5H3V7ZM3 12H7V10H3V12ZM3 17H12V15H3V17ZM3 22H21V20H3V22ZM18.4 5.19999L15.7333 7.19999L16.9332 8.80001L19.6 6.80001L18.4 5.19999ZM14.4 7.80002L15.7332 8.79999L16.9333 7.20001L15.6 6.20004L14.4 7.80002ZM22 7C22 9.76142 19.7614 12 17 12V14C20.866 14 24 10.866 24 7H22ZM17 12C14.2386 12 12 9.76142 12 7H10C10 10.866 13.134 14 17 14V12ZM12 7C12 4.23858 14.2386 2 17 2V0C13.134 0 10 3.13401 10 7H12ZM17 2C19.7614 2 22 4.23858 22 7H24C24 3.13401 20.866 0 17 0V2Z",
      fill: i
    }));
  },
  barcode: function barcode(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M5 3V12M9 3V12M13 3V12M15 3V12M19 3V12M5 15V21M9 15V21M13 15V21M15 15V21M19 15V21",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), l.createElement("path", {
      d: "M2 12H22",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round"
    }));
  },
  "pix-outline": function pixOutline(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 22 23",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M9.1123 2.78192L7.0796 4.81461C7.46949 4.95738 7.82772 5.18404 8.12695 5.48327L11.1837 8.54003L14.2405 5.48327C14.4723 5.25144 14.7396 5.06316 15.0295 4.92372L12.8877 2.78192C11.8452 1.73936 10.5 1.5 9.1123 2.78192ZM9.1123 2.78192L8.39422 3.5M9.1123 21.2181L7.0796 19.1854C7.46949 19.0426 7.82772 18.816 8.12695 18.5167L11.1837 15.46L14.2405 18.5167C14.4723 18.7486 14.7396 18.9368 15.0295 19.0763L12.8877 21.2181C11.8452 22.2606 10.1548 22.2606 9.1123 21.2181ZM1.78192 13.8877C0.73936 12.8452 0.73936 11.1548 1.78192 10.1123L3.69379 8.20042H5.80726L9.275 11.6681C9.4006 11.7937 9.5354 11.9043 9.6774 12C9.5354 12.0957 9.4006 12.2063 9.275 12.3319L5.80726 15.7996H3.69378L1.78192 13.8877ZM12.69 12C12.832 11.9043 12.9669 11.7937 13.0925 11.6681L16.5602 8.20042H18.3062L20.2181 10.1123C21.2606 11.1548 21.2606 12.8452 20.2181 13.8877L18.3062 15.7996H16.5602L13.0925 12.3319C12.9669 12.2063 12.832 12.0957 12.69 12Z",
      stroke: i,
      strokeWidth: "2",
      strokeLinejoin: "round"
    }));
  },
  alarm: function alarm(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("circle", {
      cx: "12",
      cy: "13",
      r: "8",
      stroke: i,
      strokeWidth: "2"
    }), l.createElement("path", {
      d: "M2.29289 5.29289C1.90237 5.68342 1.90237 6.31658 2.29289 6.70711C2.68342 7.09763 3.31658 7.09763 3.70711 6.70711L2.29289 5.29289ZM6.70711 3.70711C7.09763 3.31658 7.09763 2.68342 6.70711 2.29289C6.31658 1.90237 5.68342 1.90237 5.29289 2.29289L6.70711 3.70711ZM20.2929 6.70711C20.6834 7.09763 21.3166 7.09763 21.7071 6.70711C22.0976 6.31658 22.0976 5.68342 21.7071 5.29289L20.2929 6.70711ZM18.7071 2.29289C18.3166 1.90237 17.6834 1.90237 17.2929 2.29289C16.9024 2.68342 16.9024 3.31658 17.2929 3.70711L18.7071 2.29289ZM12 14H11C11 14.2652 11.1054 14.5196 11.2929 14.7071L12 14ZM13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9H13ZM13.2929 16.7071C13.6834 17.0976 14.3166 17.0976 14.7071 16.7071C15.0976 16.3166 15.0976 15.6834 14.7071 15.2929L13.2929 16.7071ZM3.70711 6.70711L6.70711 3.70711L5.29289 2.29289L2.29289 5.29289L3.70711 6.70711ZM21.7071 5.29289L18.7071 2.29289L17.2929 3.70711L20.2929 6.70711L21.7071 5.29289ZM13 14V9H11V14H13ZM11.2929 14.7071L13.2929 16.7071L14.7071 15.2929L12.7071 13.2929L11.2929 14.7071Z",
      fill: i
    }));
  },
  "alarm-off": function alarmOff(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M6.86493 6.86534C8.25443 5.70101 10.0453 5 12 5C16.4183 5 20 8.58172 20 13C20 14.9387 19.3104 16.7164 18.163 18.1011M4.74923 9.61521C4.26853 10.6432 4 11.7902 4 13C4 17.4183 7.58172 21 12 21C13.1835 21 14.3069 20.743 15.3176 20.2818",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round"
    }), l.createElement("path", {
      d: "M6.70711 3.70711C7.09763 3.31658 7.09763 2.68342 6.70711 2.29289C6.31658 1.90237 5.68342 1.90237 5.29289 2.29289L6.70711 3.70711ZM20.2929 6.70711C20.6834 7.09763 21.3166 7.09763 21.7071 6.70711C22.0976 6.31658 22.0976 5.68342 21.7071 5.29289L20.2929 6.70711ZM18.7071 2.29289C18.3166 1.90237 17.6834 1.90237 17.2929 2.29289C16.9024 2.68342 16.9024 3.31658 17.2929 3.70711L18.7071 2.29289ZM3.79289 3.79289C3.40237 4.18342 3.40237 4.81658 3.79289 5.20711C4.18342 5.59763 4.81658 5.59763 5.20711 5.20711L3.79289 3.79289ZM21.7071 5.29289L18.7071 2.29289L17.2929 3.70711L20.2929 6.70711L21.7071 5.29289ZM5.20711 5.20711L6.70711 3.70711L5.29289 2.29289L3.79289 3.79289L5.20711 5.20711Z",
      fill: i
    }), l.createElement("path", {
      d: "M3 3L21 21",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round"
    }));
  },
  apps: function apps(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M14.5 5.5C14.5 6.88071 13.3807 8 12 8C10.6193 8 9.5 6.88071 9.5 5.5C9.5 4.11929 10.6193 3 12 3C13.3807 3 14.5 4.11929 14.5 5.5Z",
      stroke: i,
      strokeWidth: "2"
    }), l.createElement("path", {
      d: "M14.5 18.5C14.5 19.8807 13.3807 21 12 21C10.6193 21 9.5 19.8807 9.5 18.5C9.5 17.1193 10.6193 16 12 16C13.3807 16 14.5 17.1193 14.5 18.5Z",
      stroke: i,
      strokeWidth: "2"
    }), l.createElement("path", {
      d: "M8 12C8 13.3807 6.88071 14.5 5.5 14.5C4.11929 14.5 3 13.3807 3 12C3 10.6193 4.11929 9.5 5.5 9.5C6.88071 9.5 8 10.6193 8 12Z",
      stroke: i,
      strokeWidth: "2"
    }), l.createElement("path", {
      d: "M21 12C21 13.3807 19.8807 14.5 18.5 14.5C17.1193 14.5 16 13.3807 16 12C16 10.6193 17.1193 9.5 18.5 9.5C19.8807 9.5 21 10.6193 21 12Z",
      stroke: i,
      strokeWidth: "2"
    }));
  },
  "arrow-down": function arrowDown(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: o
    }, a), l.createElement("path", {
      d: "M18 9L12 15L6 9",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  "arrow-left": function arrowLeft(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: o
    }, a), l.createElement("path", {
      d: "M13.6446 2.41879C13.1708 1.8604 12.4055 1.8604 11.9317 2.41879L6.35535 8.9906C5.88155 9.54899 5.88155 10.451 6.35535 11.0094L11.9317 17.5812C12.4055 18.1396 13.1708 18.1396 13.6446 17.5812C14.1185 17.0228 14.1185 16.1208 13.6446 15.5624L8.9309 9.99284L13.6446 4.43758C14.1185 3.87919 14.1063 2.96286 13.6446 2.41879Z",
      fill: i
    }));
  },
  "arrow-right": function arrowRight(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: o
    }, a), l.createElement("path", {
      d: "M6.35535 2.41879C6.82916 1.8604 7.59453 1.8604 8.06834 2.41879L13.6446 8.9906C14.1185 9.54899 14.1185 10.451 13.6446 11.0094L8.06834 17.5812C7.59453 18.1396 6.82916 18.1396 6.35535 17.5812C5.88155 17.0228 5.88155 16.1208 6.35535 15.5624L11.0691 9.99284L6.35535 4.43758C5.88155 3.87919 5.8937 2.96286 6.35535 2.41879Z",
      fill: i
    }));
  },
  "card-money": function cardMoney(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: o
    }, a), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 4H6V6H4V4C4 2.89543 4.89543 2 6 2H22C23.1046 2 24 2.89543 24 4V14C24 15.1046 23.1046 16 22 16V14V9V4Z",
      fill: i
    }), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 9H2V20H18V9ZM2 7C0.895431 7 0 7.89543 0 9V20C0 21.1046 0.895431 22 2 22H18C19.1046 22 20 21.1046 20 20V9C20 7.89543 19.1046 7 18 7H2Z",
      fill: i
    }), l.createElement("path", {
      d: "M10.2831 10.7563C10.2831 10.3386 9.96765 10 9.57853 10C9.18941 10 8.87397 10.3386 8.87397 10.7563V11.0087C8.01646 11.0817 7.27548 11.7204 7.06043 12.6299L7.06002 12.6317C6.83026 13.6132 7.27733 14.6028 8.10677 15.0505L8.10946 15.0519C8.38904 15.2012 8.70699 15.2876 9.03288 15.2876H9.99418C10.3404 15.2876 10.5909 15.5776 10.5909 15.8898C10.5909 16.2042 10.3441 16.492 9.99418 16.492H9.58313L9.57853 16.492L9.57394 16.492H8.01298C7.62386 16.492 7.30841 16.8306 7.30841 17.2483C7.30841 17.666 7.62386 18.0046 8.01298 18.0046H8.87397V18.2437C8.87397 18.6614 9.18941 19 9.57853 19C9.96765 19 10.2831 18.6614 10.2831 18.2437V17.9827C11.2427 17.8363 12 16.9714 12 15.8898C12 14.6995 11.0782 13.775 9.99418 13.775H9.03288C8.9372 13.775 8.83365 13.7489 8.73847 13.6984C8.47888 13.5575 8.36371 13.2709 8.42646 13.0012C8.49114 12.7293 8.73415 12.5143 9.03875 12.5143H9.57581C9.57671 12.5143 9.57762 12.5143 9.57853 12.5143C9.57944 12.5143 9.58035 12.5143 9.58126 12.5143H11.0199C11.4091 12.5143 11.7245 12.1757 11.7245 11.758C11.7245 11.3403 11.4091 11.0017 11.0199 11.0017H10.2831V10.7563Z",
      fill: i
    }));
  },
  canceled: function canceled(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M15.364 9L9 15.364M9.00019 9L15.3642 15.364M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  cards: function cards(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: o
    }, a), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.0002 5H17.0001H6.00019H3.1709C3.58274 3.83481 4.69397 3 6.00019 3H20.0002C21.657 3 23.0002 4.34315 23.0002 6V14C23.0002 15.3062 22.1653 16.4175 21.0001 16.8293V14.0128L21.0002 14V6C21.0002 5.44771 20.5525 5 20.0002 5Z",
      fill: i
    }), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17 8H4C3.44772 8 3 8.44772 3 9V17C3 17.5523 3.44772 18 4 18H17C17.5523 18 18 17.5523 18 17V9C18 8.44771 17.5523 8 17 8ZM4 6C2.34315 6 1 7.34315 1 9V17C1 18.6569 2.34315 20 4 20H17C18.6569 20 20 18.6569 20 17V9C20 7.34315 18.6569 6 17 6H4Z",
      fill: i
    }), l.createElement("rect", {
      x: "3",
      y: "10",
      width: "15",
      height: "2",
      fill: i
    }));
  },
  check: function check(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M5 19C4.44772 19 4 19.4477 4 20C4 20.5523 4.44772 21 5 21V19ZM15 21C15.5523 21 16 20.5523 16 20C16 19.4477 15.5523 19 15 19V21ZM4.70711 10.2929C4.31658 9.90237 3.68342 9.90237 3.29289 10.2929C2.90237 10.6834 2.90237 11.3166 3.29289 11.7071L4.70711 10.2929ZM9 16L8.29289 16.7071C8.68342 17.0976 9.31658 17.0976 9.70711 16.7071L9 16ZM20.7071 5.70711C21.0976 5.31658 21.0976 4.68342 20.7071 4.29289C20.3166 3.90237 19.6834 3.90237 19.2929 4.29289L20.7071 5.70711ZM5 21H15V19H5V21ZM3.29289 11.7071L8.29289 16.7071L9.70711 15.2929L4.70711 10.2929L3.29289 11.7071ZM9.70711 16.7071L20.7071 5.70711L19.2929 4.29289L8.29289 15.2929L9.70711 16.7071Z",
      fill: i
    }));
  },
  "checkbox-indeterminate": function checkboxIndeterminate(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: o
    }, a), l.createElement("path", {
      d: "M6 11C6 8.23858 8.23858 6 11 6H21C23.7614 6 26 8.23858 26 11V21C26 23.7614 23.7614 26 21 26H11C8.23858 26 6 23.7614 6 21V11Z",
      fill: i
    }), l.createElement("path", {
      d: "M9 16C9 15.4477 9.44772 15 10 15H16H22C22.5523 15 23 15.4477 23 16V16C23 16.5523 22.5523 17 22 17H10C9.44772 17 9 16.5523 9 16V16Z",
      fill: "var(--checkbox-indeterminate-check-color)"
    }));
  },
  "checkbox-off": function checkboxOff(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: o
    }, a), l.createElement("path", {
      d: "M7 11C7 8.79086 8.79086 7 11 7H21C23.2091 7 25 8.79086 25 11V21C25 23.2091 23.2091 25 21 25H11C8.79086 25 7 23.2091 7 21V11Z",
      stroke: i,
      strokeWidth: "2"
    }));
  },
  "checkbox-on": function checkboxOn(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: o
    }, a), l.createElement("path", {
      d: "M6 11C6 8.23858 8.23858 6 11 6H21C23.7614 6 26 8.23858 26 11V21C26 23.7614 23.7614 26 21 26H11C8.23858 26 6 23.7614 6 21V11Z",
      fill: i
    }), l.createElement("path", {
      d: "M11 17L14 20L21 13",
      stroke: "var(--checkbox-check-color)",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  clear: function clear(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
      fill: i
    }), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5856 12L7.40366 8.81802L8.81787 7.40381L11.9999 10.5858L15.1818 7.40381L16.596 8.81802L13.4141 12L16.596 15.182L15.1818 16.5962L11.9999 13.4142L8.81787 16.5962L7.40366 15.182L10.5856 12Z",
      fill: "#8C91A9"
    }));
  },
  close: Hn,
  delete: function _delete(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M5 11L5.83464 19.1811C5.92829 20.2112 6.79202 21 7.82643 21H16.1736C17.208 21 18.0717 20.2112 18.1654 19.1811L19 11",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), l.createElement("path", {
      d: "M3 6C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8V6ZM8.62127 4.51493L7.65113 4.27239V4.27239L8.62127 4.51493ZM15.3787 4.51493L16.3489 4.27239V4.27239L15.3787 4.51493ZM21 8C21.5523 8 22 7.55228 22 7C22 6.44772 21.5523 6 21 6V8ZM8.97014 7.24254L9.59141 4.75746L7.65113 4.27239L7.02986 6.75746L8.97014 7.24254ZM10.5616 4H13.4384V2H10.5616V4ZM14.4086 4.75746L15.0299 7.24254L16.9701 6.75746L16.3489 4.27239L14.4086 4.75746ZM8 8H16V6H8V8ZM13.4384 4C13.8973 4 14.2973 4.3123 14.4086 4.75746L16.3489 4.27239C16.015 2.93689 14.8151 2 13.4384 2V4ZM9.59141 4.75746C9.7027 4.3123 10.1027 4 10.5616 4V2C9.18495 2 7.985 2.93689 7.65113 4.27239L9.59141 4.75746ZM3 8H8V6H3V8ZM16 8H21V6H16V8Z",
      fill: i
    }));
  },
  edit: function edit(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M8.6665 14H13.9998",
      stroke: i,
      strokeLinecap: "round"
    }), l.createElement("path", {
      d: "M9 4.00001L10.7676 2.23236C11.0801 1.91994 11.5866 1.91994 11.899 2.23236L13.7676 4.10099C14.0801 4.41341 14.0801 4.91994 13.7676 5.23236L12 7.00001M9 4.00001L2.39052 10.6095C2.14048 10.8595 2 11.1987 2 11.5523V14H4.44772C4.80134 14 5.14048 13.8595 5.39052 13.6095L12 7.00001M9 4.00001L12 7.00001",
      stroke: i,
      strokeLinejoin: "round"
    }));
  },
  eye: function eye(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 20 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M10 1.86667C13.4455 1.86667 16.5182 3.85467 18.0182 7C16.5182 10.1453 13.4545 12.1333 10 12.1333C6.54545 12.1333 3.48182 10.1453 1.98182 7C3.48182 3.85467 6.55455 1.86667 10 1.86667ZM10 0C5.45455 0 1.57273 2.90267 0 7C1.57273 11.0973 5.45455 14 10 14C14.5455 14 18.4273 11.0973 20 7C18.4273 2.90267 14.5455 0 10 0ZM10 4.66667C11.2545 4.66667 12.2727 5.712 12.2727 7C12.2727 8.288 11.2545 9.33333 10 9.33333C8.74545 9.33333 7.72727 8.288 7.72727 7C7.72727 5.712 8.74545 4.66667 10 4.66667ZM10 2.8C7.74545 2.8 5.90909 4.68533 5.90909 7C5.90909 9.31467 7.74545 11.2 10 11.2C12.2545 11.2 14.0909 9.31467 14.0909 7C14.0909 4.68533 12.2545 2.8 10 2.8Z",
      fill: i
    }));
  },
  "eye-cross": function eyeCross(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 20 21",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.8232 5.26263C14.1457 4.14753 12.1469 3.5 10 3.5C5.45455 3.5 1.57273 6.40267 0 10.5C0.934646 12.935 2.6848 14.948 4.90511 16.1807L6.27681 14.809C4.43258 13.9452 2.90869 12.4435 1.98182 10.5C3.48182 7.35467 6.55455 5.36667 10 5.36667C11.6197 5.36667 13.1571 5.80601 14.4874 6.5984L15.8232 5.26263ZM13.1994 7.88638C12.449 6.92041 11.2933 6.3 10 6.3C7.74545 6.3 5.90909 8.18533 5.90909 10.5C5.90909 11.7882 6.47791 12.9435 7.37105 13.7147L8.68376 12.402C8.10498 11.9789 7.72727 11.2845 7.72727 10.5C7.72727 9.212 8.74545 8.16667 10 8.16667C10.7855 8.16667 11.4784 8.5765 11.8867 9.19913L13.1994 7.88638ZM9.27952 14.6347L14.0448 9.86939C14.0752 10.0751 14.0909 10.2857 14.0909 10.5C14.0909 12.8147 12.2545 14.7 10 14.7C9.75426 14.7 9.51349 14.6776 9.27952 14.6347ZM8.42185 15.4924C8.93552 15.5853 9.46304 15.6333 10 15.6333C13.4545 15.6333 16.5182 13.6453 18.0182 10.5C17.5293 9.4749 16.8734 8.57273 16.092 7.82225L17.3872 6.52706C18.5189 7.62983 19.4177 8.98304 20 10.5C18.4273 14.5973 14.5455 17.5 10 17.5C8.91677 17.5 7.87123 17.3352 6.88564 17.0286L8.42185 15.4924Z",
      fill: i
    }), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.7071 1.79289C19.0976 2.18342 19.0976 2.81658 18.7071 3.20711L2.70711 19.2071C2.31658 19.5976 1.68342 19.5976 1.29289 19.2071C0.902369 18.8166 0.902369 18.1834 1.29289 17.7929L17.2929 1.79289C17.6834 1.40237 18.3166 1.40237 18.7071 1.79289Z",
      fill: i
    }));
  },
  hide: function hide(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M15.114 5.5571C15.2375 5.31011 15.1374 5.00978 14.8904 4.88628C14.6434 4.76279 14.3431 4.8629 14.2196 5.10989L15.114 5.5571ZM1.78071 5.10989C1.65722 4.8629 1.35688 4.76279 1.10989 4.88628C0.8629 5.00978 0.762788 5.31011 0.886283 5.5571L1.78071 5.10989ZM13.1446 7.47846C12.9468 7.28584 12.6302 7.2901 12.4376 7.48798C12.245 7.68585 12.2492 8.0024 12.4471 8.19502L13.1446 7.47846ZM13.9847 9.69178C14.1826 9.88439 14.4992 9.88013 14.6918 9.68226C14.8844 9.48438 14.8801 9.16783 14.6823 8.97521L13.9847 9.69178ZM10.362 9.5712C10.2724 9.31001 9.98797 9.17092 9.72677 9.26055C9.46558 9.35017 9.32649 9.63457 9.41612 9.89576L10.362 9.5712ZM10.1939 12.1624C10.2835 12.4236 10.5679 12.5627 10.8291 12.4731C11.0903 12.3835 11.2294 12.0991 11.1398 11.8379L10.1939 12.1624ZM6.58421 9.89576C6.67383 9.63457 6.53475 9.35017 6.27355 9.26055C6.01236 9.17092 5.72797 9.31001 5.63834 9.5712L6.58421 9.89576ZM4.86056 11.8379C4.77094 12.0991 4.91002 12.3835 5.17122 12.4731C5.43241 12.5627 5.7168 12.4236 5.80643 12.1624L4.86056 11.8379ZM3.51706 8.2238C3.71451 8.03075 3.71808 7.71419 3.52503 7.51674C3.33198 7.31929 3.01542 7.31572 2.81797 7.50877L3.51706 8.2238ZM1.31729 8.97598C1.11983 9.16903 1.11626 9.48559 1.30931 9.68304C1.50236 9.88049 1.81892 9.88406 2.01637 9.69101L1.31729 8.97598ZM14.2196 5.10989C13.8608 5.82743 13.0698 6.93996 11.9695 7.86795C10.8698 8.79539 9.50803 9.50016 8.00016 9.50016V10.5002C9.82563 10.5002 11.4083 9.64938 12.6142 8.63238C13.8194 7.61592 14.695 6.39512 15.114 5.5571L14.2196 5.10989ZM8.00016 9.50016C6.4923 9.50016 5.13053 8.79539 4.03085 7.86795C2.93053 6.93996 2.13948 5.82743 1.78071 5.10989L0.886283 5.5571C1.30529 6.39512 2.18091 7.61592 3.38614 8.63238C4.59202 9.64938 6.1747 10.5002 8.00016 10.5002V9.50016ZM12.4471 8.19502L13.9847 9.69178L14.6823 8.97521L13.1446 7.47846L12.4471 8.19502ZM9.41612 9.89576L10.1939 12.1624L11.1398 11.8379L10.362 9.5712L9.41612 9.89576ZM5.63834 9.5712L4.86056 11.8379L5.80643 12.1624L6.58421 9.89576L5.63834 9.5712ZM2.81797 7.50877L1.31729 8.97598L2.01637 9.69101L3.51706 8.2238L2.81797 7.50877Z",
      fill: i
    }));
  },
  house: function house(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: o
    }, a), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 12C5.55228 12 6 12.4477 6 13V18C6 18.5523 6.44772 19 7 19H17C17.5523 19 18 18.5523 18 18V13C18 12.4477 18.4477 12 19 12C19.5523 12 20 12.4477 20 13V18C20 19.6569 18.6569 21 17 21H7C5.34315 21 4 19.6569 4 18V13C4 12.4477 4.44772 12 5 12Z",
      fill: i
    }), l.createElement("path", {
      d: "M2.51916 7.86731C2.0227 8.18289 1.85261 8.88181 2.13924 9.42841C2.42586 9.975 3.06068 10.1623 3.55714 9.8467L12 4.47993L20.4429 9.8467C20.9393 10.1623 21.5741 9.975 21.8608 9.42841C22.1474 8.88181 21.9773 8.18289 21.4808 7.86731L12.7384 2.3101C12.5377 2.10222 12.2706 1.9928 12 2.00037C11.7294 1.9928 11.4623 2.10222 11.2616 2.3101L2.51916 7.86731Z",
      fill: i
    }));
  },
  info: function info(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M11.5 8C11.5 9.933 9.933 11.5 8 11.5C6.067 11.5 4.5 9.933 4.5 8C4.5 6.067 6.067 4.5 8 4.5C9.933 4.5 11.5 6.067 11.5 8Z",
      stroke: i,
      strokeWidth: "7"
    }), l.createElement("path", {
      d: "M8 4.66667L8 4M8 12L8 7.33333",
      stroke: "white",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  loading: function loading(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement($n, r({
      viewBox: "0 0 24 24",
      fill: "none",
      width: e,
      height: o
    }, a), l.createElement(Qn, {
      cx: "12",
      cy: "12",
      r: "8",
      stroke: i,
      strokeWidth: "2"
    }), l.createElement("path", {
      d: "M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C10.5429 20 9.17669 19.6104 8 18.9297",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  pai: function pai(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: o
    }, a), l.createElement("path", {
      d: "M6.7403 6.00145L2.56657 6C2.49942 6 2.45913 6.07161 2.49582 6.12587L3.91824 8.23764C3.94726 8.28032 3.99643 8.30637 4.04919 8.30637H6.7403C8.42221 8.30637 8.9767 8.84094 8.9767 9.83655C8.9767 10.8322 8.42221 11.3486 6.7403 11.3486H6.18534C6.10859 11.3486 6.06207 11.4309 6.10404 11.4928L7.47609 13.5332C7.51159 13.5863 7.57466 13.6167 7.63965 13.6118C10.3375 13.4127 11.5378 12.0315 11.5378 9.83655C11.5378 7.55044 10.1809 6.00145 6.7403 6.00145Z",
      fill: i
    }), l.createElement("path", {
      d: "M15.1013 12.59H13.2671C13.1515 12.59 13.0716 12.474 13.1126 12.365L14.0268 9.93324C14.0849 9.77868 14.3026 9.77844 14.3609 9.93324L15.2684 12.3469C15.3126 12.4643 15.2262 12.59 15.1013 12.59ZM19.9321 17.7553L15.5562 6.11598C15.5301 6.04605 15.4634 6 15.3893 6H13.0176C12.9433 6 12.8769 6.04605 12.8505 6.11598L11.8458 8.77391C11.8228 8.83515 11.819 8.9017 11.8331 8.9656C12.1933 10.598 11.66 12.4163 10.3174 13.2058C10.2102 13.2687 10.1313 13.3712 10.0872 13.4882L8.47457 17.7553C8.43045 17.873 8.51678 17.9986 8.64173 17.9986H10.8784C10.9527 17.9986 11.0192 17.9523 11.0455 17.8824L12.124 15.0138C12.1504 14.9438 12.2169 14.8973 12.2912 14.8973H16.1155C16.1898 14.8973 16.2563 14.9438 16.2827 15.0138L17.3612 17.8824C17.3875 17.9523 17.4542 17.9986 17.5283 17.9986H19.765C19.8899 17.9986 19.9762 17.873 19.9321 17.7553Z",
      fill: i
    }), l.createElement("path", {
      d: "M21.8214 6H19.6173C19.5188 6 19.4387 6.08054 19.4387 6.17964L19.4355 15.2558C19.4353 15.3643 19.455 15.4719 19.4931 15.5736L20.2505 17.5902C20.3071 17.7259 20.2929 17.8713 20.2294 17.9574C20.2167 17.9743 20.2287 17.9979 20.2498 17.9979L21.8214 17.9986C21.9199 17.9986 22 17.9183 22 17.819V6.17964C22 6.08078 21.9197 6 21.8214 6Z",
      fill: i
    }), l.createElement("path", {
      d: "M2.1626 6.24174L7.06181 13.5384C7.09659 13.5905 7.05797 13.6592 6.99394 13.6592H4.99473C4.89401 13.6592 4.81246 13.7378 4.81246 13.8348V17.824C4.81246 17.9214 4.73092 18 4.63019 18H2.18227C2.08178 18 2 17.9214 2 17.824V6.28803C2 6.20316 2.11464 6.17036 2.1626 6.24174Z",
      fill: i
    }));
  },
  paper: function paper(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: o
    }, a), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.2941 4V6H17.957C17.5694 4.83481 16.5235 4 15.2941 4ZM18.1176 8H14.3529C13.8331 8 13.4118 7.55228 13.4118 7V4H6.82353C6.30373 4 5.88235 4.44772 5.88235 5V19C5.88235 19.5523 6.30373 20 6.82353 20H17.1765C17.6963 20 18.1176 19.5523 18.1176 19V8ZM13.4118 2H15.2941C17.5708 2 19.4698 3.71776 19.9059 6C19.9132 6.03815 19.92 6.07646 19.9265 6.11492C19.9748 6.40219 20 6.69797 20 7V8V19C20 20.6569 18.7359 22 17.1765 22H6.82353C5.26414 22 4 20.6569 4 19V5C4 3.34315 5.26414 2 6.82353 2H13.4118Z",
      fill: i
    }), l.createElement("rect", {
      x: "8",
      y: "10",
      width: "8",
      height: "2",
      rx: "1",
      fill: i
    }), l.createElement("rect", {
      x: "8",
      y: "13",
      width: "5",
      height: "2",
      rx: "1",
      fill: i
    }), l.createElement("rect", {
      x: "8",
      y: "16",
      width: "6",
      height: "2",
      rx: "1",
      fill: i
    }));
  },
  pencil: function pencil(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: o
    }, a), l.createElement("g", null, l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 19.875V16.5C3 16.2016 3.11853 15.9155 3.3295 15.7045L15.7045 3.3295C16.1438 2.89017 16.8562 2.89017 17.2955 3.3295L20.6705 6.7045C21.1098 7.14384 21.1098 7.85615 20.6705 8.2955L8.2955 20.6705C8.08452 20.8815 7.79837 21 7.5 21H4.125C3.50368 21 3 20.4963 3 19.875ZM16.5001 9.2841L18.284 7.50018L16.5 5.71617L14.7161 7.50009L16.5001 9.2841ZM14.9091 10.8751L13.1251 9.09108L5.25 16.9662V18.7502H7.03401L14.9091 10.8751Z",
      fill: i
    })));
  },
  pending: function pending(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M12 7V12.5385L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  polygon: function polygon(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: o
    }, a), l.createElement("path", {
      d: "m6.80001,9.26666c-0.4,0.53334 -1.2,0.53334 -1.6,0l-4,-5.33333c-0.49443,-0.65924 -0.02404,-1.6 0.8,-1.6l8,0c0.824,0 1.2944,0.94077 0.8,1.6l-4,5.33333z",
      fill: i
    }));
  },
  "radio-on": function radioOn(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: o
    }, a), l.createElement("circle", {
      cx: "16",
      cy: "16",
      r: "9",
      stroke: i,
      strokeWidth: "2"
    }), l.createElement("circle", {
      cx: "16.0001",
      cy: "16",
      r: "5.33333",
      fill: i
    }));
  },
  "radio-off": function radioOff(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: o
    }, a), l.createElement("circle", {
      cx: "16",
      cy: "16",
      r: "9",
      stroke: i,
      strokeWidth: "2"
    }));
  },
  "right-arrow": function rightArrow(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: e,
      height: o
    }, a), l.createElement("path", {
      d: "M20 12H3M14 5l7 7-7 7",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  "left-arrow": function leftArrow(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M4 12H21",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), l.createElement("path", {
      d: "M10 5L3 12L10 19",
      stroke: i,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  search: function search(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: o
    }, a), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5 16.7222C13.9364 16.7222 16.7222 13.9364 16.7222 10.5C16.7222 7.06356 13.9364 4.27778 10.5 4.27778C7.06356 4.27778 4.27778 7.06356 4.27778 10.5C4.27778 13.9364 7.06356 16.7222 10.5 16.7222ZM10.5 18.5C6.08172 18.5 2.5 14.9183 2.5 10.5C2.5 6.08172 6.08172 2.5 10.5 2.5C14.9183 2.5 18.5 6.08172 18.5 10.5C18.5 14.9183 14.9183 18.5 10.5 18.5Z",
      fill: i
    }), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.0961 19.1462L18.7423 16.9039C18.2038 16.3654 17.4423 16.3654 16.9039 16.9039C16.3654 17.4423 16.3654 18.2038 16.9039 18.7423L19.1462 21.0961C19.6846 21.6346 20.5577 21.6346 21.0961 21.0961C21.6346 20.5577 21.6346 19.6846 21.0961 19.1462Z",
      fill: i
    }));
  },
  settings: function settings(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: o
    }, a), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 15.6374C9.9917 15.6374 8.36365 14.0092 8.36365 12.0007C8.36365 9.99228 9.9917 8.36411 12 8.36411C14.0083 8.36411 15.6364 9.99228 15.6364 12.0007C15.6364 14.0092 14.0083 15.6374 12 15.6374ZM12 13.8191C13.0042 13.8191 13.8182 13.005 13.8182 12.0007C13.8182 10.9965 13.0042 10.1824 12 10.1824C10.9959 10.1824 10.1818 10.9965 10.1818 12.0007C10.1818 13.005 10.9959 13.8191 12 13.8191Z",
      fill: i
    }), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.5268 9.44375C21.2208 9.48207 21.8178 10.0338 21.9103 10.723C21.9219 10.8089 21.9387 10.9515 21.9553 11.1302C21.9782 11.3772 21.9938 11.6227 21.9985 11.8568L21.9996 11.9278L22 12L21.9996 12.0715L21.9985 12.1418C21.9938 12.3763 21.9783 12.6222 21.9553 12.8695C21.9387 13.0482 21.9219 13.1907 21.9105 13.275C21.8189 13.9654 21.2212 14.5174 20.5266 14.5557L19.5217 14.6109L19.1642 15.4708L19.8363 16.2206C20.3097 16.7499 20.3239 17.5763 19.8137 18.1816L18.1221 19.8682C17.5769 20.3243 16.75 20.3098 16.2203 19.8354L15.473 19.1655L14.6112 19.5198L14.5562 20.5263C14.518 21.2198 13.9673 21.817 13.2781 21.9105C13.191 21.9223 13.0484 21.939 12.8696 21.9555C12.6217 21.9784 12.3751 21.9939 12.1401 21.9986C12.07 21.9997 12.07 21.9997 11.9993 22C11.9282 21.9997 11.928 21.9997 11.8579 21.9986C11.6235 21.9939 11.3771 21.9784 11.1297 21.9555C10.9511 21.939 10.8085 21.9223 10.7209 21.9105C10.0321 21.817 9.48097 21.2196 9.44318 20.526L9.38815 19.5216L8.52835 19.1641L7.77874 19.8358C7.24966 20.3096 6.42339 20.3238 5.81816 19.8136L4.13115 18.1215C3.67569 17.5761 3.68992 16.7496 4.16421 16.2198L4.83386 15.4728L4.47989 14.611L3.47359 14.5557C2.77968 14.5174 2.18297 13.9667 2.08969 13.2775C2.07791 13.1904 2.06118 13.0479 2.04462 12.8693C2.02169 12.6221 2.00616 12.3762 2.00146 12.1418L2.00038 12.0715L2 12L2.00039 11.9279L2.00148 11.8569C2.0062 11.6229 2.02169 11.3774 2.04451 11.1306C2.06102 10.952 2.0777 10.8094 2.08953 10.7218C2.18288 10.033 2.77957 9.48202 3.47389 9.44373L4.47781 9.38889L4.83535 8.52864L4.16413 7.77953C3.68983 7.25029 3.67559 6.42347 4.18607 5.8184L5.87769 4.13176C6.42275 3.67607 7.24886 3.69016 7.77878 4.16417L8.52637 4.83398L9.38826 4.47985L9.44335 3.47413C9.48116 2.7801 10.0324 2.18314 10.7214 2.08969C10.8085 2.0779 10.951 2.06118 11.1297 2.04462C11.3769 2.02171 11.6227 2.00618 11.857 2.00147L11.9276 2.00038L11.9993 2C12.0696 2.00025 12.0696 2.00025 12.1392 2.00142C12.3745 2.00606 12.6214 2.02162 12.8696 2.04462C13.0484 2.06118 13.191 2.0779 13.2776 2.08963C13.9667 2.18254 14.518 2.77945 14.5563 3.474L14.6111 4.47806L15.4716 4.8356L16.221 4.16368C16.7504 3.69016 17.5771 3.67607 18.1819 4.18641L19.8685 5.87822C20.324 6.4233 20.3099 7.24986 19.8357 7.77947L19.1658 8.52714L19.5199 9.38877L20.5268 9.44375ZM11.2971 20.1449C11.504 20.164 11.7079 20.1769 11.8938 20.1806L11.9475 20.1814L11.9993 20.1817L12.0507 20.1814L12.104 20.1806C12.2904 20.1769 12.4949 20.1641 12.7023 20.1449L12.7565 20.1398L12.8032 19.284C12.838 18.6531 13.2964 18.0523 13.8361 17.8748L14.7957 17.4809C15.3608 17.1961 16.1108 17.2958 16.5825 17.7182L17.1752 18.2496L18.2516 17.1768L17.7181 16.5817C17.2962 16.1103 17.1964 15.3603 17.4529 14.8571L17.8527 13.8954C18.0524 13.2959 18.6538 12.8368 19.284 12.8029L20.1397 12.7559L20.1449 12.7013C20.1641 12.4946 20.177 12.291 20.1807 12.1053C20.1816 12.052 20.1816 12.052 20.1818 12C20.1816 11.948 20.1816 11.9473 20.1807 11.8936C20.1769 11.7082 20.164 11.5048 20.1449 11.2984L20.1397 11.2436L19.2844 11.1969C18.6534 11.1626 18.0526 10.704 17.875 10.1641L17.4811 9.20403C17.1964 8.6387 17.2962 7.889 17.7184 7.41784L18.2497 6.82486L17.177 5.7486L16.5834 6.28077C16.112 6.70464 15.36 6.80417 14.8583 6.54705L13.895 6.14702C13.2963 5.94711 12.838 5.34679 12.8032 4.71573L12.7565 3.86037L12.7019 3.85519C12.4943 3.83596 12.2898 3.82307 12.1033 3.81939L12.0503 3.81859L11.9993 3.81832L11.9474 3.8186L11.8936 3.81942C11.7078 3.82316 11.5042 3.83603 11.2975 3.85518L11.2431 3.86035L11.1963 4.71557C11.1619 5.34693 10.7032 5.94745 10.1632 6.12494L9.20452 6.51816C8.63887 6.80395 7.88808 6.7044 7.4175 6.2818L6.82443 5.75043L5.74843 6.82303L6.28134 7.41778C6.70406 7.88946 6.80356 8.63986 6.54663 9.14216L6.14683 10.1044C5.94703 10.7039 5.34628 11.1625 4.71552 11.1969L3.86011 11.2437L3.85496 11.298C3.83587 11.5045 3.82303 11.708 3.81929 11.8936L3.81845 11.9478L3.81818 12L3.81845 12.0517L3.81927 12.1053C3.82299 12.2911 3.83586 12.4947 3.85503 12.7015L3.8602 12.7559L4.71471 12.8028C5.34587 12.8368 5.94635 13.2954 6.12486 13.8357L6.51767 14.7941C6.80349 15.3595 6.70391 16.11 6.28127 16.5821L5.74988 17.1749L6.82261 18.2511L7.41772 17.7178C7.88904 17.2958 8.63861 17.1961 9.1418 17.4526L10.1028 17.8522C10.7033 18.0518 11.1622 18.6535 11.196 19.2843L11.2429 20.1398L11.2971 20.1449Z",
      fill: i
    }));
  },
  show: function show(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M7.99992 3.3335C4.66659 3.3335 2.22214 6.44461 1.33325 8.00016C2.11103 9.55572 4.66659 12.6668 7.99992 12.6668C11.3333 12.6668 13.8888 9.55572 14.6666 8.00016C13.7777 6.44461 11.3333 3.3335 7.99992 3.3335Z",
      stroke: i,
      strokeLinejoin: "round"
    }), l.createElement("path", {
      d: "M9.33341 7.99984C9.33341 8.73622 8.73646 9.33317 8.00008 9.33317C7.2637 9.33317 6.66675 8.73622 6.66675 7.99984C6.66675 7.26346 7.2637 6.6665 8.00008 6.6665",
      stroke: i,
      strokeLinecap: "round"
    }));
  },
  success: function success(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      width: e,
      height: o
    }, a), l.createElement("path", {
      fill: i,
      fillRule: "evenodd",
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
      clipRule: "evenodd"
    }), l.createElement("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M18 9.433L9.502 17 6 13.882l1.453-1.434 2.049 1.825L16.547 8 18 9.433z",
      clipRule: "evenodd"
    }));
  },
  security: function security(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      d: "M3 13C3 11.8954 3.89543 11 5 11H19C20.1046 11 21 11.8954 21 13V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V13Z",
      stroke: i,
      strokeWidth: "2"
    }), l.createElement("path", {
      d: "M16 8C16 8.55228 16.4477 9 17 9C17.5523 9 18 8.55228 18 8H16ZM6 8C6 8.55228 6.44772 9 7 9C7.55228 9 8 8.55228 8 8H6ZM10 16V17H12V16H10ZM8 7C8 4.79086 9.79086 3 12 3V1C8.68629 1 6 3.68629 6 7H8ZM12 3C14.2091 3 16 4.79086 16 7H18C18 3.68629 15.3137 1 12 1V3ZM16 7V8H18V7H16ZM6 7V8H8V7H6ZM12 16V17H14V16H12ZM12 17V19C13.1046 19 14 18.1046 14 17H12ZM12 16H14C14 14.8954 13.1046 14 12 14V16ZM10 17C10 18.1046 10.8954 19 12 19V17H10ZM12 16V14C10.8954 14 10 14.8954 10 16H12Z",
      fill: i
    }));
  },
  team: function team(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: o
    }, a), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.02369 14.43C8.06003 13.8071 9.2588 13.7123 9.98568 13.7123H14.0147C14.7416 13.7123 15.9403 13.8071 16.9767 14.43C18.0732 15.0891 18.8495 16.2539 18.8495 18.1155C18.8495 18.5208 18.4887 18.8493 18.0437 18.8493C17.5986 18.8493 17.2379 18.5208 17.2379 18.1155C17.2379 16.6747 16.6711 16.0049 16.0889 15.6549C15.4465 15.2688 14.6308 15.18 14.0147 15.18H9.98568C9.36956 15.18 8.55383 15.2688 7.91142 15.6549C7.32924 16.0049 6.76248 16.6747 6.76248 18.1155C6.76248 18.5208 6.40171 18.8493 5.95668 18.8493C5.51165 18.8493 5.15088 18.5208 5.15088 18.1155C5.15088 16.2539 5.92712 15.0891 7.02369 14.43Z",
      fill: i
    }), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.0001 10.2877C12.9458 10.2877 13.7124 9.52104 13.7124 8.57535C13.7124 7.62966 12.9458 6.86302 12.0001 6.86302C11.0544 6.86302 10.2878 7.62966 10.2878 8.57535C10.2878 9.52104 11.0544 10.2877 12.0001 10.2877ZM12.0001 12C13.8915 12 15.4247 10.4667 15.4247 8.57535C15.4247 6.68396 13.8915 5.1507 12.0001 5.1507C10.1087 5.1507 8.57544 6.68396 8.57544 8.57535C8.57544 10.4667 10.1087 12 12.0001 12Z",
      fill: i
    }), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.79468 10.0822C6.79468 10.6118 6.36536 11.0411 5.83577 11.0411C5.30619 11.0411 4.87687 10.6118 4.87687 10.0822C4.87687 9.55258 5.30619 9.12327 5.83577 9.12327C6.36536 9.12327 6.79468 9.55258 6.79468 10.0822ZM7.75358 10.0822C7.75358 11.1413 6.89495 12 5.83577 12C4.7766 12 3.91797 11.1413 3.91797 10.0822C3.91797 9.023 4.7766 8.16437 5.83577 8.16437C6.89495 8.16437 7.75358 9.023 7.75358 10.0822ZM4.70773 12.9589C4.30068 12.9589 3.62937 13.0119 3.04902 13.3608C2.43494 13.7299 2.00024 14.3821 2.00024 15.4246C2.00024 15.6516 2.20227 15.8356 2.45149 15.8356C2.70071 15.8356 2.90274 15.6516 2.90274 15.4246C2.90274 14.6178 3.22013 14.422 3.54615 14.226C3.9059 14.0098 4.3627 13.9601 4.70773 13.9601H6.31871C6.9477 13.5286 7.61017 13.2915 8.21345 13.1645C7.7484 12.9904 7.2777 12.9589 6.96397 12.9589H4.70773ZM17.6816 13.9601C17.0526 13.5286 16.3901 13.2915 15.7868 13.1646C16.2519 12.9904 16.7226 12.9589 17.0363 12.9589H19.2925C19.6996 12.9589 20.3709 13.0119 20.9513 13.3608C21.5653 13.7299 22 14.3821 22 15.4246C22 15.6516 21.798 15.8356 21.5488 15.8356C21.2996 15.8356 21.0975 15.6516 21.0975 15.4246C21.0975 14.6178 20.7802 14.422 20.4541 14.226C20.0944 14.0098 19.6376 13.9601 19.2925 13.9601H17.6816ZM19.1233 10.0822C19.1233 10.6118 18.6939 11.0411 18.1644 11.0411C17.6348 11.0411 17.2054 10.6118 17.2054 10.0822C17.2054 9.55259 17.6348 9.12328 18.1644 9.12328C18.6939 9.12328 19.1233 9.55259 19.1233 10.0822ZM20.0822 10.0822C20.0822 11.1414 19.2235 12 18.1644 12C17.1052 12 16.2465 11.1414 16.2465 10.0822C16.2465 9.02301 17.1052 8.16438 18.1644 8.16438C19.2235 8.16438 20.0822 9.02301 20.0822 10.0822Z",
      fill: i
    }));
  },
  rectangle: function rectangle(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("g", null, l.createElement("rect", {
      x: "3",
      y: "3",
      width: "18",
      height: "18",
      stroke: i,
      strokeWidth: "2"
    })));
  },
  warning: function warning(n) {
    var e = n.width,
        o = n.height,
        i = n.color,
        a = t(n, ["width", "height", "color"]);
    return l.createElement("svg", r({
      width: e,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, a), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
      fill: i
    }), l.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.9614 5.75H11.0386L11.1489 14.7423H12.8511L12.9614 5.75ZM12 15.5346C11.276 15.5346 10.75 16.1558 10.75 16.8923C10.75 17.6288 11.276 18.25 12 18.25C12.724 18.25 13.25 17.6288 13.25 16.8923C13.25 16.1558 12.724 15.5346 12 15.5346Z",
      fill: "white"
    }));
  }
},
    ee = h(function (n) {
  var e = n.name,
      o = n.size,
      i = n.color,
      a = void 0 === i ? "var(--gray400)" : i,
      c = n.width,
      d = n.height,
      s = n.style,
      h = void 0 === s ? {} : s,
      p = t(n, ["name", "size", "color", "width", "height", "style"]),
      u = ne[e],
      g = o || d || 24,
      f = o || c || 24;
  return l.createElement(u, r({
    role: "img",
    "aria-label": e + " icon",
    width: f,
    height: g,
    color: a,
    style: r(r({}, h), {
      cursor: p.onClick ? "pointer" : "inherit"
    })
  }, p));
}),
    te = "\n    pointer-events: none;\n    opacity: 0.5;\n  ",
    re = v.input(jn || (jn = e(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  margin: 0;\n  cursor: pointer;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  margin: 0;\n  cursor: pointer;\n"]))),
    oe = v.label(In || (In = e(["\n  font-family: Inter;\n  font-size: 14px;\n  color: var(--gray400);\n  margin: 0 8px 0 12px;\n"], ["\n  font-family: Inter;\n  font-size: 14px;\n  color: var(--gray400);\n  margin: 0 8px 0 12px;\n"]))),
    ie = v.div(Sn || (Sn = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.disabled;
  return b(Wn || (Wn = e(["\n    display: inline-flex;\n    align-items: center;\n    position: relative;\n    height: 40px;\n    padding: 4px 0;\n    box-sizing: border-box;\n    user-select: none;\n    ", "\n  "], ["\n    display: inline-flex;\n    align-items: center;\n    position: relative;\n    height: 40px;\n    padding: 4px 0;\n    box-sizing: border-box;\n    user-select: none;\n    ", "\n  "])), t && te);
}),
    ae = h(l.forwardRef(function (e, o) {
  var i = e.id,
      a = e.label,
      c = void 0 === a ? "" : a,
      d = e.name,
      s = e.checked,
      h = e.defaultChecked,
      p = e.disabled,
      u = void 0 !== p && p,
      g = e.indeterminate,
      f = void 0 !== g && g,
      m = e.color,
      v = e.size,
      x = void 0 === v ? 32 : v,
      b = e.onChange,
      C = t(e, ["id", "label", "name", "checked", "defaultChecked", "disabled", "indeterminate", "color", "size", "onChange"]),
      w = n(on({
    controlled: s,
    defaultState: h
  }), 2),
      k = w[0],
      L = w[1];
  return l.createElement(ie, {
    disabled: u
  }, l.createElement(re, r({}, C, {
    type: "checkbox",
    ref: o,
    name: d,
    id: i,
    defaultChecked: h,
    disabled: u,
    onChange: function onChange(n) {
      b && b(n), L(n.target.checked);
    }
  })), f ? l.createElement(ee, {
    name: "checkbox-indeterminate",
    size: x,
    color: m || "var(--checkbox-indeterminate-color)"
  }) : l.createElement(ee, {
    name: "checkbox-" + (k ? "on" : "off"),
    size: x,
    color: m || "var(--checkbox-color)"
  }), c && l.createElement(oe, {
    htmlFor: i
  }, c));
})),
    le = v.div(Dn || (Dn = e(["\n  display: inline-block;\n  position: relative;\n  padding: ", "px;\n  width: 100%;\n  max-width: var(--container-box-max-width);\n  min-height: 60px;\n  border-radius: var(--container-box-border-radius);\n  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08);\n  background-color: var(--container-box-background-color);\n  color: var(--container-box-text-color);\n"], ["\n  display: inline-block;\n  position: relative;\n  padding: ", "px;\n  width: 100%;\n  max-width: var(--container-box-max-width);\n  min-height: 60px;\n  border-radius: var(--container-box-border-radius);\n  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08);\n  background-color: var(--container-box-background-color);\n  color: var(--container-box-text-color);\n"])), 20),
    ce = h(function (n) {
  var e = n.children,
      o = t(n, ["children"]);
  return l.createElement(le, r({}, o), e);
}),
    de = function de(n) {
  var e = n.value,
      t = n.finalLength,
      r = void 0 === t ? 2 : t;
  return e.toString().padStart(r, "0");
},
    se = function se(n) {
  var e = n.getDate(),
      t = n.getMonth() + 1,
      r = n.getFullYear();
  return {
    day: e,
    month: t,
    year: r,
    formatted: de({
      value: e
    }) + "/" + de({
      value: t
    }) + "/" + r
  };
},
    he = v.div(An || (An = e(["\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-evenly;\n  flex-flow: row nowrap;\n  margin-top: 10px;\n"], ["\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-evenly;\n  flex-flow: row nowrap;\n  margin-top: 10px;\n"]))),
    pe = v.div(Tn || (Tn = e(["\n  display: flex;\n  position: relative;\n  align-items: center;\n"], ["\n  display: flex;\n  position: relative;\n  align-items: center;\n"]))),
    ue = v(pe)(Pn || (Pn = e(["\n  & > span:first-child {\n    margin-right: 5px;\n  }\n"], ["\n  & > span:first-child {\n    margin-right: 5px;\n  }\n"]))),
    ge = v.span(Yn || (Yn = e(["\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 24px;\n  color: var(--datepicker-month-and-year-text-color);\n"], ["\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 24px;\n  color: var(--datepicker-month-and-year-text-color);\n"]))),
    fe = v.div(Fn || (Fn = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.optionsLength;
  return b(_n || (_n = e(["\n    position: absolute;\n    top: 0;\n    width: 100px;\n    height: ", ";\n    background: white;\n    z-index: var(--zIndexMaximum);\n  "], ["\n    position: absolute;\n    top: 0;\n    width: 100px;\n    height: ", ";\n    background: white;\n    z-index: var(--zIndexMaximum);\n  "])), t > 11 ? "297px" : 27 * t + "px");
}),
    me = v.div(Nn || (Nn = e(["\n  position: relative;\n  display: flex-box;\n  flex-flow: column wrap;\n  overflow-y: scroll;\n  width: 100%;\n  height: 100%;\n  background-color: var(--datepicker-year-select-background-color);\n  border-radius: var(--datepicker-year-select-border-radius);\n  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08);\n"], ["\n  position: relative;\n  display: flex-box;\n  flex-flow: column wrap;\n  overflow-y: scroll;\n  width: 100%;\n  height: 100%;\n  background-color: var(--datepicker-year-select-background-color);\n  border-radius: var(--datepicker-year-select-border-radius);\n  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08);\n"]))),
    ve = v.span(On || (On = e(["\n  width: 100%;\n  font-size: 0.8rem;\n  color: var(--datepicker-year-select-text-color);\n  height: 27px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  width: 100%;\n  font-size: 0.8rem;\n  color: var(--datepicker-year-select-text-color);\n  height: 27px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]))),
    xe = v.div(Gn || (Gn = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.isRangeDate,
      r = n.popUpOpened;
  return b(Xn || (Xn = e(["\n    display: flex;\n    position: relative;\n\n    ", "\n\n    .react-datepicker {\n      ", "\n\n      border: none;\n      display: flex;\n      flex-flow: column wrap;\n\n      &__header {\n        background-color: transparent;\n        border: none;\n      }\n\n      &__day-names {\n        margin-top: 8px;\n\n        .react-datepicker__day-name {\n          text-transform: capitalize;\n          font-family: Inter;\n          font-style: normal;\n          font-weight: normal;\n          font-size: var(--datepicker-day-names-font-size);\n          line-height: 18px;\n          color: var(--datepicker-day-names-text-color);\n        }\n\n        > div:first-child,\n        > div:nth-child(7) {\n          color: var(--datepicker-weekend-text-color);\n        }\n      }\n\n      &__month {\n        .react-datepicker__week {\n          height: 40px;\n          border-bottom: 0.5px solid var(--datepicker-week-border-color);\n          display: flex;\n          justify-content: center;\n          align-items: center;\n\n          .react-datepicker__day {\n            z-index: 0;\n            color: var(--datepicker-day-text-color);\n\n            &:hover {\n              background-color: transparent;\n            }\n\n            &--keyboard-selected {\n              color: var(--datepicker-current-day-text-color);\n              background-color: transparent;\n            }\n\n            &--selected {\n              position: relative;\n              background-color: transparent;\n              border-radius: 0;\n              color: var(--datepicker-selected-day-text-color) !important;\n\n              &:before {\n                content: ' ' !important;\n              }\n\n              &:after {\n                position: absolute;\n                content: ' ';\n                height: 28px;\n                width: 28px;\n                border-radius: 50%;\n                z-index: -1;\n                left: 0;\n                top: 0;\n                background: var(--datepicker-selected-range-background-color);\n              }\n            }\n\n            &--today {\n              position: relative;\n              color: var(--datepicker-current-day-text-color);\n              font-weight: normal;\n\n              &:before {\n                content: 'HOJE';\n                position: absolute;\n                top: -4px;\n                left: 4px;\n                color: var(--datepicker-current-day-text-color);\n                font-family: Inter;\n                font-style: normal;\n                font-weight: normal;\n                font-size: 8px;\n                line-height: 12px;\n              }\n            }\n\n            &.react-datepicker__day--in-selecting-range {\n              background-color: transparent !important;\n              position: relative;\n\n              &:before {\n                position: absolute;\n                content: ' ';\n                height: 28px;\n                width: 33px;\n                z-index: -1;\n                left: -3px;\n                top: 0;\n                background-color: var(\n                  --datepicker-range-in-selection-background-color\n                );\n              }\n            }\n\n            &--in-range {\n              position: relative;\n              border-radius: 0;\n              background-color: transparent;\n              color: var(--datepicker-range-in-range-text-color);\n\n              &:before {\n                position: absolute;\n                content: ' ';\n                height: 28px;\n                width: 33px;\n                z-index: -1;\n                left: -3px;\n                top: 0;\n                background-color: var(\n                  --datepicker-range-in-selection-background-color\n                );\n              }\n\n              &.react-datepicker__day--outside-month {\n                &:before {\n                  opacity: 0;\n                }\n              }\n            }\n\n            &--range-end {\n              &:before {\n                left: -6px;\n                background-color: var(\n                  --datepicker-range-in-selection-background-color\n                );\n                border-radius: 0 40% 40% 0;\n              }\n            }\n\n            &--range-start {\n              &:before {\n                right: -6px;\n                background-color: var(\n                  --datepicker-range-in-selection-background-color\n                );\n                border-radius: 40% 0 0 40%;\n                top: 0;\n                left: 0;\n              }\n            }\n\n            &--weekend,\n            &--disabled {\n              color: var(--datepicker-disabled-text-color);\n            }\n\n            &--outside-month {\n              pointer-events: none;\n              color: transparent !important;\n              margin: 0;\n              width: 33.5px;\n              border-bottom: 15px var(--datepicker-background-color) solid;\n              border-radius: 0;\n\n              &:before,\n              &:after {\n                background-color: transparent !important;\n                background: transparent !important;\n              }\n            }\n          }\n        }\n\n        > div:last-child {\n          border: none;\n        }\n      }\n    }\n  "], ["\n    display: flex;\n    position: relative;\n\n    ", "\n\n    .react-datepicker {\n      ", "\n\n      border: none;\n      display: flex;\n      flex-flow: column wrap;\n\n      &__header {\n        background-color: transparent;\n        border: none;\n      }\n\n      &__day-names {\n        margin-top: 8px;\n\n        .react-datepicker__day-name {\n          text-transform: capitalize;\n          font-family: Inter;\n          font-style: normal;\n          font-weight: normal;\n          font-size: var(--datepicker-day-names-font-size);\n          line-height: 18px;\n          color: var(--datepicker-day-names-text-color);\n        }\n\n        > div:first-child,\n        > div:nth-child(7) {\n          color: var(--datepicker-weekend-text-color);\n        }\n      }\n\n      &__month {\n        .react-datepicker__week {\n          height: 40px;\n          border-bottom: 0.5px solid var(--datepicker-week-border-color);\n          display: flex;\n          justify-content: center;\n          align-items: center;\n\n          .react-datepicker__day {\n            z-index: 0;\n            color: var(--datepicker-day-text-color);\n\n            &:hover {\n              background-color: transparent;\n            }\n\n            &--keyboard-selected {\n              color: var(--datepicker-current-day-text-color);\n              background-color: transparent;\n            }\n\n            &--selected {\n              position: relative;\n              background-color: transparent;\n              border-radius: 0;\n              color: var(--datepicker-selected-day-text-color) !important;\n\n              &:before {\n                content: ' ' !important;\n              }\n\n              &:after {\n                position: absolute;\n                content: ' ';\n                height: 28px;\n                width: 28px;\n                border-radius: 50%;\n                z-index: -1;\n                left: 0;\n                top: 0;\n                background: var(--datepicker-selected-range-background-color);\n              }\n            }\n\n            &--today {\n              position: relative;\n              color: var(--datepicker-current-day-text-color);\n              font-weight: normal;\n\n              &:before {\n                content: 'HOJE';\n                position: absolute;\n                top: -4px;\n                left: 4px;\n                color: var(--datepicker-current-day-text-color);\n                font-family: Inter;\n                font-style: normal;\n                font-weight: normal;\n                font-size: 8px;\n                line-height: 12px;\n              }\n            }\n\n            &.react-datepicker__day--in-selecting-range {\n              background-color: transparent !important;\n              position: relative;\n\n              &:before {\n                position: absolute;\n                content: ' ';\n                height: 28px;\n                width: 33px;\n                z-index: -1;\n                left: -3px;\n                top: 0;\n                background-color: var(\n                  --datepicker-range-in-selection-background-color\n                );\n              }\n            }\n\n            &--in-range {\n              position: relative;\n              border-radius: 0;\n              background-color: transparent;\n              color: var(--datepicker-range-in-range-text-color);\n\n              &:before {\n                position: absolute;\n                content: ' ';\n                height: 28px;\n                width: 33px;\n                z-index: -1;\n                left: -3px;\n                top: 0;\n                background-color: var(\n                  --datepicker-range-in-selection-background-color\n                );\n              }\n\n              &.react-datepicker__day--outside-month {\n                &:before {\n                  opacity: 0;\n                }\n              }\n            }\n\n            &--range-end {\n              &:before {\n                left: -6px;\n                background-color: var(\n                  --datepicker-range-in-selection-background-color\n                );\n                border-radius: 0 40% 40% 0;\n              }\n            }\n\n            &--range-start {\n              &:before {\n                right: -6px;\n                background-color: var(\n                  --datepicker-range-in-selection-background-color\n                );\n                border-radius: 40% 0 0 40%;\n                top: 0;\n                left: 0;\n              }\n            }\n\n            &--weekend,\n            &--disabled {\n              color: var(--datepicker-disabled-text-color);\n            }\n\n            &--outside-month {\n              pointer-events: none;\n              color: transparent !important;\n              margin: 0;\n              width: 33.5px;\n              border-bottom: 15px var(--datepicker-background-color) solid;\n              border-radius: 0;\n\n              &:before,\n              &:after {\n                background-color: transparent !important;\n                background: transparent !important;\n              }\n            }\n          }\n        }\n\n        > div:last-child {\n          border: none;\n        }\n      }\n    }\n  "])), t && r ? "\n      background-color: var(--datepicker-background-color);\n      border-radius: var(--datepicker-border-radius);\n      box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08);\n    " : "", t ? "" : "\n      background-color: var(--datepicker-background-color);\n      border-radius: var(--datepicker-border-radius);\n\n      box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08);\n      ");
}),
    be = v(k)(Un || (Un = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.isRightSide;
  return b(Jn || (Jn = e(["\n    margin-left: ", ";\n  "], ["\n    margin-left: ", ";\n  "])), t ? "16px" : "0");
}),
    Ce = v.div(Kn || (Kn = e(["\n  display: flex;\n  justify-content: flex-end;\n  margin: 8px 0;\n  padding: 0 9px;\n\n  button {\n    font-weight: bold;\n  }\n\n  > button:first-child {\n    color: var(--datepicker-clear-text-color);\n  }\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  margin: 8px 0;\n  padding: 0 9px;\n\n  button {\n    font-weight: bold;\n  }\n\n  > button:first-child {\n    color: var(--datepicker-clear-text-color);\n  }\n"]))),
    we = function we(n) {
  var e = n.onClearClick,
      t = n.onApplyClick;
  return n.visible ? l.createElement(Ce, null, l.createElement(Vn, {
    variant: "link",
    onClick: e
  }, "LIMPAR"), l.createElement(Vn, {
    variant: "link",
    onClick: t
  }, "APLICAR")) : null;
},
    ke = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
    Le = function Le(e) {
  var t = e.month,
      r = e.year,
      o = e.minYear,
      i = e.maxYear,
      a = e.changeYear,
      s = e.updateDate,
      h = n(c(!1), 2),
      g = h[0],
      f = h[1],
      m = p(null);
  an(m, function () {
    return g && f(!1);
  });
  var v = new Date().getFullYear(),
      x = o || v - 10,
      b = i || v + 10,
      C = u(function () {
    for (var n = [], e = function e(_e2) {
      n.push(l.createElement(ve, {
        key: _e2,
        "data-testid": "year-option-" + _e2,
        onClick: function onClick() {
          f(!1), a(_e2), s(new Date(r, t, 1));
        }
      }, _e2));
    }, o = b; o >= x; o -= 1) {
      e(o);
    }

    return n;
  }, [x, b]),
      w = d(function () {
    C.length && f(!0);
  }, [C]);
  return l.createElement(pe, null, g && l.createElement(fe, {
    optionsLength: C.length,
    ref: m
  }, l.createElement(me, null, C)), l.createElement(ge, {
    onClick: w
  }, r), l.createElement(ee, {
    name: "arrow-down",
    onClick: w
  }));
};

Le.defaultProps = {
  minYear: null,
  maxYear: null
};

var ye = function ye(n) {
  var e = n.date,
      t = n.decreaseMonth,
      r = n.increaseMonth,
      o = n.changeYear,
      i = n.updateDate,
      a = n.minYear,
      c = n.maxYear,
      d = ke[e.getMonth()];
  return l.createElement(he, {
    "data-testid": "datepicker-header"
  }, l.createElement(ee, {
    name: "arrow-left",
    onClick: t
  }), l.createElement(ue, null, l.createElement(ge, null, d + " "), l.createElement(Le, {
    changeYear: o,
    updateDate: i,
    month: e.getMonth(),
    year: e.getFullYear(),
    minYear: a,
    maxYear: c
  })), l.createElement(ee, {
    name: "arrow-right",
    onClick: r
  }));
};

ye.defaultProps = {
  minYear: null,
  maxYear: null
};

var Me,
    Ee,
    Ze,
    Ve,
    He,
    ze,
    Be,
    Re,
    je,
    Ie,
    We,
    Se,
    De,
    Ae,
    Te,
    Pe,
    Ye,
    _e,
    Fe,
    Ne,
    Oe,
    Xe,
    Ge = function Ge() {
  return b(Me || (Me = e(["\n    color: var(--input-success-label-text-color);\n  "], ["\n    color: var(--input-success-label-text-color);\n  "])));
},
    Je = function Je() {
  return b(Ee || (Ee = e(["\n    color: var(--input-error-label-text-color);\n  "], ["\n    color: var(--input-error-label-text-color);\n  "])));
},
    Ue = function Ue() {
  return b(Ze || (Ze = e(["\n    color: var(--input-disabled-label-text-color);\n  "], ["\n    color: var(--input-disabled-label-text-color);\n  "])));
},
    Ke = function Ke() {
  return b(Ve || (Ve = e(["\n    background-color: var(--input-success-input-background-color);\n  "], ["\n    background-color: var(--input-success-input-background-color);\n  "])));
},
    qe = function qe() {
  return b(He || (He = e(["\n    background-color: var(--input-error-input-background-color);\n  "], ["\n    background-color: var(--input-error-input-background-color);\n  "])));
},
    $e = v.div(ze || (ze = e(["\n  display: flex;\n  margin-bottom: 4px;\n"], ["\n  display: flex;\n  margin-bottom: 4px;\n"]))),
    Qe = v.label(Re || (Re = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.error,
      r = n.success,
      o = n.disabled;
  return b(Be || (Be = e(["\n    font-size: var(--input-label-font-size);\n    line-height: 16px;\n    margin-right: auto;\n    margin-top: auto;\n    margin-bottom: 0;\n    font-family: Inter;\n    color: var(--input-label-text-color);\n    ", "\n    ", "\n    ", "\n  "], ["\n    font-size: var(--input-label-font-size);\n    line-height: 16px;\n    margin-right: auto;\n    margin-top: auto;\n    margin-bottom: 0;\n    font-family: Inter;\n    color: var(--input-label-text-color);\n    ", "\n    ", "\n    ", "\n  "])), t && Je(), r && Ge(), o && Ue());
}),
    nt = v.div(Ie || (Ie = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.error,
      r = n.success,
      o = n.disabled;
  return b(je || (je = e(["\n    height: 40px;\n    background: var(--gray100);\n    border-radius: var(--radiiMd);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: relative;\n    ", "\n    ", "\n  "], ["\n    height: 40px;\n    background: var(--gray100);\n    border-radius: var(--radiiMd);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: relative;\n    ", "\n    ", "\n  "])), t && !o && qe(), r && !o && Ke());
}),
    et = function et() {
  return b(We || (We = e(["\n  font-family: Inter;\n  font-weight: bold;\n  font-size: var(--input-placeholder-font-size);\n  color: var(--input-placeholder-text-color);\n"], ["\n  font-family: Inter;\n  font-weight: bold;\n  font-size: var(--input-placeholder-font-size);\n  color: var(--input-placeholder-text-color);\n"])));
},
    tt = function tt(n) {
  var t = n.hasIconRight,
      r = n.hasIconLeft;
  return b(Se || (Se = e(["\n  background: transparent;\n  flex: 1;\n  height: 100%;\n  padding: 8px 16px;\n  font-size: var(--input-font-size);\n  font-family: Inter;\n\n  ", "\n  ", "\n"], ["\n  background: transparent;\n  flex: 1;\n  height: 100%;\n  padding: 8px 16px;\n  font-size: var(--input-font-size);\n  font-family: Inter;\n\n  ", "\n  ", "\n"])), t && "padding-right: 8px;", r && "padding-left: 8px;");
},
    rt = v.input(Ae || (Ae = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.hasIconRight,
      r = n.hasIconLeft;
  return b(De || (De = e(["\n    ", "\n\n    ::-webkit-input-placeholder {\n      ", "\n    }\n\n    :-ms-input-placeholder {\n      ", "\n    }\n\n    ::placeholder {\n      ", "\n    }\n\n    ::-webkit-outer-spin-button,\n    ::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n\n    [type='number'] {\n      -moz-appearance: textfield;\n    }\n  "], ["\n    ", "\n\n    ::-webkit-input-placeholder {\n      ", "\n    }\n\n    :-ms-input-placeholder {\n      ", "\n    }\n\n    ::placeholder {\n      ", "\n    }\n\n    ::-webkit-outer-spin-button,\n    ::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n\n    [type='number'] {\n      -moz-appearance: textfield;\n    }\n  "])), tt({
    hasIconLeft: r,
    hasIconRight: t
  }), et(), et(), et());
}),
    ot = v(ee)(Pe || (Pe = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.$hasClickHandler;
  return b(Te || (Te = e(["\n    &&& {\n      cursor: ", ";\n    }\n  "], ["\n    &&& {\n      cursor: ", ";\n    }\n  "])), t ? "pointer" : "inherit");
}),
    it = v.div(Ye || (Ye = e(["\n  padding: 8px 0 8px 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  padding: 8px 0 8px 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]))),
    at = v.div(_e || (_e = e(["\n  padding: 8px 8px 8px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  padding: 8px 8px 8px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]))),
    lt = v.span(Ne || (Ne = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.error,
      r = n.success,
      o = n.disabled;
  return b(Fe || (Fe = e(["\n    font-family: Inter;\n    font-size: var(--input-info-font-size);\n    text-align: right;\n    line-height: 16px;\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    color: var(--input-info-text-color);\n    ", "\n    ", "\n    ", "\n  "], ["\n    font-family: Inter;\n    font-size: var(--input-info-font-size);\n    text-align: right;\n    line-height: 16px;\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    color: var(--input-info-text-color);\n    ", "\n    ", "\n    ", "\n  "])), t && Je(), r && Ge(), o && Ue());
}),
    ct = v.div(Xe || (Xe = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.disabled;
  return b(Oe || (Oe = e(["\n    display: inline-flex;\n    flex-direction: column;\n    position: relative;\n    padding-bottom: 20px;\n    ", "\n  "], ["\n    display: inline-flex;\n    flex-direction: column;\n    position: relative;\n    padding-bottom: 20px;\n    ", "\n  "])), t && "pointer-events: none;");
}),
    dt = function dt(n, e, t) {
  var r = n;
  return "string" == typeof n && Object.keys(ne).includes(n) && (r = l.createElement(ot, {
    name: n,
    size: 24,
    $hasClickHandler: Boolean(t)
  })), l.createElement(e, {
    onClick: t
  }, r);
},
    st = l.forwardRef(function (n, e) {
  var o = n.id,
      i = n.disabled,
      a = void 0 !== i && i,
      c = n.error,
      d = void 0 !== c && c,
      s = n.helper,
      h = n.iconLeft,
      p = n.iconRight,
      u = n.infoText,
      g = n.label,
      f = n.name,
      m = n.placeholder,
      v = n.readOnly,
      x = void 0 !== v && v,
      b = n.success,
      C = void 0 !== b && b,
      w = n.type,
      k = void 0 === w ? "text" : w,
      L = n.className,
      y = n.style,
      M = n.dataTestId,
      E = void 0 === M ? "" : M,
      Z = n.onClickIconLeft,
      V = n.onClickIconRight,
      H = t(n, ["id", "disabled", "error", "helper", "iconLeft", "iconRight", "infoText", "label", "name", "placeholder", "readOnly", "success", "type", "className", "style", "dataTestId", "onClickIconLeft", "onClickIconRight"]);
  return l.createElement(ct, {
    disabled: a,
    className: L,
    style: y,
    "data-testid": E || o
  }, (g || s) && l.createElement($e, null, l.createElement(Qe, {
    htmlFor: o,
    error: d,
    success: C,
    disabled: a,
    "data-testid": (E || o) + "_input-label"
  }, g), s && l.createElement("span", {
    "data-testid": (E || o) + "_input-helper"
  }, s)), l.createElement(nt, {
    error: d,
    success: C,
    disabled: a
  }, h && dt(h, it, Z), l.createElement(rt, r({
    id: o,
    name: f,
    type: k,
    placeholder: m,
    disabled: a,
    hasIconRight: Boolean(p),
    hasIconLeft: Boolean(h),
    readOnly: x,
    ref: e
  }, H)), p && dt(p, at, V)), u && l.createElement(lt, {
    error: d,
    success: C,
    disabled: a,
    "data-testid": (E || o) + "_input-info"
  }, u));
}),
    ht = h(l.forwardRef(function (e, o) {
  var i = e.mask,
      a = e.maskPlaceholder,
      c = void 0 === a ? null : a,
      s = e.disabled,
      h = e.value,
      p = e.defaultValue,
      u = e.onChange,
      g = e.onInput,
      f = e.onBlur,
      m = e.onlyNumber,
      v = void 0 !== m && m,
      x = t(e, ["mask", "maskPlaceholder", "disabled", "value", "defaultValue", "onChange", "onInput", "onBlur", "onlyNumber"]),
      b = n(on({
    controlled: h,
    defaultState: p
  }), 2),
      C = b[0],
      w = b[1],
      k = d(function (n) {
    return function (e) {
      var t = e.target;
      !0 === v && (t.value = t.value.replace(/\D/g, "")), t.value !== C && (w(t.value), null == n || n(e));
    };
  }, [v, w, C]);
  return i ? l.createElement(M, {
    mask: i,
    maskPlaceholder: c,
    defaultValue: C,
    disabled: s,
    onBlur: f,
    onChange: k(u),
    onInput: k(g)
  }, l.createElement(st, r({
    disabled: s,
    ref: o
  }, x))) : l.createElement(st, r({
    defaultValue: C,
    disabled: s,
    onBlur: f,
    onChange: k(u),
    onInput: k(g),
    ref: o
  }, x));
}));

L("pt-BR", y);

var pt,
    ut,
    gt,
    ft,
    mt,
    vt,
    xt,
    bt,
    Ct,
    wt,
    kt,
    Lt,
    yt,
    Mt,
    Et,
    Zt,
    Vt = h(l.forwardRef(function (e, o) {
  var i = e.name,
      a = e.value,
      h = e.startDate,
      g = e.endDate,
      f = e.disabled,
      m = void 0 !== f && f,
      v = e.onChange,
      x = e.onStartDateChange,
      b = e.onEndDateChange,
      C = e.className,
      w = e.isRangeDate,
      k = e.footer,
      L = void 0 === k || k,
      y = e.minDate,
      M = e.maxDate,
      E = t(e, ["name", "value", "startDate", "endDate", "disabled", "onChange", "onStartDateChange", "onEndDateChange", "className", "isRangeDate", "footer", "minDate", "maxDate"]),
      Z = p(),
      V = n(c(!1), 2),
      H = V[0],
      z = V[1],
      B = p(),
      R = p(),
      j = p(),
      I = n(c(w ? void 0 : h || a), 2),
      W = I[0],
      S = I[1],
      D = n(c(g), 2),
      A = D[0],
      T = D[1];
  s(function () {
    a !== Z.current && (Z.current = a, S(a));
  }, [a, W]);

  var P = u(function () {
    return Boolean(g || w);
  }, [g, w]),
      Y = l.forwardRef(function (n, e) {
    var o = n.value,
        i = t(n, ["value"]);
    return l.createElement(ht, r({
      defaultValue: o,
      ref: e
    }, i, {
      readOnly: !0
    }));
  }),
      _ = d(function (n) {
    return n ? se(n).formatted : "";
  }, []),
      F = d(function () {
    var n, e, t, r;
    null === (e = null === (n = null == R ? void 0 : R.current) || void 0 === n ? void 0 : n.setOpen) || void 0 === e || e.call(n, !1), null === (r = null === (t = null == j ? void 0 : j.current) || void 0 === t ? void 0 : t.setOpen) || void 0 === r || r.call(t, !1), z(!1);
  }, []);

  an(B, F);
  var N = d(function () {
    var n, e, t, r;
    P && (z(!0), null === (e = null === (n = null == R ? void 0 : R.current) || void 0 === n ? void 0 : n.setOpen) || void 0 === e || e.call(n, !0), null === (r = null === (t = null == j ? void 0 : j.current) || void 0 === t ? void 0 : t.setOpen) || void 0 === r || r.call(t, !0));
  }, [P]),
      O = d(function () {
    P && (null == x || x(W), null == b || b(A)), null == v || v(W), F();
  }, [v, x, b, W, A, P, F]);
  return l.createElement(xe, {
    isRangeDate: P,
    popUpOpened: H,
    ref: function ref(n) {
      n && (B.current = n);
    }
  }, l.createElement("input", {
    ref: o,
    style: {
      display: "none"
    },
    value: P ? JSON.stringify({
      startDate: _(W),
      endDate: _(A)
    }) : _(W),
    onChange: function onChange() {}
  }), l.createElement(be, {
    showPopperArrow: !1,
    selectsStart: P,
    name: A ? i + "-start" : i,
    selected: W,
    disabled: m,
    onChange: function onChange(n) {
      var e;
      S(n), !L && (null == v || v(n)), !P && !L && (null === (e = R.current) || void 0 === e || e.setOpen(!1));
    },
    locale: "pt-BR",
    dateFormat: "P",
    ref: function ref(n) {
      n && (R.current = n);
    },
    wrapperClassName: C,
    customInput: l.createElement(Y, r({}, E)),
    shouldCloseOnSelect: P,
    renderCustomHeader: function renderCustomHeader(n) {
      return l.createElement(ye, r({}, n, {
        minYear: null == y ? void 0 : y.getFullYear(),
        maxYear: null == M ? void 0 : M.getFullYear(),
        updateDate: S
      }));
    },
    formatWeekDay: function formatWeekDay(n) {
      return n.substring(0, 1);
    },
    onCalendarOpen: N,
    startDate: W,
    endDate: A,
    inline: H,
    minDate: y,
    maxDate: P ? void 0 : M
  }, l.createElement(we, {
    onClearClick: function onClearClick() {
      S(void 0), null == v || v(void 0);
    },
    onApplyClick: O,
    visible: !P && L
  })), P && l.createElement(be, {
    isRightSide: !0,
    showPopperArrow: !1,
    name: i + "-end",
    selectsEnd: !0,
    selected: A,
    disabled: m,
    onChange: function onChange(n) {
      return T(n);
    },
    ref: function ref(n) {
      n && (j.current = n);
    },
    locale: "pt-BR",
    dateFormat: "P",
    wrapperClassName: C,
    customInput: l.createElement(Y, r({}, E)),
    startDate: W,
    endDate: A,
    minDate: W,
    onCalendarOpen: N,
    formatWeekDay: function formatWeekDay(n) {
      return n.substring(0, 1);
    },
    renderCustomHeader: function renderCustomHeader(n) {
      return l.createElement(ye, r({}, n, {
        updateDate: T,
        minYear: null == y ? void 0 : y.getFullYear(),
        maxYear: null == M ? void 0 : M.getFullYear()
      }));
    },
    inline: H,
    maxDate: M
  }, l.createElement(we, {
    onClearClick: function onClearClick() {
      S(void 0), T(void 0), null == v || v(), null == x || x(), null == b || b();
    },
    onApplyClick: O,
    visible: L
  })));
})),
    Ht = v.footer(pt || (pt = e(["\n  border-top: 0.5px solid var(--footer-border-color);\n  width: calc(100% + ", "px);\n  padding: 32px ", "px 8px;\n  margin-top: ", "px;\n  display: flex;\n  justify-content: flex-end;\n\n  > button + button {\n    margin-left: 16px;\n  }\n"], ["\n  border-top: 0.5px solid var(--footer-border-color);\n  width: calc(100% + ", "px);\n  padding: 32px ", "px 8px;\n  margin-top: ", "px;\n  display: flex;\n  justify-content: flex-end;\n\n  > button + button {\n    margin-left: 16px;\n  }\n"])), 20, 20, 40),
    zt = h(function (n) {
  var e = n.children,
      o = t(n, ["children"]);
  return l.createElement(Ht, r({}, o), e);
}),
    Bt = v.header(ut || (ut = e(["\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 0.5px solid var(--header-border-color);\n  padding-bottom: 8px;\n  margin-bottom: 16px;\n  width: calc(100% + ", "px);\n\n  h2 {\n    font-size: var(--header-title-font-size);\n    color: var(--header-title-text-color);\n    font-weight: 600;\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 0.5px solid var(--header-border-color);\n  padding-bottom: 8px;\n  margin-bottom: 16px;\n  width: calc(100% + ", "px);\n\n  h2 {\n    font-size: var(--header-title-font-size);\n    color: var(--header-title-text-color);\n    font-weight: 600;\n  }\n"])), 20),
    Rt = v.ol(gt || (gt = e(["\n  display: flex;\n  align-items: center;\n  list-style: none;\n  padding: 0 ", "px 0 0;\n  margin: 0;\n"], ["\n  display: flex;\n  align-items: center;\n  list-style: none;\n  padding: 0 ", "px 0 0;\n  margin: 0;\n"])), 20),
    jt = v.li(mt || (mt = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.isCurrentStep;
  return b(ft || (ft = e(["\n    font-size: 12px;\n    width: 24px;\n    height: 24px;\n    margin-left: 8px;\n    border: 2px solid var(--header-step-border-color);\n    text-align: center;\n    background: ", ";\n    border-radius: 50%;\n    color: var(--header-step-text-color);\n    line-height: 20px;\n    position: relative;\n    display: inline-block;\n\n    svg {\n      margin-top: -2px;\n      margin-left: -2px;\n    }\n\n    &:after {\n      content: '';\n      height: 2px;\n      background: var(--header-step-lint-color);\n      position: absolute;\n      right: -10px;\n      top: 10px;\n      width: 8px;\n    }\n\n    &:last-child {\n      &:after {\n        opacity: 0;\n      }\n    }\n  "], ["\n    font-size: 12px;\n    width: 24px;\n    height: 24px;\n    margin-left: 8px;\n    border: 2px solid var(--header-step-border-color);\n    text-align: center;\n    background: ", ";\n    border-radius: 50%;\n    color: var(--header-step-text-color);\n    line-height: 20px;\n    position: relative;\n    display: inline-block;\n\n    svg {\n      margin-top: -2px;\n      margin-left: -2px;\n    }\n\n    &:after {\n      content: '';\n      height: 2px;\n      background: var(--header-step-lint-color);\n      position: absolute;\n      right: -10px;\n      top: 10px;\n      width: 8px;\n    }\n\n    &:last-child {\n      &:after {\n        opacity: 0;\n      }\n    }\n  "])), t ? "var(--header-current-step-background-color)" : "var(--header-step-background-color)");
}),
    It = h(function (n) {
  var e = n.title,
      o = n.steps,
      i = n.children,
      a = n.currentStep,
      c = void 0 === a ? 0 : a,
      d = t(n, ["title", "steps", "children", "currentStep"]),
      s = u(function () {
    return !!o && Array.from({
      length: o
    }, function (n, e) {
      return e + 1;
    });
  }, [o]);
  return l.createElement(Bt, r({}, d), e && l.createElement("h2", null, e), i, s && l.createElement(Rt, {
    "aria-label": "progress",
    "data-steps": o
  }, s.map(function (n) {
    var e = c === n;
    return l.createElement(jt, {
      key: n,
      isCurrentStep: e,
      "aria-current": !!e && "step"
    }, c > n ? l.createElement(ee, {
      name: "success",
      "aria-hidden": "true",
      color: "var(--success500)"
    }) : "" + n);
  })));
}),
    Wt = v.div(vt || (vt = e(["\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  background-color: ", ";\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  z-index: 100;\n"], ["\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  background-color: ", ";\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  z-index: 100;\n"])), function (n) {
  return n.transparent ? "transparent" : "rgba(0, 0, 0, 0.15)";
}),
    St = x(xt || (xt = e(["\n  0% {\n    margin-left: -10px;\n  }\n  12% {\n    margin-left: 20px;\n  }\n  25% {\n    margin-left: -40px;\n  }\n  50% {\n    margin-left: 40px;\n  }\n  62%{\n    margin-left: -40px;\n  }\n  75% {\n    margin-left: -20px;\n  }\n  87%{\n    margin-left: 20px;\n  }\n  100% {\n    margin-left: -10px;\n  }\n"], ["\n  0% {\n    margin-left: -10px;\n  }\n  12% {\n    margin-left: 20px;\n  }\n  25% {\n    margin-left: -40px;\n  }\n  50% {\n    margin-left: 40px;\n  }\n  62%{\n    margin-left: -40px;\n  }\n  75% {\n    margin-left: -20px;\n  }\n  87%{\n    margin-left: 20px;\n  }\n  100% {\n    margin-left: -10px;\n  }\n"]))),
    Dt = v.div(Ct || (Ct = e(["\n  position: relative;\n  background: white;\n  border-radius: 7px;\n  display: flex;\n  flex-direction: column;\n  max-width: min(500px, 95vw);\n  width: 250px;\n  max-height: 95vh;\n  padding: 1rem;\n  box-shadow: 0 1px 3px var(--gray300);\n\n  ", "\n"], ["\n  position: relative;\n  background: white;\n  border-radius: 7px;\n  display: flex;\n  flex-direction: column;\n  max-width: min(500px, 95vw);\n  width: 250px;\n  max-height: 95vh;\n  padding: 1rem;\n  box-shadow: 0 1px 3px var(--gray300);\n\n  ", "\n"])), function (n) {
  return n.shakeWarning && b(bt || (bt = e(["\n      animation: ", " 0.6s cubic-bezier(0, 0.28, 0.99, 0.72);\n    "], ["\n      animation: ", " 0.6s cubic-bezier(0, 0.28, 0.99, 0.72);\n    "])), St);
}),
    At = v.button(wt || (wt = e(["\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  border-radius: 50%;\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  border-radius: 50%;\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]))),
    Tt = v.h3(kt || (kt = e(["\n  color: var(--primary500);\n"], ["\n  color: var(--primary500);\n"]))),
    Pt = v.div(Lt || (Lt = e(["\n  padding: 1rem 0;\n"], ["\n  padding: 1rem 0;\n"]))),
    Yt = v.div(yt || (yt = e(["\n  padding: 0 0 1rem;\n  border-bottom: 1px solid var(--gray100);\n"], ["\n  padding: 0 0 1rem;\n  border-bottom: 1px solid var(--gray100);\n"]))),
    _t = v.div(Mt || (Mt = e(["\n  padding: 1rem 0 0;\n  border-top: 1px solid var(--gray100);\n"], ["\n  padding: 1rem 0 0;\n  border-top: 1px solid var(--gray100);\n"]))),
    Ft = v.div(Et || (Et = e(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n"]))),
    Nt = v.div(Zt || (Zt = e(["\n  width: 1rem;\n"], ["\n  width: 1rem;\n"]))),
    Ot = function Ot(e) {
  var t = e.visible,
      o = e.title,
      i = e.header,
      a = e.footer,
      d = e.children,
      s = e.onClose,
      h = e.onClickOutside,
      p = e.noBackdrop,
      u = void 0 !== p && p,
      g = e.width,
      f = void 0 === g ? 250 : g,
      m = e.style,
      v = void 0 === m ? {} : m,
      x = e.portalSelector,
      b = void 0 === x ? "body" : x,
      C = ln(),
      w = n(c(!1), 2),
      k = w[0],
      L = w[1];
  console.log("onclose:", s);
  if (!C) return null;
  var y = document.querySelector(b);
  return t && y ? Z(l.createElement(Wt, {
    "data-testid": "modal-backdrop",
    onClick: function onClick(n) {
      n.target === n.currentTarget && (h ? h() : (L(!0), setTimeout(function () {
        return L(!1);
      }, 700)));
    },
    transparent: u
  }, l.createElement(Dt, {
    role: "dialog",
    "aria-modal": "true",
    "data-testid": "modal-main-container",
    shakeWarning: k,
    style: r({
      width: f
    }, v)
  }, !i && o && l.createElement(Yt, {
    "data-testid": "modal-header"
  }, l.createElement(Tt, {
    "data-testid": "modal-title"
  }, o)), i && l.createElement(Yt, {
    "data-testid": "modal-header"
  }, i), l.createElement(Pt, {
    "data-testid": "modal-body"
  }, d), a && l.createElement(_t, {
    "data-testid": "modal-footer"
  }, a), s && l.createElement(At, {
    onClick: s,
    "data-testid": "modal-close-btn"
  }, l.createElement(ee, {
    name: "close",
    width: 16,
    height: 16
  })))), y) : null;
},
    Xt = function Xt(n) {
  var e = n.onPrimary,
      o = n.primaryButtonLabel,
      i = void 0 === o ? "Entendi" : o,
      a = n.primaryButtonDisabled,
      c = void 0 !== a && a,
      d = n.primaryActionProcessing,
      s = void 0 !== d && d,
      h = n.children,
      p = t(n, ["onPrimary", "primaryButtonLabel", "primaryButtonDisabled", "primaryActionProcessing", "children"]),
      u = l.createElement(Ft, null, l.createElement(Vn, {
    name: "primary",
    variant: "primary",
    isLoading: s,
    disabled: c || s,
    onClick: e
  }, i));
  return l.createElement(Ot, r({}, p, {
    footer: u
  }), h);
},
    Gt = function Gt(n) {
  var e = n.secondaryButtonLabel,
      o = void 0 === e ? "Cancelar" : e,
      i = n.secondaryButtonDisabled,
      a = void 0 !== i && i,
      c = n.secondaryActionProcessing,
      d = void 0 !== c && c,
      s = n.onPrimary,
      h = n.onSecondary,
      p = n.primaryButtonLabel,
      u = void 0 === p ? "Confirmar" : p,
      g = n.primaryButtonDisabled,
      f = void 0 !== g && g,
      m = n.primaryActionProcessing,
      v = void 0 !== m && m,
      x = n.processing,
      b = void 0 !== x && x,
      C = n.children,
      w = t(n, ["secondaryButtonLabel", "secondaryButtonDisabled", "secondaryActionProcessing", "onPrimary", "onSecondary", "primaryButtonLabel", "primaryButtonDisabled", "primaryActionProcessing", "processing", "children"]),
      k = l.createElement(Ft, null, l.createElement(Vn, {
    name: "secondary-button",
    variant: "secondary",
    isLoading: d || b,
    disabled: a || d || v || b,
    onClick: h
  }, o), l.createElement(Nt, null), l.createElement(Vn, {
    name: "primary-button",
    variant: "primary",
    isLoading: v || b,
    disabled: f || v || d || b,
    onClick: s
  }, u));
  return l.createElement(Ot, r({
    footer: k
  }, w), C);
},
    Jt = v.div(qt || (qt = e(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"]))),
    Ut = v.div($t || ($t = e(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: 1rem 0;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: 1rem 0;\n"]))),
    Kt = v.input(Qt || (Qt = e(["\n  background: var(--gray100);\n  border-radius: 4px;\n  font-size: 2rem;\n  width: 38px;\n  height: 42px;\n  line-height: 45px;\n  color: var(--gray500);\n  text-align: center;\n  border: 1px solid transparent;\n\n  ", "\n\n  box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.15);\n\n  &:focus {\n    box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.25);\n  }\n"], ["\n  background: var(--gray100);\n  border-radius: 4px;\n  font-size: 2rem;\n  width: 38px;\n  height: 42px;\n  line-height: 45px;\n  color: var(--gray500);\n  text-align: center;\n  border: 1px solid transparent;\n\n  ", "\n\n  box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.15);\n\n  &:focus {\n    box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.25);\n  }\n"])), function (n) {
  return n.invalid && "\n    color: var(--error500);\n    background: var(--error100);\n  ";
});

v.div(nr || (nr = e(["\n  width: 0.4rem;\n"], ["\n  width: 0.4rem;\n"])));

var qt,
    $t,
    Qt,
    nr,
    er,
    tr,
    rr,
    or,
    ir,
    ar,
    lr,
    cr,
    dr = v.div(er || (er = e(["\n  text-align: center;\n"], ["\n  text-align: center;\n"]))),
    sr = v.button(tr || (tr = e(["\n  background: transparent;\n  border: none;\n  color: var(--primary500);\n  font-size: 1rem;\n  cursor: pointer;\n\n  &:disabled {\n    color: var(--primary300);\n    cursor: no-drop;\n  }\n"], ["\n  background: transparent;\n  border: none;\n  color: var(--primary500);\n  font-size: 1rem;\n  cursor: pointer;\n\n  &:disabled {\n    color: var(--primary300);\n    cursor: no-drop;\n  }\n"]))),
    hr = v.div(rr || (rr = e(["\n  display: flex;\n  flex-direction: row;\n  color: var(--primary500);\n  h3 {\n    margin-left: 0.5rem;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  color: var(--primary500);\n  h3 {\n    margin-left: 0.5rem;\n  }\n"]))),
    pr = v.div(or || (or = e(["\n  text-align: center;\n  padding: 2.2rem 0;\n"], ["\n  text-align: center;\n  padding: 2.2rem 0;\n"]))),
    ur = v.div(ir || (ir = e(["\n  text-align: center;\n  font-size: 1rem;\n  font-weight: bold;\n  color: var(--success500);\n"], ["\n  text-align: center;\n  font-size: 1rem;\n  font-weight: bold;\n  color: var(--success500);\n"]))),
    gr = v.div(ar || (ar = e(["\n  text-align: center;\n  color: red;\n  font-size: 1rem;\n  font-weight: bold;\n"], ["\n  text-align: center;\n  color: red;\n  font-size: 1rem;\n  font-weight: bold;\n"]))),
    fr = v.div(lr || (lr = e(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  color: var(--gray300);\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  color: var(--gray300);\n"]))),
    mr = v.div(cr || (cr = e(["\n  text-align: center;\n"], ["\n  text-align: center;\n"]))),
    vr = function vr(e) {
  var t = e.disabled,
      r = e.error,
      i = e.onChange,
      a = n(c(["", "", "", "", "", ""]), 2),
      d = a[0],
      h = a[1],
      p = [g(), g(), g(), g(), g(), g()],
      u = function u(n) {
    var e,
        t,
        r,
        a = n.target.value,
        l = parseInt(n.target.name, 10),
        c = o(d);
    (a = a.replace(/\D/g, "")).length > 1 && (a = a[a.length - 1]), a && (l < 5 ? null === (t = null === (e = p[l + 1]) || void 0 === e ? void 0 : e.current) || void 0 === t || t.focus() : null === (r = p[l].current) || void 0 === r || r.blur()), c[l] = a, h(c), i(c.join(""));
  },
      f = function f(n) {
    var e,
        t,
        r = parseInt(n.target.name, 10);
    d[r] || 8 !== n.keyCode || null === (t = null === (e = p[r - 1]) || void 0 === e ? void 0 : e.current) || void 0 === t || t.focus();
  };

  return s(function () {
    var n;
    t || null === (n = p[0].current) || void 0 === n || n.focus();
  }, [t]), l.createElement(Ut, null, p.map(function (n, e) {
    var o = e + "-" + d[e];
    return l.createElement(Kt, {
      key: o,
      type: "text",
      name: "" + e,
      value: d[e],
      ref: n,
      onChange: u,
      placeholder: "_",
      invalid: r,
      disabled: t,
      onKeyDown: f
    });
  }));
},
    xr = {
  pj: {
    uat: "https://cdpj-api.uatbi.com.br/autenticacao/v2/token",
    prd: "https://cdpj-api.bancointer.com.br/autenticacao/v2/token"
  },
  pf: {
    uat: "https://cdpj-api.uatbi.com.br/autenticacao/v2/token",
    prd: "https://cdpj-api.bancointer.com.br/autenticacao/v2/token"
  }
},
    br = function br(n, e, t, r) {
  return i(void 0, void 0, void 0, function () {
    var o, i;
    return a(this, function (a) {
      switch (a.label) {
        case 0:
          return [4, fetch(xr[n][t], {
            method: "POST",
            headers: {
              "Content-Type": "x-inter-conta-corrente",
              authorization: "bearer " + r.replace("bearer ", ""),
              "x-inter-origem": "IBPJ"
            },
            body: JSON.stringify({
              origem: "WEB",
              transactionId: e,
              comunicationsType: ["EMAIL", "SMS"]
            })
          })];

        case 1:
          return [4, (o = a.sent()).json()];

        case 2:
          if (i = a.sent(), 200 === o.status) return [2, i.communicationType];
          throw new Error("Falha ao solicitar token para o usuário: Erro " + o.status);
      }
    });
  });
},
    Cr = function Cr(e) {
  var t = e.visible,
      r = e.processing,
      o = e.bearerToken,
      h = e.clientType,
      g = e.transactionType,
      f = e.env,
      m = e.invalidToken,
      v = e.onInput,
      x = e.onToken,
      b = e.onAbort,
      C = e.noBackdrop,
      w = void 0 !== C && C,
      k = e.resendTimeout,
      L = void 0 === k ? 30 : k,
      y = p(""),
      M = n(c(""), 2),
      E = M[0],
      Z = M[1],
      V = n(c(!1), 2),
      H = V[0],
      z = V[1],
      B = n(c(!1), 2),
      R = B[0],
      j = B[1],
      I = n(c(!0), 2),
      W = I[0],
      S = I[1],
      D = n(c(L), 2),
      A = D[0],
      T = D[1],
      P = d(function (n) {
    return i(void 0, void 0, void 0, function () {
      var e;
      return a(this, function (t) {
        switch (t.label) {
          case 0:
            return T(L), n ? j(!0) : S(!0), [4, br(h, g, f, o)];

          case 1:
            return e = t.sent(), Z(e), n ? j(!1) : S(!1), n && z(!0), y.current = "", [2];
        }
      });
    });
  }, [o, f, L, g, h]),
      Y = u(function () {
    return E && function (n) {
      switch (n) {
        case "SMS":
          return "Informe o código de 6 dígitos enviados para o seu celular";

        case "EMAIL":
          return "Informe o código de 6 dígitos enviados para o seu e-mail";

        case "EMAIL_SMS":
          return "Informe o código de 6 dígitos enviados para o seu celular e e-mail";

        case "ISAFE":
          return "Informe o código de 6 dígitos gerados no seu aplicativo";

        default:
          throw new Error("Unexpected communication type: " + n);
      }
    }(E);
  }, [E]);
  s(function () {
    var n;
    return A > 0 && (n = window.setTimeout(function () {
      return T(A - 1);
    }, 1e3)), function () {
      window.clearTimeout(n);
    };
  }, [A]), s(function () {
    var n;
    return H && (n = window.setTimeout(function () {
      return z(!1);
    }, 5e3)), function () {
      window.clearTimeout(n);
    };
  }, [H]), s(function () {
    P(!1);
  }, []);

  var _ = l.createElement(dr, null, !r && H && l.createElement(ur, null, "Código enviado!"), !r && !H && l.createElement(sr, {
    disabled: A > 0 || R || r,
    type: "button",
    onClick: function onClick(n) {
      n.preventDefault(), 0 === A && P(!0);
    }
  }, R ? "Enviando código..." : l.createElement(l.Fragment, null, "Reenviar código ", A > 0 ? "(" + A + "s)" : "")), r && l.createElement(fr, {
    "data-testid": "token-modal-processing-message"
  }, l.createElement(ee, {
    name: "loading",
    size: 20,
    color: "var(--secondary500)"
  }), "processando..."));

  return l.createElement(Ot, {
    visible: t,
    width: 300,
    onClose: b,
    header: l.createElement(hr, null, l.createElement(ee, {
      name: "security",
      color: "var(--primary500)",
      size: 20
    }), l.createElement("h3", null, "Autenticação adicional")),
    footer: _,
    noBackdrop: w
  }, l.createElement(Jt, null, W && l.createElement(pr, null, l.createElement(ee, {
    name: "loading",
    size: 60,
    color: "var(--secondary500)"
  })), !W && l.createElement(l.Fragment, null, l.createElement(mr, {
    "data-testid": "token-modal-instruction"
  }, Y), l.createElement(vr, {
    disabled: r || W,
    error: m,
    onChange: function onChange(n) {
      n.length <= 6 && (v(), y.current = n), 6 === n.length && x(y.current);
    }
  }), !r && m && l.createElement(gr, null, "Token inválido"))));
};

f({});
var wr,
    kr,
    Lr,
    yr,
    Mr,
    Er,
    Zr,
    Vr,
    Hr = x(wr || (wr = e(["\n  0% {\n    transform: scale(.8) translateY(1000px);\n    opacity: 0;\n  }\n\n  100% {\n    transform: scale(1) translateY(0px);\n    opacity: 1;\n  }\n"], ["\n  0% {\n    transform: scale(.8) translateY(1000px);\n    opacity: 0;\n  }\n\n  100% {\n    transform: scale(1) translateY(0px);\n    opacity: 1;\n  }\n"])));
v.div(kr || (kr = e(["\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  z-index: var(--modal-overlay-z-index);\n  background-color: var(--modal-overlay-background-color);\n  transition: all 0.5s ease 0s;\n  justify-content: center;\n  align-items: center;\n\n  & {\n    display: ", ";\n  }\n\n  & > div {\n    animation: ", " 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;\n  }\n"], ["\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  z-index: var(--modal-overlay-z-index);\n  background-color: var(--modal-overlay-background-color);\n  transition: all 0.5s ease 0s;\n  justify-content: center;\n  align-items: center;\n\n  & {\n    display: ", ";\n  }\n\n  & > div {\n    animation: ", " 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;\n  }\n"])), function (n) {
  return n.opened ? "flex" : "none";
}, Hr), v.div(Lr || (Lr = e(["\n  background-color: var(--modal-background-color);\n  border-radius: var(--modal-border-radius);\n  padding: 0 16px;\n  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08);\n  min-width: 400px;\n  position: relative;\n  transition: transform 0.5s;\n"], ["\n  background-color: var(--modal-background-color);\n  border-radius: var(--modal-border-radius);\n  padding: 0 16px;\n  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08);\n  min-width: 400px;\n  position: relative;\n  transition: transform 0.5s;\n"]))), v(ee).attrs({
  name: "close",
  height: 20,
  width: 20
})(yr || (yr = e(["\n  position: absolute;\n  right: 10px;\n  top: 10px;\n"], ["\n  position: absolute;\n  right: 10px;\n  top: 10px;\n"]))), v.div(Mr || (Mr = e(["\n  border-bottom: 1px solid var(--modal-header-border-color);\n  user-select: none;\n"], ["\n  border-bottom: 1px solid var(--modal-header-border-color);\n  user-select: none;\n"]))), v.h1(Er || (Er = e(["\n  color: var(--modal-header-title-text-color);\n  margin-top: 10px;\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 600;\n  font-size: var(--modal-header-title-font-size);\n  line-height: 30px;\n"], ["\n  color: var(--modal-header-title-text-color);\n  margin-top: 10px;\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 600;\n  font-size: var(--modal-header-title-font-size);\n  line-height: 30px;\n"]))), v.div(Zr || (Zr = e(["\n  padding: 20px 0;\n"], ["\n  padding: 20px 0;\n"]))), v.footer(Vr || (Vr = e(["\n  border-top: 1px solid var(--modal-footer-border-color);\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 0;\n"], ["\n  border-top: 1px solid var(--modal-footer-border-color);\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 0;\n"])));

var zr,
    Br,
    Rr,
    jr,
    Ir,
    Wr,
    Sr,
    Dr,
    Ar,
    Tr,
    Pr,
    Yr,
    _r,
    Fr,
    Nr,
    Or,
    Xr,
    Gr,
    Jr,
    Ur,
    Kr,
    qr,
    $r,
    Qr,
    no,
    eo,
    to,
    ro,
    oo,
    io,
    ao,
    lo,
    co,
    so,
    ho,
    po,
    uo,
    go,
    fo,
    mo,
    vo,
    xo,
    bo,
    Co,
    wo,
    ko,
    Lo,
    yo,
    Mo,
    Eo,
    Zo,
    Vo,
    Ho,
    zo,
    Bo,
    Ro,
    jo,
    Io,
    Wo,
    So,
    Do,
    Ao,
    To,
    Po,
    Yo,
    _o,
    Fo,
    No = function No() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
},
    Oo = "opacity: 1;",
    Xo = function Xo(n) {
  return b(zr || (zr = e(["\n    transform: translateX(430px);\n    margin-bottom: ", "px;\n  "], ["\n    transform: translateX(430px);\n    margin-bottom: ", "px;\n  "])), n);
},
    Go = {
  NULL: function NULL() {
    return b(Rr || (Rr = e(["\n    ", "\n  "], ["\n    ", "\n  "])), function () {
      return b(Br || (Br = e(["\n      background-color: var(--notification-null-background-color);\n    "], ["\n      background-color: var(--notification-null-background-color);\n    "])));
    });
  },
  SUCCESS: function SUCCESS() {
    return b(Ir || (Ir = e(["\n    ", "\n  "], ["\n    ", "\n  "])), function () {
      return b(jr || (jr = e(["\n      background-color: var(--notification-success-background-color);\n    "], ["\n      background-color: var(--notification-success-background-color);\n    "])));
    });
  },
  ERROR: function ERROR() {
    return b(Sr || (Sr = e(["\n    ", "\n  "], ["\n    ", "\n  "])), function () {
      return b(Wr || (Wr = e(["\n      background-color: var(--notification-error-background-color);\n    "], ["\n      background-color: var(--notification-error-background-color);\n    "])));
    });
  },
  ALERT: function ALERT() {
    return b(Ar || (Ar = e(["\n    ", "\n  "], ["\n    ", "\n  "])), function () {
      return b(Dr || (Dr = e(["\n      background-color: var(--notification-alert-background-color);\n    "], ["\n      background-color: var(--notification-alert-background-color);\n    "])));
    });
  }
},
    Jo = v.div(Tr || (Tr = e(["\n  position: fixed;\n  right: 10px;\n  top: 10px;\n"], ["\n  position: fixed;\n  right: 10px;\n  top: 10px;\n"]))),
    Uo = v.div(Yr || (Yr = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.type,
      r = n.show,
      o = n.hide,
      i = n.marginBottom;
  return b(Pr || (Pr = e(["\n    position: relative;\n    display: flex;\n    flex-flow: row wrap;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 18px;\n    background-color: var(--notification-container-background-color);\n    box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08);\n    border-radius: var(--notification-container-border-radius);\n    margin-bottom: 10px;\n    width: 420px;\n    min-height: 100px;\n    transition: all ease-in-out 200ms;\n    opacity: 0;\n\n    ", "\n    ", "\n\n    &::after {\n      position: absolute;\n      content: '';\n      background-color: var(--notification-bar-color);\n      ", "\n      width: 8px;\n      height: 60px;\n      left: 0;\n      top: 20px;\n      border-radius: 0px 8px 8px 0px;\n    }\n  "], ["\n    position: relative;\n    display: flex;\n    flex-flow: row wrap;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 18px;\n    background-color: var(--notification-container-background-color);\n    box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08);\n    border-radius: var(--notification-container-border-radius);\n    margin-bottom: 10px;\n    width: 420px;\n    min-height: 100px;\n    transition: all ease-in-out 200ms;\n    opacity: 0;\n\n    ", "\n    ", "\n\n    &::after {\n      position: absolute;\n      content: '';\n      background-color: var(--notification-bar-color);\n      ", "\n      width: 8px;\n      height: 60px;\n      left: 0;\n      top: 20px;\n      border-radius: 0px 8px 8px 0px;\n    }\n  "])), r && Oo, o && Xo(i), Go[t]());
}),
    Ko = v.div(_r || (_r = e(["\n  background-color: var(--notification-icon-color);\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  background-color: var(--notification-icon-color);\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]))),
    qo = v.div(Fr || (Fr = e(["\n  justify-self: flex-end;\n  margin-left: auto;\n"], ["\n  justify-self: flex-end;\n  margin-left: auto;\n"]))),
    $o = v.div(Nr || (Nr = e(["\n  display: flex;\n  flex-flow: column wrap;\n  margin-left: 8px;\n  max-width: 80%;\n"], ["\n  display: flex;\n  flex-flow: column wrap;\n  margin-left: 8px;\n  max-width: 80%;\n"]))),
    Qo = v.div(Or || (Or = e(["\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 600;\n  font-size: var(--notification-title-font-size);\n  line-height: 20px;\n  color: var(--notification-title-text-color);\n  margin-bottom: 4px;\n"], ["\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 600;\n  font-size: var(--notification-title-font-size);\n  line-height: 20px;\n  color: var(--notification-title-text-color);\n  margin-bottom: 4px;\n"]))),
    ni = v.div(Xr || (Xr = e(["\n  font-family: Inter;\n  font-style: normal;\n  font-weight: normal;\n  font-size: var(--notification-content-font-size);\n  line-height: 16px;\n  color: var(--notification-content-text-color);\n"], ["\n  font-family: Inter;\n  font-style: normal;\n  font-weight: normal;\n  font-size: var(--notification-content-font-size);\n  line-height: 16px;\n  color: var(--notification-content-text-color);\n"]))),
    ei = f({}),
    ti = function ti() {
  return m(ei);
},
    ri = function ri(e) {
  var t = e.type,
      o = e.title,
      i = e.content,
      a = e.time,
      h = e.onClick,
      g = e.onRemove,
      f = e.closeNotification,
      m = n(c(!1), 2),
      v = m[0],
      x = m[1],
      b = n(c(!1), 2),
      C = b[0],
      w = b[1],
      k = n(c(0), 2),
      L = k[0],
      y = k[1],
      M = p(0),
      E = p(!1),
      Z = p(null),
      V = u(function () {
    var n = {
      width: 20,
      height: 20
    };
    return {
      NULL: r(r({}, n), {
        name: "rectangle"
      }),
      SUCCESS: r(r({}, n), {
        name: "success",
        color: "#20C05D"
      }),
      ERROR: r(r({}, n), {
        name: "close",
        color: "#EB7000"
      }),
      ALERT: r(r({}, n), {
        name: "warning",
        color: "#FFBA00"
      })
    };
  }, []),
      H = d(function () {
    E.current && (clearTimeout(M.current), x(!1), w(!0), M.current = setTimeout(function () {
      null == g || g(), f();
    }, 200));
  }, [f, g]),
      z = d(function () {
    var n;
    y((null === (n = Z.current) || void 0 === n ? void 0 : n.offsetHeight) || 0), x(!0), M.current = setTimeout(function () {
      H();
    }, a);
  }, [H, a]);
  return s(function () {
    return E.current = !0, a && f && z(), function () {
      E.current = !1;
    };
  }, [f, z, a]), l.createElement(Uo, {
    onClick: h,
    ref: Z,
    type: t,
    show: v,
    hide: C,
    marginBottom: -L,
    role: "dialog"
  }, l.createElement(Ko, null, l.createElement(ee, r({}, V[t]))), l.createElement($o, null, l.createElement(Qo, null, o), l.createElement(ni, null, i)), l.createElement(qo, null, l.createElement(ee, {
    name: "clear",
    onClick: function onClick(n) {
      n.stopPropagation(), H();
    },
    color: "#F5F6FA"
  })));
},
    oi = function oi() {
  var n = ti(),
      e = n.notifications,
      t = n.closeNotification;
  return l.createElement(Jo, null, e.map(function (n) {
    return l.createElement(ri, r({}, n, {
      closeNotification: function closeNotification() {
        return t(n.id);
      },
      key: n.id
    }));
  }));
},
    ii = function ii(e) {
  var t = e.children,
      i = n(c([]), 2),
      a = i[0],
      s = i[1],
      h = d(function (n) {
    s(function (e) {
      return e.filter(function (e) {
        return e.id !== n;
      });
    });
  }, [s]),
      p = d(function () {
    s([]);
  }, [s]),
      u = d(function (n) {
    if (Array.isArray(n)) {
      var e = n.map(function (n) {
        return r(r({}, n), {
          time: n.time || 5e3,
          id: No()
        });
      });
      s(function (n) {
        return o(n, e);
      });
    } else s(function (e) {
      return o(e, [r(r({}, n), {
        id: No(),
        time: n.time || 5e3
      })]);
    });
  }, [s]);
  return l.createElement(ei.Provider, {
    value: {
      closeNotification: h,
      closeAllNotifications: p,
      showNotification: u,
      notifications: a
    }
  }, t, l.createElement(oi, null));
},
    ai = l.createContext(void 0),
    li = "\n    pointer-events: none;\n    opacity: 0.5;\n  ",
    ci = v.input(Gr || (Gr = e(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  margin: 0;\n  cursor: pointer;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  margin: 0;\n  cursor: pointer;\n"]))),
    di = v.label(Jr || (Jr = e(["\n  font-family: Inter;\n  font-size: var(--radio-label-font-size);\n  color: var(--radio-label-text-color);\n  margin: 0 8px 0 12px;\n"], ["\n  font-family: Inter;\n  font-size: var(--radio-label-font-size);\n  color: var(--radio-label-text-color);\n  margin: 0 8px 0 12px;\n"]))),
    si = v.div(Kr || (Kr = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.disabled;
  return b(Ur || (Ur = e(["\n    display: flex;\n    align-items: center;\n    position: relative;\n    height: 40px;\n    padding: 4px 0;\n    box-sizing: border-box;\n    user-select: none;\n    ", "\n  "], ["\n    display: flex;\n    align-items: center;\n    position: relative;\n    height: 40px;\n    padding: 4px 0;\n    box-sizing: border-box;\n    user-select: none;\n    ", "\n  "])), t && li);
}),
    hi = h(function (n) {
  var e = n.id,
      o = n.value,
      i = n.label,
      a = void 0 === i ? "" : i,
      c = n.name,
      d = n.disabled,
      s = void 0 !== d && d,
      h = n.checked,
      p = void 0 !== h && h,
      u = n.onChange,
      g = n.style,
      f = n.className,
      m = n.color,
      v = t(n, ["id", "value", "label", "name", "disabled", "checked", "onChange", "style", "className", "color"]),
      x = l.useContext(ai),
      b = c,
      C = p,
      w = s;
  x && (b = x.name, C = x.value === o, w = Boolean(x.disabled));
  return l.createElement(si, {
    disabled: w,
    style: g,
    className: f
  }, l.createElement(ci, r({}, v, {
    type: "radio",
    id: e,
    value: o,
    name: b,
    disabled: w,
    checked: C,
    onChange: function onChange(n) {
      u && u(n);
    }
  })), C ? l.createElement(ee, {
    name: "radio-on",
    size: 32,
    color: m || "var(--primary500)"
  }) : l.createElement(ee, {
    name: "radio-off",
    size: 32
  }), a && l.createElement(di, {
    htmlFor: e
  }, a));
}),
    pi = h(function (e) {
  var o = e.children,
      i = e.name,
      a = e.disabled,
      d = e.value,
      s = void 0 === d ? "" : d,
      h = e.onChange,
      p = t(e, ["children", "name", "disabled", "value", "onChange"]),
      u = n(c(s), 2),
      g = u[0],
      f = u[1];
  return l.createElement(ai.Provider, {
    value: {
      name: i,
      value: g,
      disabled: a
    }
  }, l.createElement("div", r({}, p, {
    role: "radiogroup",
    onChange: function onChange(n) {
      f(n.target.value), h && h(n);
    }
  }), o));
}),
    ui = v.select($r || ($r = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.hasIconRight,
      r = n.hasIconLeft;
  return b(qr || (qr = e(["\n    border: none;\n    appearance: none;\n    cursor: pointer;\n\n    ", ";\n    ", ";\n  "], ["\n    border: none;\n    appearance: none;\n    cursor: pointer;\n\n    ", ";\n    ", ";\n  "])), tt({
    hasIconRight: t,
    hasIconLeft: r
  }), t && "padding-right: 40px;");
}),
    gi = v(at)(Qr || (Qr = e(["\n  position: absolute;\n  pointer-events: none;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n"], ["\n  position: absolute;\n  pointer-events: none;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n"]))),
    fi = h(l.forwardRef(function (e, o) {
  var i = e.id,
      a = e.disabled,
      d = void 0 !== a && a,
      s = e.error,
      h = void 0 !== s && s,
      p = e.helper,
      u = e.iconLeft,
      g = e.infoText,
      f = e.label,
      m = e.name,
      v = e.success,
      x = void 0 !== v && v,
      b = e.value,
      C = void 0 === b ? "" : b,
      w = e.emptyOptionText,
      k = void 0 === w ? "Selecione" : w,
      L = e.hideEmptyOption,
      y = void 0 !== L && L,
      M = e.options,
      E = e.onChange,
      Z = e.className,
      V = e.style,
      H = t(e, ["id", "disabled", "error", "helper", "iconLeft", "infoText", "label", "name", "success", "value", "emptyOptionText", "hideEmptyOption", "options", "onChange", "className", "style"]),
      z = l.createElement(ee, {
    name: "arrow-down"
  }),
      B = n(c(C), 2),
      R = B[0],
      j = B[1];
  return l.createElement(ct, {
    disabled: d,
    className: Z,
    style: V
  }, l.createElement($e, null, l.createElement(Qe, {
    htmlFor: i,
    error: h,
    success: x,
    disabled: d
  }, f), p && l.createElement("span", null, p)), l.createElement(nt, {
    error: h,
    success: x,
    disabled: d
  }, u && l.createElement(it, null, u), l.createElement(ui, r({
    id: i,
    name: m,
    disabled: d,
    hasIconRight: !0,
    hasIconLeft: Boolean(u),
    value: R,
    onChange: function onChange(n) {
      j(n.target.value), E && E(n);
    },
    ref: o
  }, H), !y && l.createElement("option", {
    value: ""
  }, k), M.map(function (n) {
    return l.createElement("option", {
      value: n.value,
      key: n.value
    }, n.text);
  })), l.createElement(gi, null, z)), g && l.createElement(lt, {
    error: h,
    success: x,
    disabled: d
  }, g));
})),
    mi = x(no || (no = e(["\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 1;\n  }\n"], ["\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 1;\n  }\n"]))),
    vi = x(eo || (eo = e(["\n  0% {\n    transform: translateX(-100%);\n  }\n  50% {\n    transform: translateX(100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n"], ["\n  0% {\n    transform: translateX(-100%);\n  }\n  50% {\n    transform: translateX(100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n"]))),
    xi = {
  wave: function wave() {
    return b(to || (to = e(["\n    overflow: hidden;\n\n    &::after {\n      transform: translateX(-100%);\n      animation: ", " 1.5s linear 0.5s infinite;\n      background: linear-gradient(\n        90deg,\n        transparent,\n        var(--skeleton-animation-highlight),\n        transparent\n      );\n    }\n  "], ["\n    overflow: hidden;\n\n    &::after {\n      transform: translateX(-100%);\n      animation: ", " 1.5s linear 0.5s infinite;\n      background: linear-gradient(\n        90deg,\n        transparent,\n        var(--skeleton-animation-highlight),\n        transparent\n      );\n    }\n  "])), vi);
  },
  pulse: function pulse() {
    return b(ro || (ro = e(["\n    &::after {\n      animation: ", " 1.5s ease-in-out 0.5s infinite;\n      background: var(--skeleton-animation-highlight);\n    }\n  "], ["\n    &::after {\n      animation: ", " 1.5s ease-in-out 0.5s infinite;\n      background: var(--skeleton-animation-highlight);\n    }\n  "])), mi);
  }
},
    bi = {
  circle: function circle(n) {
    var t = n.animation;
    return b(oo || (oo = e(["\n    border-radius: 50%;\n\n    &::after {\n      ", ";\n    }\n  "], ["\n    border-radius: 50%;\n\n    &::after {\n      ", ";\n    }\n  "])), "pulse" === t && "border-radius: 50%");
  },
  rect: function rect() {
    return b(io || (io = e(["\n    border-radius: 0;\n\n    &::after {\n      border-radius: 0;\n    }\n  "], ["\n    border-radius: 0;\n\n    &::after {\n      border-radius: 0;\n    }\n  "])));
  },
  text: function text() {
    return b(ao || (ao = e(["\n    border-radius: var(--skeleton-border-radius);\n\n    &::after {\n      border-radius: var(--skeleton-border-radius);\n    }\n  "], ["\n    border-radius: var(--skeleton-border-radius);\n\n    &::after {\n      border-radius: var(--skeleton-border-radius);\n    }\n  "])));
  }
},
    Ci = v.div(co || (co = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.width,
      r = n.height,
      o = n.animation,
      i = n.variant;
  return b(lo || (lo = e(["\n    position: relative;\n    display: inline-block;\n    width: ", ";\n    height: ", ";\n    background-color: var(--skeleton-background-color);\n    border-radius: var(--skeleton-border-radius);\n    ", ";\n    ", ";\n\n    &::after {\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      content: '';\n      position: absolute;\n    }\n  "], ["\n    position: relative;\n    display: inline-block;\n    width: ", ";\n    height: ", ";\n    background-color: var(--skeleton-background-color);\n    border-radius: var(--skeleton-border-radius);\n    ", ";\n    ", ";\n\n    &::after {\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      content: '';\n      position: absolute;\n    }\n  "])), t, r, "disabled" !== o && xi[o](), bi[i]({
    animation: o
  }));
}),
    wi = h(function (n) {
  var e = n.width,
      o = void 0 === e ? "100%" : e,
      i = n.height,
      a = void 0 === i ? "100%" : i,
      c = n.animation,
      d = void 0 === c ? "wave" : c,
      s = n.variant,
      h = void 0 === s ? "text" : s,
      p = t(n, ["width", "height", "animation", "variant"]);
  return l.createElement(Ci, r({
    width: o,
    height: a,
    animation: d,
    variant: h
  }, p));
}),
    ki = {
  checked: function checked() {
    return b(so || (so = e(["\n    background-color: var(--switch-checked-color);\n    transform: translate(90%, -50%);\n  "], ["\n    background-color: var(--switch-checked-color);\n    transform: translate(90%, -50%);\n  "])));
  }
},
    Li = {
  checked: function checked() {
    return b(ho || (ho = e(["\n    background-color: var(--switch-checked-color);\n    opacity: 0.54;\n  "], ["\n    background-color: var(--switch-checked-color);\n    opacity: 0.54;\n  "])));
  }
},
    yi = v(re)(po || (po = e([""], [""]))),
    Mi = v(oe)(uo || (uo = e([""], [""]))),
    Ei = v.div(go || (go = e(["\n  position: relative;\n  padding: 2px;\n  pointer-events: none;\n"], ["\n  position: relative;\n  padding: 2px;\n  pointer-events: none;\n"]))),
    Zi = v.div(mo || (mo = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.checked;
  return b(fo || (fo = e(["\n    background-color: var(--switch-unchecked-color);\n    border-radius: 60px;\n    width: 34px;\n    height: 14px;\n    pointer-events: none;\n    transition: all ease 0.2s;\n    ", "\n  "], ["\n    background-color: var(--switch-unchecked-color);\n    border-radius: 60px;\n    width: 34px;\n    height: 14px;\n    pointer-events: none;\n    transition: all ease 0.2s;\n    ", "\n  "])), t && Li.checked);
}),
    Vi = v.div(xo || (xo = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.checked;
  return b(vo || (vo = e(["\n    background-color: var(--switch-unchecked-color);\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.24);\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    border-radius: 50%;\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n    transition: all ease 0.2s;\n    pointer-events: none;\n    ", "\n  "], ["\n    background-color: var(--switch-unchecked-color);\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.24);\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    border-radius: 50%;\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n    transition: all ease 0.2s;\n    pointer-events: none;\n    ", "\n  "])), t && ki.checked);
}),
    Hi = v(ie)(bo || (bo = e(["\n  padding: 0;\n  height: 24px;\n"], ["\n  padding: 0;\n  height: 24px;\n"]))),
    zi = h(function (e) {
  var o = e.id,
      i = e.label,
      a = void 0 === i ? "" : i,
      c = e.checked,
      d = e.disabled,
      s = void 0 !== d && d,
      h = e.onChange,
      p = t(e, ["id", "label", "checked", "disabled", "onChange"]),
      u = n(on({
    controlled: c,
    defaultState: !!c
  }), 2),
      g = u[0],
      f = u[1];
  return l.createElement(Hi, {
    disabled: s
  }, l.createElement(yi, r({}, p, {
    type: "checkbox",
    id: o,
    checked: g,
    disabled: s,
    onChange: function onChange(n) {
      h && h(n), f(n.target.checked);
    }
  })), l.createElement(Ei, null, l.createElement(Zi, {
    checked: !!g
  }), l.createElement(Vi, {
    checked: !!g
  })), a && l.createElement(Mi, {
    htmlFor: o
  }, a));
}),
    Bi = function Bi() {
  return b(Co || (Co = e(["\n    font-weight: 600;\n    color: var(--tab-label-selected-text-color);\n  "], ["\n    font-weight: 600;\n    color: var(--tab-label-selected-text-color);\n  "])));
},
    Ri = "opacity: 1;",
    ji = "\n    opacity: 0.5;\n    pointer-events: none;\n  ",
    Ii = v.label(ko || (ko = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.selected;
  return b(wo || (wo = e(["\n    font-family: Inter;\n    font-size: 20px;\n    line-height: 24px;\n    pointer-events: none;\n    color: var(--tab-label-text-color);\n    transition: 100ms ease-in-out;\n    ", "\n  "], ["\n    font-family: Inter;\n    font-size: 20px;\n    line-height: 24px;\n    pointer-events: none;\n    color: var(--tab-label-text-color);\n    transition: 100ms ease-in-out;\n    ", "\n  "])), t && Bi());
}),
    Wi = v.div(yo || (yo = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.selected;
  return b(Lo || (Lo = e(["\n    width: ", ";\n    position: absolute;\n    bottom: 0;\n    opacity: 0;\n    height: 4px;\n    transition: 180ms ease-in-out;\n    background-color: var(--tab-bar-background-color);\n    border-radius: var(--tab-bar-border-radius) var(--tab-bar-border-radius) 0px\n      0px;\n    ", ";\n  "], ["\n    width: ", ";\n    position: absolute;\n    bottom: 0;\n    opacity: 0;\n    height: 4px;\n    transition: 180ms ease-in-out;\n    background-color: var(--tab-bar-background-color);\n    border-radius: var(--tab-bar-border-radius) var(--tab-bar-border-radius) 0px\n      0px;\n    ", ";\n  "])), "calc(100% - 48px)", t && Ri);
}),
    Si = v.div(Eo || (Eo = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.disabled;
  return b(Mo || (Mo = e(["\n    display: inline-block;\n    padding: 24px ", "px 20px;\n    position: relative;\n    cursor: pointer;\n    ", "\n  "], ["\n    display: inline-block;\n    padding: 24px ", "px 20px;\n    position: relative;\n    cursor: pointer;\n    ", "\n  "])), 24, t && ji);
}),
    Di = h(function (n) {
  var e = n.label,
      o = n.value,
      i = n.selected,
      a = void 0 !== i && i,
      c = n.disabled,
      d = void 0 !== c && c,
      s = n.onClick,
      h = t(n, ["label", "value", "selected", "disabled", "onClick"]);
  return l.createElement(Si, r({
    onClick: function onClick() {
      d || a || !s || s(o);
    },
    disabled: d,
    role: "tab"
  }, h), l.createElement(Ii, {
    selected: a
  }, e), l.createElement(Wi, {
    selected: a
  }));
}),
    Ai = v.div(Vo || (Vo = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.maxHeight;
  return b(Zo || (Zo = e(["\n    width: 100%;\n    max-height: ", ";\n    overflow: auto;\n  "], ["\n    width: 100%;\n    max-height: ", ";\n    overflow: auto;\n  "])), t);
}),
    Ti = v.table(Ho || (Ho = e(["\n  display: flex;\n  flex-flow: column nowrap;\n  flex: 1 1 auto;\n"], ["\n  display: flex;\n  flex-flow: column nowrap;\n  flex: 1 1 auto;\n"]))),
    Pi = v.thead(zo || (zo = e(["\n  margin: 0 0 18px;\n  background-color: var(--table-head-background-color);\n  border-radius: var(--table-head-border-radius);\n"], ["\n  margin: 0 0 18px;\n  background-color: var(--table-head-background-color);\n  border-radius: var(--table-head-border-radius);\n"]))),
    Yi = v.tr(Bo || (Bo = e(["\n  width: 100%;\n  display: flex;\n  flex-flow: row nowrap;\n  padding: 0 24px;\n"], ["\n  width: 100%;\n  display: flex;\n  flex-flow: row nowrap;\n  padding: 0 24px;\n"]))),
    _i = v.th(Ro || (Ro = e(["\n  color: var(--table-head-text-color);\n  font-family: Inter;\n  font-size: var(--table-head-font-size);\n  font-weight: 600;\n  line-height: 18px;\n  display: flex;\n  align-items: center;\n  flex-flow: row nowrap;\n  flex-grow: 1;\n  flex-basis: 0;\n  word-break: break-word;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  user-select: none;\n"], ["\n  color: var(--table-head-text-color);\n  font-family: Inter;\n  font-size: var(--table-head-font-size);\n  font-weight: 600;\n  line-height: 18px;\n  display: flex;\n  align-items: center;\n  flex-flow: row nowrap;\n  flex-grow: 1;\n  flex-basis: 0;\n  word-break: break-word;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  user-select: none;\n"]))),
    Fi = v(ee)(Io || (Io = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.direction;
  return b(jo || (jo = e(["\n    transform: ", ";\n    margin-left: 8px;\n  "], ["\n    transform: ", ";\n    margin-left: 8px;\n  "])), "DECREASING" === t ? "rotate(-180deg);" : "none;");
}),
    Ni = v.tbody(Wo || (Wo = e([""], [""]))),
    Oi = v.tr(So || (So = e(["\n  width: 100%;\n  display: flex;\n  flex-flow: row nowrap;\n  background-color: var(--table-body-background-color);\n  padding: 24px;\n  margin-bottom: 8px;\n  border-radius: var(--table-body-border-radius);\n\n  &:nth-of-type(even) {\n    background: rgba(245, 246, 250, 0.5);\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  flex-flow: row nowrap;\n  background-color: var(--table-body-background-color);\n  padding: 24px;\n  margin-bottom: 8px;\n  border-radius: var(--table-body-border-radius);\n\n  &:nth-of-type(even) {\n    background: rgba(245, 246, 250, 0.5);\n  }\n"]))),
    Xi = v.td(Do || (Do = e(["\n  display: flex;\n  align-items: center;\n  flex-flow: row nowrap;\n  flex-grow: 1;\n  flex-basis: 0;\n  word-break: break-word;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 600;\n  font-size: var(--table-body-cell-font-size);\n  line-height: 18px;\n  color: var(--table-body-cell-text-color);\n"], ["\n  display: flex;\n  align-items: center;\n  flex-flow: row nowrap;\n  flex-grow: 1;\n  flex-basis: 0;\n  word-break: break-word;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 600;\n  font-size: var(--table-body-cell-font-size);\n  line-height: 18px;\n  color: var(--table-body-cell-text-color);\n"]))),
    Gi = v(Oi)(To || (To = e(["\n  ", "\n"], ["\n  ", "\n"])), function () {
  return b(Ao || (Ao = e(["\n    background-color: var(--table-user-feedback-background-color);\n  "], ["\n    background-color: var(--table-user-feedback-background-color);\n  "])));
}),
    Ji = v(Xi)(Po || (Po = e(["\n  justify-content: center;\n"], ["\n  justify-content: center;\n"]))),
    Ui = v.span(_o || (_o = e(["\n  ", "\n"], ["\n  ", "\n"])), function () {
  return b(Yo || (Yo = e(["\n    display: flex;\n    justify-content: center;\n    font-family: Inter;\n    font-style: normal;\n    font-weight: 600;\n    font-size: var(--table-error-font-size);\n    line-height: 18px;\n    color: var(--table-error-message-text-color);\n  "], ["\n    display: flex;\n    justify-content: center;\n    font-family: Inter;\n    font-style: normal;\n    font-weight: 600;\n    font-size: var(--table-error-font-size);\n    line-height: 18px;\n    color: var(--table-error-message-text-color);\n  "])));
}),
    Ki = v.span(Fo || (Fo = e(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]))),
    qi = function qi(n) {
  var e = n.visible,
      t = n.isSorted,
      r = n.isSortedDesc;
  return e && t ? l.createElement(Fi, {
    name: "polygon",
    size: 12,
    color: "var(--table-head-arrow-" + (r ? "up" : "down") + ")",
    direction: r ? "DECREASING" : "GROWING"
  }) : null;
},
    $i = function $i(n) {
  var e = n.children;
  return n.visible ? l.createElement(Gi, null, l.createElement(Ji, null, e)) : null;
};

function Qi(n) {
  var e = n.data,
      t = n.columns,
      i = n.isLoading,
      a = void 0 !== i && i,
      c = n.filter,
      d = n.sortBy,
      h = n.emptyDataMessage,
      p = n.hideHeader,
      u = n.maxHeight,
      g = void 0 === u ? "500px" : u,
      f = n.selectionColumn,
      m = n.autoResetGlobalFilter,
      v = void 0 === m || m,
      x = n.manualRowSelectedKey,
      b = void 0 === x ? "isSelected" : x,
      C = n.onRowClick,
      w = n.error,
      k = V({
    columns: t,
    data: e,
    autoResetGlobalFilter: v,
    manualRowSelectedKey: b,
    initialState: {
      sortBy: d || [{
        id: t[0].accessor,
        desc: !1
      }]
    }
  }, H, z, function (n) {
    f && n.visibleColumns.push(function (n) {
      return o("START" === f.position ? [] : n, [f.column], "END" === f.position ? [] : n);
    });
  }),
      L = k.getTableProps,
      y = k.getTableBodyProps,
      M = k.headerGroups,
      E = k.rows,
      Z = k.prepareRow,
      B = k.setGlobalFilter,
      R = function R(n) {
    return function () {
      null == C || C(n);
    };
  },
      j = function j(n) {
    return {
      width: n.width,
      maxWidth: n.maxWidth,
      minWidth: n.minWidth
    };
  };

  return s(function () {
    B(c);
  }, [c, B]), l.createElement(Ai, {
    maxHeight: g
  }, l.createElement(Ti, r({}, L()), !p && l.createElement(Pi, null, M.map(function (n) {
    return l.createElement(Yi, r({}, n.getHeaderGroupProps()), n.headers.map(function (n) {
      return l.createElement(_i, r({}, n.getHeaderProps(function (n) {
        var e = n.getSortByToggleProps();
        return e.style = r(r({}, e.style), j(n)), e;
      }(n))), n.render("Header"), l.createElement(qi, {
        visible: !n.disableSortBy,
        isSorted: n.isSorted,
        isSortedDesc: n.isSortedDesc || !1
      }));
    }));
  })), l.createElement(Ni, r({}, y()), l.createElement($i, {
    visible: !a && !E.length
  }, l.createElement(Ui, null, w || h)), E.map(function (n) {
    return Z(n), l.createElement(Oi, r({}, n.getRowProps(), {
      onClick: R(n.original)
    }), n.cells.map(function (n) {
      return l.createElement(Xi, r({}, n.getCellProps({
        style: j(n.column)
      })), n.value ? l.createElement(Ki, null, n.render("Cell")) : n.render("Cell"));
    }));
  }), l.createElement($i, {
    visible: a
  }, l.createElement(ee, {
    name: "loading",
    color: "var(--orange500)"
  })))));
}

Qi.defaultProps = {
  data: [],
  emptyDataMessage: "Não há dados a serem exibidos"
};

var na,
    ea,
    ta,
    ra,
    oa,
    ia,
    aa,
    la,
    ca,
    da,
    sa,
    ha,
    pa,
    ua,
    ga,
    fa,
    ma,
    va,
    xa,
    ba,
    Ca,
    wa,
    ka,
    La,
    ya,
    Ma,
    Ea,
    Za,
    Va,
    Ha,
    za,
    Ba,
    Ra,
    ja,
    Ia,
    Wa,
    Sa,
    Da,
    Aa,
    Ta,
    Pa = "display: block",
    Ya = v.div(ea || (ea = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.show;
  return b(na || (na = e(["\n    display: none;\n    border-top: 1px solid var(--tab-panel-border-color);\n    ", "\n  "], ["\n    display: none;\n    border-top: 1px solid var(--tab-panel-border-color);\n    ", "\n  "])), t && Pa);
}),
    _a = h(function (n) {
  var e = n.value,
      o = n.index,
      i = n.children,
      a = t(n, ["value", "index", "children"]),
      c = e === o;
  return l.createElement(Ya, r({
    show: c,
    role: "tabpanel"
  }, a), i);
}),
    Fa = v.div(ta || (ta = e(["\n  position: relative;\n  display: inline-block;\n"], ["\n  position: relative;\n  display: inline-block;\n"]))),
    Na = h(function (n) {
  var e = n.value,
      o = n.children,
      i = n.onChange,
      a = t(n, ["value", "children", "onChange"]),
      c = l.Children.map(o, function (n, t) {
    var r;

    if (l.isValidElement(n)) {
      var o = null !== (r = n.props.value) && void 0 !== r ? r : t,
          a = {
        selected: o === e,
        value: o,
        onClick: i
      };
      return l.cloneElement(n, a);
    }

    return n;
  });
  return l.createElement(Fa, r({
    role: "tablist"
  }, a), c);
}),
    Oa = function Oa(n) {
  var t = n.semiBold;
  return b(ra || (ra = e(["\n  font-family: Sora;\n  font-style: normal;\n  font-weight: ", ";\n"], ["\n  font-family: Sora;\n  font-style: normal;\n  font-weight: ", ";\n"])), t ? 600 : "normal");
},
    Xa = function Xa(n) {
  var t = n.bold;
  return b(oa || (oa = e(["\n  font-family: Inter;\n  font-style: normal;\n  font-weight: ", ";\n"], ["\n  font-family: Inter;\n  font-style: normal;\n  font-weight: ", ";\n"])), t ? "bold" : "normal");
},
    Ga = {
  "web-head": function webHead(n) {
    return b(ia || (ia = e(["\n    ", "\n    font-size: 96px;\n    line-height: 121px;\n  "], ["\n    ", "\n    font-size: 96px;\n    line-height: 121px;\n  "])), Oa(n));
  },
  "web-title": function webTitle(n) {
    return b(aa || (aa = e(["\n    ", "\n    font-size: 72px;\n    line-height: 91px;\n  "], ["\n    ", "\n    font-size: 72px;\n    line-height: 91px;\n  "])), Oa(n));
  },
  "web-subtitle": function webSubtitle(n) {
    return b(la || (la = e(["\n    ", "\n    font-size: 64px;\n    line-height: 81px;\n  "], ["\n    ", "\n    font-size: 64px;\n    line-height: 81px;\n  "])), Oa(n));
  },
  "headline-master": function headlineMaster(n) {
    return b(ca || (ca = e(["\n    ", "\n    font-size: 64px;\n    line-height: 81px;\n  "], ["\n    ", "\n    font-size: 64px;\n    line-height: 81px;\n  "])), Oa(n));
  },
  "headline-super": function headlineSuper(n) {
    return b(da || (da = e(["\n    ", "\n    font-size: 40px;\n    line-height: 50px;\n  "], ["\n    ", "\n    font-size: 40px;\n    line-height: 50px;\n  "])), Oa(n));
  },
  "headline-big": function headlineBig(n) {
    return b(sa || (sa = e(["\n    ", "\n    font-size: 32px;\n    line-height: 40px;\n  "], ["\n    ", "\n    font-size: 32px;\n    line-height: 40px;\n  "])), Oa(n));
  },
  "headline-h1": function headlineH1(n) {
    return b(ha || (ha = e(["\n    ", "\n    font-size: 24px;\n    line-height: 30px;\n  "], ["\n    ", "\n    font-size: 24px;\n    line-height: 30px;\n  "])), Oa(n));
  },
  "headline-h2": function headlineH2(n) {
    return b(pa || (pa = e(["\n    ", "\n    font-size: 20px;\n    line-height: 25px;\n  "], ["\n    ", "\n    font-size: 20px;\n    line-height: 25px;\n  "])), Oa(n));
  },
  "headline-h3": function headlineH3(n) {
    return b(ua || (ua = e(["\n    ", "\n    font-size: 16px;\n    line-height: 20px;\n  "], ["\n    ", "\n    font-size: 16px;\n    line-height: 20px;\n  "])), Oa(n));
  },
  "body-1": function body1(n) {
    return b(ga || (ga = e(["\n    ", "\n    font-size: 18px;\n    line-height: 22px;\n  "], ["\n    ", "\n    font-size: 18px;\n    line-height: 22px;\n  "])), Xa(n));
  },
  "body-2": function body2(n) {
    return b(fa || (fa = e(["\n    ", "\n    font-size: 16px;\n    line-height: 19px;\n  "], ["\n    ", "\n    font-size: 16px;\n    line-height: 19px;\n  "])), Xa(n));
  },
  "body-3": function body3(n) {
    return b(ma || (ma = e(["\n    ", "\n    font-size: 14px;\n    line-height: 17px;\n  "], ["\n    ", "\n    font-size: 14px;\n    line-height: 17px;\n  "])), Xa(n));
  },
  "caption-1": function caption1(n) {
    return b(va || (va = e(["\n    ", "\n    font-size: 12px;\n    line-height: 15px;\n  "], ["\n    ", "\n    font-size: 12px;\n    line-height: 15px;\n  "])), Xa(n));
  },
  "caption-2": function caption2(n) {
    return b(xa || (xa = e(["\n    ", "\n    font-size: 10px;\n    line-height: 12px;\n  "], ["\n    ", "\n    font-size: 10px;\n    line-height: 12px;\n  "])), Xa(n));
  }
},
    Ja = v.span(Ca || (Ca = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  return b(ba || (ba = e(["\n    color: ", ";\n    ", "\n  "], ["\n    color: ", ";\n    ", "\n  "])), "var(--" + n.color + n.colorWeight + ")", Ga[n.variant](n));
}),
    Ua = function Ua(n) {
  var e = n.children,
      t = n.childRects,
      r = n.position,
      o = n.onMouseEnter,
      i = n.onMouseLeave,
      a = document.createElement("div"),
      l = d(function (n, e) {
    return {
      "top-start": {
        xAxis: t.left,
        yAxis: t.top - e
      },
      top: {
        xAxis: t.left + t.width / 2 - n / 2,
        yAxis: t.top - e
      },
      "top-end": {
        xAxis: t.left + t.width - n,
        yAxis: t.top - e
      },
      "bottom-start": {
        xAxis: t.left,
        yAxis: t.top + t.height
      },
      bottom: {
        xAxis: t.left + t.width / 2 - n / 2,
        yAxis: t.top + t.height
      },
      "bottom-end": {
        xAxis: t.left + t.width - n,
        yAxis: t.top + t.height
      }
    }[r];
  }, [t, r]);
  return s(function () {
    document.body.appendChild(a);
    var n = l(a.offsetWidth, a.offsetHeight),
        e = "translate3d(" + n.xAxis + "px, " + n.yAxis + "px, 0px)";
    return a.onmouseleave = i || null, a.onmouseover = o || null, a.style.cssText = "position: absolute; top: 0px; left: 0px; transform: " + e + ";", function () {
      document.body.removeChild(a);
    };
  }, [l, a, o, i]), E.createPortal(e, a);
},
    Ka = {
  top: b(wa || (wa = e(["\n    margin-bottom: 8px;\n  "], ["\n    margin-bottom: 8px;\n  "]))),
  bottom: b(ka || (ka = e(["\n    margin-top: 8px;\n  "], ["\n    margin-top: 8px;\n  "])))
},
    qa = {
  "top-start": b(La || (La = e(["\n    left: 20px;\n    bottom: -4px;\n  "], ["\n    left: 20px;\n    bottom: -4px;\n  "]))),
  top: b(ya || (ya = e(["\n    left: 50%;\n    transform: translateX(-50%) rotate(-135deg);\n    bottom: -4px;\n  "], ["\n    left: 50%;\n    transform: translateX(-50%) rotate(-135deg);\n    bottom: -4px;\n  "]))),
  "top-end": b(Ma || (Ma = e(["\n    right: 20px;\n    bottom: -4px;\n  "], ["\n    right: 20px;\n    bottom: -4px;\n  "]))),
  "bottom-start": b(Ea || (Ea = e(["\n    left: 20px;\n    top: -4px;\n  "], ["\n    left: 20px;\n    top: -4px;\n  "]))),
  bottom: b(Za || (Za = e(["\n    left: 50%;\n    transform: translateX(-50%) rotate(-135deg);\n    top: -4px;\n  "], ["\n    left: 50%;\n    transform: translateX(-50%) rotate(-135deg);\n    top: -4px;\n  "]))),
  "bottom-end": b(Va || (Va = e(["\n    right: 20px;\n    top: -4px;\n  "], ["\n    right: 20px;\n    top: -4px;\n  "])))
},
    $a = v.div(za || (za = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.position;
  return b(Ha || (Ha = e(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    position: relative;\n    padding: 16px;\n    background-color: var(--tooltip-content-background-color);\n    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.22);\n    border-radius: var(--tooltip-content-border-radius);\n    max-width: 248px;\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    position: relative;\n    padding: 16px;\n    background-color: var(--tooltip-content-background-color);\n    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.22);\n    border-radius: var(--tooltip-content-border-radius);\n    max-width: 248px;\n    ", "\n  "])), Ka[function (n) {
    return n.position.startsWith("top") ? "top" : "bottom";
  }({
    position: t
  })]);
}),
    Qa = v.span(Ba || (Ba = e(["\n  font-family: Inter;\n  font-size: var(--tooltip-regular-font-size);\n  line-height: 15px;\n"], ["\n  font-family: Inter;\n  font-size: var(--tooltip-regular-font-size);\n  line-height: 15px;\n"]))),
    nl = v(Qa)(Ra || (Ra = e(["\n  font-weight: bold;\n"], ["\n  font-weight: bold;\n"]))),
    el = v(nl)(ja || (ja = e(["\n  color: var(--tooltip-title-text-color);\n  margin-bottom: 4px;\n"], ["\n  color: var(--tooltip-title-text-color);\n  margin-bottom: 4px;\n"]))),
    tl = v(Qa)(Wa || (Wa = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.hasAction;
  return b(Ia || (Ia = e(["\n    color: var(--tooltip-description-text-color);\n    margin-bottom: ", ";\n  "], ["\n    color: var(--tooltip-description-text-color);\n    margin-bottom: ", ";\n  "])), t ? "16px" : "0");
}),
    rl = v(nl)(Sa || (Sa = e(["\n  color: var(--tooltip-action-text-color);\n  margin-left: auto;\n  cursor: pointer;\n"], ["\n  color: var(--tooltip-action-text-color);\n  margin-left: auto;\n  cursor: pointer;\n"]))),
    ol = v.div(Aa || (Aa = e(["\n  ", "\n"], ["\n  ", "\n"])), function (n) {
  var t = n.position,
      r = n.isInteractive;
  return b(Da || (Da = e(["\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    background-color: var(--tooltip-arrow-background-color);\n    border-radius: var(--tooltip-arrow-border-radius);\n    transform: rotate(-135deg);\n    pointer-events: ", ";\n    ", "\n  "], ["\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    background-color: var(--tooltip-arrow-background-color);\n    border-radius: var(--tooltip-arrow-border-radius);\n    transform: rotate(-135deg);\n    pointer-events: ", ";\n    ", "\n  "])), r ? "all" : "none", qa[t]);
}),
    il = v.div(Ta || (Ta = e(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"]))),
    al = h(function (e) {
  var o = e.children,
      i = e.description,
      a = e.title,
      s = void 0 === a ? "" : a,
      h = e.action,
      g = void 0 === h ? "" : h,
      f = e.position,
      m = void 0 === f ? "top" : f,
      v = e.interactive,
      x = void 0 !== v && v,
      b = t(e, ["children", "description", "title", "action", "position", "interactive"]),
      C = p(null),
      w = p(0),
      k = n(c(!1), 2),
      L = k[0],
      y = k[1],
      M = n(c(dn), 2),
      E = M[0],
      Z = M[1],
      V = Boolean(x || g),
      H = d(function () {
    V ? w.current = setTimeout(function () {
      y(!1);
    }) : y(!1);
  }, [V]),
      z = d(function () {
    var n;

    if (clearTimeout(w.current), !L) {
      var e = (null === (n = C.current) || void 0 === n ? void 0 : n.getClientRects()[0]) || dn,
          t = e.top,
          r = e.left,
          o = e.width,
          i = e.height;
      Z({
        top: t,
        left: r,
        width: o,
        height: i
      }), y(!0);
    }
  }, [L]),
      B = u(function () {
    return V ? {
      onMouseEnter: function onMouseEnter() {
        return clearTimeout(w.current);
      },
      onMouseLeave: H
    } : {};
  }, [V, H]);
  return l.createElement(il, r({
    ref: C
  }, b, {
    onMouseOver: z,
    onMouseLeave: H
  }), o, L && l.createElement(Ua, r({
    childRects: E,
    position: m
  }, B), l.createElement($a, {
    position: m
  }, s && l.createElement(el, null, s), l.createElement(tl, {
    hasAction: Boolean(g)
  }, i), g && l.createElement(rl, {
    onClick: H
  }, g), l.createElement(ol, {
    position: m,
    isInteractive: V
  }))));
}),
    ll = v.section(dl || (dl = e(["\n  display: flex;\n  flex-direction: column;\n  min-width: 500px;\n  padding: ", "px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  min-width: 500px;\n  padding: ", "px;\n"])), 20),
    cl = v.div(sl || (sl = e(["\n  display: flex;\n  flex: 1 0 100%;\n  align-items: center;\n  justify-content: center;\n"], ["\n  display: flex;\n  flex: 1 0 100%;\n  align-items: center;\n  justify-content: center;\n"])));

v.div(hl || (hl = e(["\n  display: flex;\n  order: ", ";\n"], ["\n  display: flex;\n  order: ", ";\n"])), function (n) {
  return n.order || 0;
});

var dl,
    sl,
    hl,
    pl,
    ul,
    gl,
    fl,
    ml = v.footer(pl || (pl = e(["\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  height: 100px;\n  position: relative;\n  flex-wrap: wrap;\n  background-color: var(--white100);\n"], ["\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  height: 100px;\n  position: relative;\n  flex-wrap: wrap;\n  background-color: var(--white100);\n"]))),
    vl = v.div(ul || (ul = e(["\n  flex: 1 1 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  + button {\n    margin-right: 8px;\n  }\n"], ["\n  flex: 1 1 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  + button {\n    margin-right: 8px;\n  }\n"]))),
    xl = v.div(gl || (gl = e(["\n  height: 8px;\n  width: 8px;\n  border-radius: 100px;\n  margin-right: 8px;\n  background-color: ", ";\n"], ["\n  height: 8px;\n  width: 8px;\n  border-radius: 100px;\n  margin-right: 8px;\n  background-color: ", ";\n"])), function (n) {
  return n.active ? "var(--wizard-active-background-color)" : "var(--wizard-background-color)";
}),
    bl = h(function (e) {
  var t = e.steps,
      r = e.jumpHandler,
      o = e.finishHandler,
      i = e.buttonAsLink,
      a = e.onStepChange,
      d = n(c(0), 2),
      s = d[0],
      h = d[1],
      p = u(function () {
    return t.map(function (n, e) {
      return l.createElement(xl, {
        "data-id": e,
        onClick: function onClick() {
          return h(e);
        },
        active: t[s].key === n.key,
        key: n.key
      });
    });
  }, [t, s]),
      g = function g(n) {
    a && a(), n();
  };

  return l.createElement(ll, null, l.createElement(cl, null, t[s].component), l.createElement(ml, null, l.createElement(vl, null, p), s > 0 && l.createElement(Vn, {
    fixedWidth: !0,
    onClick: function onClick() {
      return g(function () {
        return h(s - 1);
      });
    },
    variant: i ? "link" : "secondary"
  }, "Anterior"), 0 === s && l.createElement(Vn, {
    fixedWidth: !0,
    onClick: r,
    variant: i ? "link" : "secondary"
  }, "Pular"), s < t.length - 1 && l.createElement(Vn, {
    fixedWidth: !0,
    onClick: function onClick() {
      return g(function () {
        return h(s + 1);
      });
    },
    variant: i ? "link" : "primary"
  }, "Próximo"), s === t.length - 1 && l.createElement(Vn, {
    fixedWidth: !0,
    onClick: o || cn,
    variant: i ? "link" : "primary"
  }, "Finalizar")));
}),
    Cl = function Cl(n, e) {
  if (o(e.matchAll(/#/g)).length !== n.length) return n;
  var t = 0;
  return e.replace(/#/g, function () {
    return n[(t += 1) - 1];
  });
},
    wl = function wl(n) {
  return Cl(n, "(##) #####-####");
},
    kl = function kl(n) {
  return Cl(n, "###.###.###-##");
},
    Ll = function Ll(n) {
  return Cl(n.replace(/-/g, ""), "##/##/####");
};

!function (n) {
  n.PJ = "pj", n.PF = "pf", n.WM = "wm", n.ID = "id";
}(fl || (fl = {}));

var yl = function yl(n) {
  document.documentElement.setAttribute("theme", n);
},
    Ml = function Ml(n) {
  void 0 === n && (n = fl.PF), yl(n);
};

export { gn as Accordion, Xt as AlertModal, Ot as BaseModal, Ln as BottomSheet, Vn as Button, ae as Checkbox, Gt as ConfirmationModal, ce as ContainerBox, Vt as DatePicker, zt as Footer, It as Header, ee as Icon, ne as IconList, ht as Input, ii as NotificationProvider, hi as Radio, pi as RadioGroup, fi as SelectNative, wi as Skeleton, zi as Switch, Di as Tab, _a as TabPanel, Qi as Table, Na as Tabs, Ja as Text, fl as Theme, Cr as TokenModal, al as Tooltip, bl as Wizard, de as addLeadingZeros, wl as cellphonePattern, yl as changeTheme, kl as cpfPattern, Ll as datePattern, se as dateToObject, Cl as formatToPattern, Ml as initTheme, on as useControlled, ln as useDomReady, ti as useNotification, an as useOutsideClick, No as uuid };